{
  "accept_invite": {
    "back_to_home": "Terug naar start",
    "choose_password": "Kies een wachtwoord",
    "heading": "Uitnodiging accepteren",
    "loading": "Laden",
    "save_button": "Uitnodiging accepteren",
    "text": "Je bent uitgenodigd om lid te worden van een organisatie. Kies een wachtwoord om door te gaan."
  },
  "automation": {
    "audience": "Dit publiek heeft momenteel één actieve medewerker | Dit publiek heeft momenteel {count} actieve medewerkers",
    "automation_updated": "Automatisering bijgewerkt",
    "delete": {
      "are_you_sure": "Weet je zeker dat je deze automatisering wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      "automation_deleted": "Automatisering verwijderd",
      "button": "Verwijderen"
    },
    "details": {
      "heading": "Details",
      "text": "Automatiseringsdetails"
    },
    "edit": {
      "subtitle": "Bouw je automatiseringsflow door acties toe te voegen",
      "title": "Acties"
    },
    "edit_automation": "Instellingen bewerken",
    "employee_already_enrolled": "Deze medewerker is al ingeschreven",
    "enroll_employees": "Medewerkers inschrijven",
    "enrolled_employees": "Groep bijgewerkt",
    "flow": {
      "actions": {
        "assign_lesson": {
          "custom_label": "Aangepast"
        },
        "assign_quiz": {
          "custom_help": "Wanneer dit is uitgeschakeld, kiest Moxso Intelligence de meest relevante training op basis van het risicoprofiel van de medewerker.",
          "custom_label": "Aangepaste beoordeling",
          "risk_categories": "Risicocategorieën"
        },
        "delete": {
          "button": "Actie verwijderen",
          "text": "Weet je zeker dat je deze actie wilt verwijderen?"
        },
        "editing": {
          "add_tag_action": "Tag toevoegen",
          "assign_course_action": "Cursus toewijzen",
          "assign_lesson_action": "Les toewijzen",
          "assign_quiz_action": "Beoordeling toewijzen",
          "assign_video_action": "Video toewijzen",
          "halt_action": "Automatisering onderbreken",
          "remove_tag_action": "Tag verwijderen",
          "wait_action": "Wachten gedurende een periode"
        },
        "preview": "Toon activiteit",
        "repeat_enabled": "Deze automatiseringsflow wordt herhaald voor elke medewerker.",
        "status": {
          "active": "Actief: {count}",
          "completed": "Voltooid: {count}",
          "halted": "Gestopt: {count}"
        },
        "step": "Stap {step}",
        "wait_units": {
          "days": "Dag | Dagen",
          "months": "Maand | Maanden",
          "weeks": "Week | Weken"
        }
      },
      "edit": "Bewerken",
      "length": "Lengte",
      "save_step": "Stap opslaan",
      "title": {
        "preview": {
          "assign_lesson_action": {
            "text": "Moxso AI zal automatisch de beste les toewijzen aan elke medewerker op basis van hun vaardigheidsniveau en leerstijl.",
            "title": "Gebruik Moxso AI om een les toe te wijzen"
          },
          "halt_action": {
            "text": "De automatisering wordt onderbroken voor de medewerker die deze stap bereikt.",
            "title": "Automatisering stoppen"
          }
        },
        "wait_action": "Wacht gedurende {duration} {unit}"
      },
      "unit": "Eenheid"
    },
    "form_new_automation": {
      "button": "Trainingsreeks maken",
      "group": "Groep",
      "group_placeholder": "Kies groep",
      "name": "Naam",
      "template": {
        "label": "Sjabloon",
        "placeholder": "Selecteer sjabloon"
      },
      "title": "Trainingsreeks maken"
    },
    "funnel": {
      "button": "Automatisering bewerken",
      "start": "Start",
      "title": "Trechteroverzicht"
    },
    "hide_advanced_settings": "Geavanceerde instellingen verbergen",
    "notification_frequency": "Meldingsfrequentie",
    "notifications": "Meldingen",
    "notifications_active": "Actief",
    "notifications_inactive": "Inactief",
    "participants": {
      "filter": {
        "status": {
          "active": "Actief ({count})",
          "all": "Alle ({count})",
          "completed": "Voltooid ({count})",
          "halted": "Onderbroken ({count})"
        }
      },
      "heading": "Deelnemers",
      "statistics": {
        "participant_coverage": "Deelnamegraad",
        "participant_coverage_text": "Berekende score op basis van het percentage medewerkers dat aan deze oefening deelneemt."
      },
      "text": "Deelname-statistieken"
    },
    "pause": "Pauzeren",
    "play": "Activeren",
    "search": {
      "placeholder": "Zoek alle medewerkers",
      "results": "Zoekresultaten voor: {query}"
    },
    "sequence": {
      "subtitle": "Automatiseringsflow",
      "title": "Automatisering"
    },
    "settings": {
      "create_segment": "Groep aanmaken aan",
      "help": {
        "content_skipping_enabled": "Sta medewerkers toe stappen van de automatisering over te slaan als hun vaardigheidsniveau voldoende is.",
        "notification_flow_enabled": "Automatische meldingen inschakelen voor medewerkers die hun training nog niet hebben voltooid.",
        "notification_past_deadline_enabled": "Verstuur wekelijks meldingen gedurende een maand na het missen van een deadline.",
        "notification_prelude_enabled": "Stuur een melding naar medewerkers wanneer een nieuwe beoordeling aan hen wordt toegewezen.",
        "relative_deadlines_enabled": "Eén medewerker zal niet verdergaan binnen de flow totdat de voorafgaande deadline is gehaald.",
        "relative_progression_enabled": "Eén medewerker zal binnen de flow vooruitgang boeken, ongeacht of de vorige les is voltooid.",
        "repeat_enabled": "Sta medewerkers toe om meer dan één keer door de automatisering te gaan.",
        "repeat_only_after_halt": "Alleen herhalen wanneer medewerker werd gestopt",
        "repeatable_assignments_enabled": "Eén medewerker kan lessen toegewezen krijgen die al zijn voltooid.",
        "segment": "Beperk de automatiseringsflow tot een specifiek groep.",
        "trigger": "Kies de trigger voor deze automatiseringsworkflow."
      },
      "labels": {
        "content_skipping_enabled": "Inhoud overslaan",
        "date": "Datum",
        "group": "Groep",
        "name": "Naam",
        "notification_flow_enabled": "Schakel meldingsstroom in",
        "notification_frequency": "Meldingsfrequentie",
        "notification_past_deadline_enabled": "Herinneringen na de deadline inschakelen",
        "notification_prelude_enabled": "Inschakelen prelude melding",
        "relative_deadlines_enabled": "Relatieve deadlines inschakelen",
        "relative_progression_enabled": "Relatieve voortgang inschakelen",
        "repeat_enabled": "Automatiseringsflow herhalen",
        "repeat_only_after_halt": "Herhaal alleen na stilstand",
        "repeatable_assignments_enabled": "Herhaalbare toewijzingen inschakelen",
        "segment": "Groep",
        "tag": "Label",
        "trigger": "Trigger",
        "use_segment": "Groep gebruiken"
      },
      "no_segment_found": "Geen groepen gevonden voor deze groep",
      "not_editable_text": "Pauzeren je automatisering om de instellingen te bewerken",
      "not_editable_title": "Automatisering is momenteel actief",
      "placeholder": {
        "course": "Cursus selecteren",
        "date": "Kies datum",
        "lesson": "Les selecteren",
        "segment": "Kies groep",
        "tag": "Kies tag",
        "video": "Video selecteren"
      },
      "repeatable_assignments_enabled": "Aangezien je hebt gekozen dat een medewerker oefeningen kan krijgen die ze al eerder hebben voltooid, moet de volgorde relatieve deadlines volgen.",
      "save_settings": "Instellingen opslaan",
      "settings_saved": "Instellingen opgeslagen"
    },
    "show_advanced_settings": "Geavanceerde instellingen weergeven"
  },
  "billing": {
    "missing_payment_banner": "Actie vereist: ontbrekende betaling"
  },
  "breaches": {
    "breached_accounts": "Geschonden Accounts",
    "compromised_info": "Kompromitteerde info",
    "data_types": "Typen gegevens in dit lek",
    "date": "Inbreukdatum",
    "disabled": {
      "button": "Ga naar instellingen",
      "heading": "Datalekken zijn uitgeschakeld",
      "text": "Waarschuw je medewerkers onmiddellijk als zij betrokken zijn geweest bij een datalek, zodat zij snel kunnen handelen om gevoelige informatie te beschermen en risico's te minimaliseren, terwijl je een volledig overzicht krijgt van alle datalekken die je team beïnvloeden voor beter beveiligingsbeheer en snelle respons."
    },
    "high": "Hoog",
    "medium": "Middelgroot",
    "untitled_data_breach": "Naamloos datalek"
  },
  "buttons": {
    "back": "Terug",
    "cancel": "Annuleren",
    "copy": "Kopiëren",
    "delete": "Verwijderen",
    "download_csv": "CSV downloaden",
    "download_pdf": "PDF downloaden",
    "view_details": "Details bekijken"
  },
  "charts": {
    "donut": {
      "amount_share": "Aantal / Aandeel",
      "category": "Categorie"
    },
    "resilience": {
      "score": "Score"
    }
  },
  "competency_profile": {
    "current_level": "Huidig niveau",
    "target_level": "Doelniveau",
    "thresholds_info_text": "De drempels zijn afgestemd op de rol van elke medewerker en hun huidige vaardigheidsniveau.",
    "title": "Competentieprofiel"
  },
  "demo_data": {
    "automations": {
      "onboarding_new_employees": "Onboarding - Nieuwe medewerkers",
      "security_awareness_essentials_training": "Grundlagen der Cybersicherheit",
      "upskilling_all_employees": "Bijscholing - Alle medewerkers"
    },
    "campaign_templates": {
      "templates": {
        "annual_benefits_enrollment_deadline": {
          "html": "<p>Hallo <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>Dit is een vriendelijke herinnering dat de jaarlijkse aanmeldperiode voor arbeidsvoorwaarden voor medewerkers van <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span> bijna afloopt. Je hebt tot en met <strong>vrijdag 15 september</strong> om je keuzes voor het komende jaar te maken.</p><p><strong>Belangrijke wijzigingen dit jaar:</strong></p><ul><li>Nieuwe zorgverzekeringsopties met betere dekking</li><li>Verhoogde werkgeversbijdrage voor pensioen tot 6%</li><li>Verbeterde tandarts- en oogzorgregelingen</li><li>Nieuwe limieten voor flexibele uitgavenrekeningen</li></ul><p>Als je je aanmelding niet op tijd voltooit, word je automatisch ingeschreven in het basisplan, dat mogelijk niet aansluit bij je huidige behoeften.</p><p>Bekijk je opties en maak je keuzes via ons beveiligde portaal voor arbeidsvoorwaarden:</p><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Voltooi aanmelding arbeidsvoorwaarden</a></strong></u></p><p>Als je vragen hebt over je opties, neem dan gerust contact op met ons HR-team.</p><p>Dank je wel,<br/><strong>HR-afdeling</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Actie vereist: Deadline jaarlijkse aanmelding arbeidsvoorwaarden"
        },
        "security_breach_immediate_action": {
          "html": "<p>Beste <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>We hebben verdachte activiteit op je account binnen <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span> gedetecteerd die onmiddellijke aandacht vereist. Onze beveiligingssystemen hebben meerdere ongeautoriseerde inlogpogingen vanaf een onbekend apparaat gemarkeerd.</p><p>Om je account en bedrijfsgegevens te beschermen, hebben we de toegang tot je account tijdelijk beperkt. Je moet je identiteit verifiëren en je inloggegevens binnen 24 uur resetten om permanente schorsing te voorkomen.</p><p><strong>Wat je moet doen:</strong></p><ol><li>Klik op de beveiligde verificatielink hieronder</li><li>Bevestig je identiteit met multi-factor-authenticatie</li><li>Werk je wachtwoord onmiddellijk bij</li></ol><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Verifieer accountbeveiliging nu</a></strong></u></p><p>Als je dit verificatieproces niet binnen 24 uur voltooit, wordt je account om veiligheidsredenen permanent geschorst.</p><p>Met vriendelijke groet,<br/><strong>IT-beveiligingsteam</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Dringend: Beveiligingsinbreuk - onmiddellijke actie vereist"
        },
        "upcoming_organizational_changes": {
          "html": "<p>Beste <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>Ik neem contact met je op om je te informeren over enkele belangrijke aankomende veranderingen binnen <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span>. Door veranderende bedrijfsbehoeften zullen we bepaalde afdelingen herstructureren, en helaas zullen sommige functies komen te vervallen.</p><p>Het is essentieel dat je de gedetailleerde informatie over deze veranderingen zo snel mogelijk bekijkt, zodat je begrijpt hoe dit jou en je team kan beïnvloeden.</p><p>Klik op de onderstaande link om de officiële blogpost te lezen met de volgende stappen en beschikbare ondersteuning:</p><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Lees de organisatorische update van de CEO</a></strong></u></p><p>Je snelle aandacht voor deze kwestie wordt zeer gewaardeerd.</p><p>Met vriendelijke groet,<br/><strong>Management,</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Aankomende organisatorische veranderingen"
        }
      }
    },
    "campaigns": {
      "completed_events": {
        "event_0": {
          "filename": "event_0.nl.html",
          "from_name": "Slack-team",
          "title": "[Slack] Je wachtwoord verloopt bijna"
        },
        "event_1": {
          "filename": "event_1.nl.html",
          "from_name": "Love2Race-team",
          "title": "[Love2Race] Gepersonaliseerd hardlooppakket voor jullie volgende evenement"
        },
        "event_10": {
          "filename": "event_10.nl.html",
          "from_name": "Maria Caroline Thomsen",
          "title": "Koffie-afspraak"
        },
        "event_11": {
          "filename": "event_11.nl.html",
          "from_name": "SAS",
          "title": "Laagste prijs ooit!"
        },
        "event_12": {
          "filename": "event_12.nl.html",
          "from_name": "Filippa",
          "title": "Aanmelding voor de DHL-estafette!"
        },
        "event_13": {
          "filename": "event_13.nl.html",
          "from_name": "Het beveiligingsteam van Slack",
          "title": "[Slack] Belangrijk: nieuw privacybeleid"
        },
        "event_14": {
          "filename": "event_14.nl.html",
          "from_name": "HubSpot",
          "title": "[HubSpot] Je wachtwoord wordt gewijzigd"
        },
        "event_15": {
          "filename": "event_15.nl.html",
          "from_name": "Je SAP ID Service-team",
          "title": "[SAP] Melding wachtwoordreset"
        },
        "event_16": {
          "filename": "event_16.nl.html",
          "from_name": "1Password",
          "title": "[1Password] Je hoofdwachtwoord is bijgewerkt"
        },
        "event_17": {
          "filename": "event_17.nl.html",
          "from_name": "LinkedIn",
          "title": "[LinkedIn] Je betrokkenheidsinzichten zijn klaar"
        },
        "event_18": {
          "filename": "event_18.nl.html",
          "from_name": "DocuSign",
          "title": "[DocuSign] Document bekijken"
        },
        "event_2": {
          "filename": "event_2.nl.html",
          "from_name": "Lars",
          "title": "Uitnodiging voor prestatie-workshop"
        },
        "event_3": {
          "filename": "event_3.nl.html",
          "from_name": "Microsoft",
          "title": "Waarschuwing: 4.214 bestanden zijn verwijderd - Microsoft"
        },
        "event_4": {
          "filename": "event_4.nl.html",
          "from_name": "Zespół Bezpieczeństwa Allegro",
          "title": "[Allegro] DRINGEND: Je account is tijdelijk opgeschort"
        },
        "event_5": {
          "filename": "event_5.nl.html",
          "title": "Voorstel voor betaaloplossing voor koffie"
        },
        "event_6": {
          "filename": "event_6.nl.html",
          "from_name": "e-Boks A/S",
          "title": "Je hebt nieuwe post van de politie"
        },
        "event_7": {
          "filename": "event_7.nl.html",
          "from_name": "Facebook",
          "title": "Vernieuw je wachtwoord - Facebook"
        },
        "event_8": {
          "filename": "event_8.nl.html",
          "title": "[Slack] Belangrijk: nieuw privacybeleid"
        },
        "event_9": {
          "filename": "event_9.nl.html",
          "from_name": "Microsoft",
          "title": "Quotum overschreden - Microsoft"
        }
      },
      "completed_sms_events": {
        "event_0": {
          "body": "TrackIt: We konden je pakket vandaag niet bezorgen. Bevestig je afleveradres voor 18:00: https://trk-it.example/delivery",
          "from_name": "TrackIt"
        },
        "event_1": {
          "body": "Salaris: Je loonstrook van april staat klaar. Bekijk het beveiligde document hier: https://payroll-example.test/review",
          "from_name": "Salaris"
        },
        "event_2": {
          "body": "IT Support: We hebben een nieuwe login op je e-mailaccount gedetecteerd. Was jij dit niet, bevestig dan nu je identiteit: https://it-help.example/verify",
          "from_name": "IT Support"
        },
        "event_3": {
          "body": "Kantoor: Je bent toegevoegd aan de toegangslijst van morgen. Open hier je bezoekerspas: https://office-pass.example/access",
          "from_name": "Kantoor"
        },
        "event_4": {
          "body": "Bank: Een kaartbetaling is in behandeling gezet. Bevestig de transactie om een tijdelijke blokkade te voorkomen: https://bank-secure.example/check",
          "from_name": "Bank"
        }
      },
      "names": {
        "automatic_campaign": "Automatische campagne",
        "christmas": "Kerstmis",
        "sms_campaign": "SMS-campagne",
        "test": "Test"
      }
    },
    "custom_courses": {
      "names": {
        "access_control_principles": "Principes van toegangsbeheer",
        "backup_and_recovery_procedures": "Back-up- en herstelprocedures",
        "business_continuity_planning": "Planning van bedrijfscontinuïteit",
        "cloud_security_basics": "Basisprincipes van cloudbeveiliging",
        "cybersecurity_awareness_training": "Training in cybersecuritybewustzijn",
        "data_protection_fundamentals": "Grondbeginselen van gegevensbescherming",
        "digital_ethics_and_compliance": "Digitale ethiek en naleving",
        "email_security_guidelines": "Richtlijnen voor e-mailbeveiliging",
        "gdpr_compliance_essentials": "Essentiële AVG-naleving",
        "incident_response_training": "Training in incidentrespons",
        "information_classification": "Informatieclassificatie",
        "mobile_device_security": "Beveiliging van mobiele apparaten",
        "network_security_fundamentals": "Basisprincipes van netwerkbeveiliging",
        "password_security_best_practices": "Best practices voor wachtwoordbeveiliging",
        "phishing_prevention": "Phishingpreventie",
        "privacy_by_design": "Privacy by design",
        "remote_work_security": "Beveiliging bij werken op afstand",
        "secure_coding_practices": "Veilige codeerpraktijken",
        "social_engineering_defense": "Verdediging tegen social engineering",
        "vendor_risk_management": "Leveranciersrisicobeheer"
      }
    },
    "custom_videos": {
      "videos": {
        "creating_strong_passwords": {
          "description": "Best practices voor het maken en beheren van sterke, veilige wachtwoorden.",
          "title": "Sterke wachtwoorden maken"
        },
        "data_privacy_basics": {
          "description": "De kern van gegevensprivacy en hoe je je persoonlijke informatie beschermt.",
          "title": "Basisprincipes van gegevensprivacy"
        },
        "introduction_to_cyber_security": {
          "description": "Een overzicht van de basisprincipes van cyberbeveiliging en waarom dit belangrijk is.",
          "title": "Introductie tot cyberbeveiliging"
        },
        "multi_factor_authentication": {
          "description": "Hoe multifactorauthenticatie werkt en waarom je het zou moeten gebruiken.",
          "title": "Multifactorauthenticatie"
        },
        "new_employee_security_awareness": {
          "description": "Een introductievideo voor nieuwe medewerkers over basisbeveiligingspraktijken.",
          "title": "Beveiligingsbewustzijn voor nieuwe medewerkers"
        },
        "recognizing_phishing_emails": {
          "description": "Leer phishingmails te herkennen en te vermijden om je gegevens te beschermen.",
          "title": "Phishingmails herkennen"
        },
        "safe_internet_browse": {
          "description": "Tips en technieken om veilig en beschermd op internet te surfen.",
          "title": "Veilig internetten"
        },
        "securing_mobile_devices": {
          "description": "Leer hoe je je mobiele apparaten beschermt tegen bedreigingen.",
          "title": "Mobiele apparaten beveiligen"
        },
        "social_engineering_attacks": {
          "description": "Begrijp social-engineeringtactieken en hoe je je ertegen verdedigt.",
          "title": "Social-engineeringaanvallen"
        },
        "understanding_ransomware": {
          "description": "Een introductie tot ransomware en hoe je je gegevens ertegen beschermt.",
          "title": "Ransomware begrijpen"
        }
      }
    },
    "policies": {
      "content": {
        "heading_second_paragraph": "Tweede alinea",
        "paragraph_1": "Bij [Company Name] zetten we ons in om de hoogste normen voor gegevensbeveiliging in alle onderdelen van onze activiteiten te handhaven. We erkennen dat de vertrouwelijkheid, integriteit en beschikbaarheid van persoonlijke en gevoelige informatie cruciaal zijn om het vertrouwen van onze klanten, medewerkers, partners en toezichthouders te behouden.",
        "paragraph_2": "Daarom hebben we dit beleid voor gegevensbeveiliging opgesteld om de principes en praktijken te definiëren die onze inspanningen sturen om gegevens te beschermen tegen ongeautoriseerde toegang, misbruik, verlies, wijziging of vernietiging. Dit beleid is van toepassing op alle persoonsgegevens die we verzamelen, verwerken of opslaan, zowel digitaal als fysiek, en is afgestemd op erkende normen en wettelijke vereisten, waaronder [voeg toepasselijke wetgeving in, bijv. GDPR, CCPA, HIPAA].",
        "paragraph_3": "Ons doel is proactieve beveiligingsmaatregelen te implementeren die risico’s verminderen, naleving waarborgen en ons bredere informatiegovernancekader ondersteunen. We gebruiken een combinatie van technische, administratieve en fysieke maatregelen om gegevens gedurende de hele levenscyclus te beschermen.",
        "paragraph_4": "Dit omvat toegangscontrolemechanismen, encryptie, veilige softwareontwikkelingspraktijken, incidentresponsplanning, training van medewerkers en regelmatige audits. Van elke medewerker, opdrachtnemer en externe dienstverlener die met persoonsgegevens werkt, wordt verwacht dat hij of zij de in dit beleid beschreven beveiligingsverantwoordelijkheden begrijpt en naleeft.",
        "paragraph_5": "Door onze beveiligingspositie continu te evalueren en te verbeteren, streven we ernaar veranderende dreigingen voor te blijven en ervoor te zorgen dat aan ons toevertrouwde persoonsgegevens met de grootste zorgvuldigheid worden behandeld."
      },
      "names": {
        "acceptable_use_policy": "Beleid voor acceptabel gebruik",
        "access_control_policy": "Beleid voor toegangscontrole",
        "bring_your_own_device_byod_policy": "Bring Your Own Device (BYOD)-beleid",
        "business_continuity_and_disaster_recovery_policy": "Beleid voor bedrijfscontinuïteit en disaster recovery",
        "change_management_policy": "Beleid voor wijzigingsbeheer",
        "cloud_usage_policy": "Beleid voor cloudgebruik",
        "code_of_conduct": "Gedragscode",
        "company_it_security_policy": "IT-beveiligingsbeleid van het bedrijf",
        "data_protection_and_privacy_policy": "Beleid voor gegevensbescherming en privacy",
        "email_and_communication_policy": "Beleid voor e-mail en communicatie",
        "employee_onboarding_policy": "Beleid voor onboarding van medewerkers",
        "encryption_policy": "Encryptiebeleid",
        "incident_response_policy": "Beleid voor incidentrespons",
        "internet_usage_policy": "Beleid voor internetgebruik",
        "mobile_device_management_policy": "Beleid voor beheer van mobiele apparaten",
        "monitoring_and_logging_policy": "Beleid voor monitoring en logging",
        "network_security_policy": "Beleid voor netwerkbeveiliging",
        "password_management_policy": "Beleid voor wachtwoordbeheer",
        "patch_management_policy": "Beleid voor patchbeheer",
        "physical_security_policy": "Beleid voor fysieke beveiliging",
        "remote_work_policy": "Beleid voor werken op afstand",
        "secure_development_policy": "Beleid voor veilige ontwikkeling",
        "social_media_policy": "Beleid voor sociale media",
        "software_installation_policy": "Beleid voor software-installatie",
        "third_party_vendor_security_policy": "Beleid voor beveiliging van externe leveranciers"
      }
    },
    "simulations": {
      "subjects": {
        "new_work_phones": "We krijgen nieuwe werktelefoons",
        "slack_privacy_policy": "[Slack] Belangrijk: nieuw privacybeleid",
        "warning_files_deleted": "Waarschuwing: 4.214 bestanden zijn verwijderd - Microsoft"
      }
    },
    "threats": {
      "emails": {
        "free_gift_card_sender": "no-reply@ing.nl"
      },
      "subjects": {
        "free_gift_card_opportunity_short": "Jouw kans op een gratis cadeaubon van 300 kr e...",
        "free_gift_card_opportunity_short_with_space": " Jouw kans op een gratis cadeaubon van 300 kr e..."
      }
    },
    "training": {
      "courses": {
        "10564bf8-aa3e-4295-9cf0-d350276455da": "Basisprincipes van cybersecurity",
        "19a78f09-8c46-4090-b2aa-e2d655efb9cf": "Verwerking van persoonsgegevens",
        "27ad50e1-7967-49bd-a85a-3c8a4a97975a": "Een introductie tot de AVG",
        "2ba7b31b-c23c-4195-9506-6dd064f9c72d": "Phishing",
        "69e29286-5079-4053-bd59-f59e64b41cf2": "Voor beginners",
        "9dadf2a3-6883-4929-b77d-ac424f690a7c": "Wachtwoorden",
        "a07d3c2d-0414-43bd-b8a7-6555af86c065": "Ransomware",
        "cdf2ba12-d0cd-4c71-a58e-267ec870007a": "Fysieke beveiliging"
      },
      "videos": {
        "a_secure_network": "Een veilig netwerk",
        "ai_impact_on_phishing": "De impact van AI op phishing",
        "ai_powered_social_engineering_tactics": "AI-gedreven social-engineeringtactieken",
        "beware_of_public_networks": "Pas op met openbare netwerken",
        "beware_of_usbs_and_other_hard_drives": "Pas op met USB-sticks en andere harde schijven",
        "black_white_and_grey_hat_hackers": "Black hat-, white hat- en grey hat-hackers",
        "cybersecurity_on_mobile_devices": "Cybersecurity op mobiele apparaten",
        "data_leak_monitoring": "Monitoring van datalekken",
        "gdpr_and_security_breaches": "AVG en beveiligingsinbreuken",
        "hacking_of_hashes": "Hacken van hashes",
        "how_has_cryptocurrency_changed_hacking": "Hoe heeft cryptocurrency hacking veranderd?",
        "how_to_create_strong_passwords": "Zo maak je sterke wachtwoorden",
        "how_to_detect_phishing": "Zo herken je phishing",
        "how_to_prevent_tailgating": "Zo voorkom je tailgating",
        "how_to_protect_confidential_data_in_llms": "Zo bescherm je vertrouwelijke gegevens in LLMs",
        "how_to_strengthen_your_physical_security": "Zo versterk je je fysieke beveiliging",
        "multi_factor_authentication": "Multifactorauthenticatie",
        "password_managers": "Wachtwoordmanagers",
        "phishing_from_a_trusted_sender": "Phishing van een vertrouwde afzender",
        "processing_of_personal_data": "Verwerking van persoonsgegevens"
      }
    }
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "at_least_two_options": "Geef alstublieft ten minste twee opties voor elke vraag.",
        "invalid_locale": "Kies een geldige taal aub",
        "network": "Er is een fout opgetreden",
        "noResponse": "Er is geen antwoord ontvangen van de server",
        "no_audience": "Kies een doelgroep aub",
        "no_date": "Vul alstublieft een geldige datum in",
        "no_group": "Kies een groep alstublieft",
        "no_lesson": "Kies een les alstublieft",
        "no_manager": "Kies een manager alstublieft",
        "no_phone_country_code": "Kies een landcode voor telefoonnummer",
        "no_role": "Kies een rol alstublieft",
        "no_tag": "Kies een tag aub",
        "no_timezone": "Kies een tijdzone alstublieft",
        "unknown": "Er is een onbekende fout opgetreden"
      },
      "messages": {
        "at_least_one_manager": "Je moet ten minste één manager in je organisatie hebben.",
        "auth_failed": "Ongeldig e-mailadres en/of wachtwoord",
        "course_could_not_be_published": "Kan niet publiceren. Zorg ervoor dat alle stappen in alle talen zijn ingevuld en dat geen enkele stap zonder titel is.",
        "deepl_translation_failed": "AI-vertaling mislukt. Probeer het later opnieuw.",
        "duplicate_field_identifier": "Veldidentificatie bestaat al",
        "duplicate_goal": "Er bestaat al een doel met dit type en deze einddatum.",
        "general_exception": "Er is een fout opgetreden",
        "goal_expired": "Een verlopen doel kan niet worden bijgewerkt.",
        "group_has_automation": "Deze groep kan niet worden verwijderd omdat deze deel uitmaakt van een actieve automatisering.",
        "group_has_campaign": "Deze groep kan niet worden verwijderd omdat het deel uitmaakt van een actieve campagne.",
        "invalid_domain": "Ongeldige domein",
        "invalid_invite": "Ongeldige uitnodiging",
        "invalid_metadata": "De metadata-URL kon niet worden opgehaald of bevatte geen bruikbare SAML-metadata. Zorg ervoor dat de SAML-configuraties zijn ingevoerd in je IdP.",
        "invalid_phone_number": "Ongeldig telefoonnummer",
        "invalid_provider": "De geselecteerde provider is ongeldig.",
        "invalid_provider_id": "De provider-ID die je heeft opgegeven is ongeldig.",
        "invalid_request": "Technische fout",
        "invalid_request_signature": "De link die je gebruikte is ongeldig of niet meer actief. Vraag je beheerder om een nieuwe uitnodiging te verstrekken.",
        "invalid_response": "De identity provider heeft een ongeldig antwoord teruggestuurd.",
        "missing_calculation": "Het lijkt erop dat we enkele gegevens missen. Probeer het later opnieuw.",
        "missing_teams_app_installation": "De Teams-app is niet geïnstalleerd. Installeer de Moxso Teams-app.",
        "missing_user": "We kunnen geen gebruiker vinden met dat e-mailadres.",
        "no_available_integration": "Er is geen integratie beschikbaar voor de geselecteerde provider.",
        "not_found": "Kon het gevraagde item niet vinden",
        "passwords_dont_match": "De opgegeven wachtwoorden zijn niet identiek",
        "policy_has_active_audit": "Kan niet worden verwijderd omdat het beleid een actieve audit heeft.",
        "policy_not_approved": "Kan audit niet aanmaken omdat het beleid niet is goedgekeurd.",
        "provider_resource_not_found": "De groep is niet gevonden in het integratiedirectory.",
        "saml_provider_not_found": "SAML-verbinding niet gevonden.",
        "sync_conflict": "Medewerkerssynchronisatie is al ingeschakeld via een andere directory-integratie of SCIM-verbinding. Schakel de andere verbinding voor medewerkerssynchronisatie uit voordat je deze inschakelt.",
        "sync_provider_missing": "Kan geen contact opnemen met de provider",
        "sync_provider_response_failure": "Kan contacten niet synchroniseren",
        "too_many_requests": "Te veel pogingen. Probeer het over een paar minuten opnieuw.",
        "two_factor_challenge_invalid": "De loginuitdaging is verlopen. Log opnieuw in.",
        "two_factor_code_invalid": "De authenticatiecode is ongeldig.",
        "unexpected_error": "Er is een onverwachte fout opgetreden. Probeer het opnieuw.",
        "upcoming_action_has_data": "Acties zijn al gepland voor de volgende stappen in deze automatisering. Verwijder deze acties voordat je opslaat.",
        "user_already_active": "De gebruiker bestaat al.",
        "user_exists_in_different_workspace": "De gebruiker bestaat al, maar in een andere werkruimte. Neem contact op met support om de gebruiker aan deze werkruimte toe te voegen.",
        "user_not_found": "De link die je gebruikte is ongeldig of niet langer actief. Vraag je beheerder om een nieuwe uitnodiging te sturen.",
        "video_could_not_be_uploaded": "Video kon niet worden geüpload"
      },
      "validations": {
        "messages": {
          "accepted_if": "Ongeldige velden",
          "after_or_equal": "De einddatum moet een datum zijn die na of gelijk is aan de startdatum.",
          "alpha": "Het veld {_field_} mag alleen alfabetische tekens bevatten.",
          "alpha_dash": "Het veld {_field_} mag alfanumerieke tekens, evenals koppeltekens en underscores bevatten.",
          "alpha_num": "Het veld {_field_} mag alleen alfanumerieke tekens bevatten.",
          "alpha_spaces": "Het veld {_field_} mag alleen alfabetische tekens en spaties bevatten",
          "between": "Het veld {_field_} moet tussen {min} en {max} liggen.",
          "boolean": "{_field_} veld is geen geldige waarde",
          "confirmed": "Het bevestigingsveld {_field_} komt niet overeen",
          "currentPassword": "Het wachtwoord is niet geldig",
          "date": "{_field_} veld is geen geldige datum",
          "date_format": "{_field_} veld is geen geldige datum",
          "digits": "Het veld {_field_} moet numeriek zijn en exact {length} cijfers bevatten.",
          "dimensions": "Het {_field_} veld moet {width} pixels bij {height} pixels zijn.",
          "double": "Het {_field_} veld moet een geldige decimaal zijn",
          "email": "Het veld {_field_} moet een geldig e-mailadres zijn.",
          "excluded": "Het veld {_field_} is geen geldige waarde",
          "ext": "Het veld {_field_} is geen geldig bestand",
          "image": "Het veld {_field_} moet een afbeelding zijn",
          "in": "{_field_} veld is geen geldige waarde",
          "integer": "Het veld {_field_} moet een geheel getal zijn",
          "invalid_domain": "Je moet je domein verifiëren voordat je gebruikers kunt toevoegen.",
          "invalid_field": "Ongeldige velden",
          "invalid_phone_number": "Ongeldig telefoonnummer",
          "length": "Het {_field_} veld moet {length} tekens lang zijn.",
          "max": "Het {_field_} veld mag niet meer dan {length} tekens bevatten.",
          "max_value": "Het {_field_} veld moet {max} of minder zijn",
          "mimes": "Het veld {_field_} moet een geldig bestandstype hebben",
          "min": "Het {_field_} veld moet minstens {length} tekens bevatten.",
          "min_value": "Het {_field_} veld moet {min} of meer zijn.",
          "missing_user": "We kunnen geen gebruiker vinden met dat e-mailadres.",
          "non_disposable_email": "{_field_} veld moet een geldig e-mailadres zijn",
          "not_found": "Het {_field_} is niet gevonden",
          "numeric": "Het {_field_} veld mag alleen numerieke tekens bevatten.",
          "oneOf": "Het {_field_} veld is geen geldige waarde.",
          "regex": "De indeling van het {_field_} veld is ongeldig.",
          "required": "Dit veld is verplicht",
          "required_if": "Het {_field_} veld is verplicht",
          "size": "De grootte van het {_field_} veld moet minder dan {size}KB zijn.",
          "string": "{_field_} veld mag alleen alfabetische tekens bevatten",
          "true": "De {_field_} moet worden geaccepteerd.",
          "unique": "Het {_field_} is al in gebruik.",
          "unique_provider_id": "Deze groep bestaat al in de integratieprovider"
        }
      }
    },
    "automation": {
      "flow": {
        "title": {
          "action_selector": "Actie kiezen",
          "add_tag_action": "Tag toevoegen",
          "assign_course_action": "Cursus toewijzen",
          "assign_lesson_action": "Les toewijzen",
          "assign_quiz_action": "Beoordeling toewijzen",
          "assign_video_action": "Video toewijzen",
          "halt_action": "Automatisering stoppen",
          "missing_action": "Ontbrekende actie",
          "remove_tag_action": "Tag verwijderen",
          "wait_action": "Wacht gedurende een periode"
        }
      },
      "frequency": {
        "intense": "Intens",
        "loose": "Losjes",
        "normal": "Normaal"
      },
      "status": {
        "paused": "Gepauzeerd",
        "running": "Bezig",
        "started": "Gestart"
      },
      "templates": {
        "advanced-it-security-training": {
          "description": "Geavanceerde beveiligingstraining voor IT- en technisch personeel.",
          "title": "Geavanceerde IT-beveiligingstraining"
        },
        "blank": {
          "description": "Begin vanaf nul met een lege automatisering.",
          "title": "Lege automatisering"
        },
        "cybersecurity-and-physical-security-awareness-intense": {
          "description": "Uitgebreide beveiligingstraining voor gevorderde gebruikers.",
          "title": "Cyber- en fysieke beveiligingsbewustzijn (Intensief)"
        },
        "cybersecurity-and-physical-security-awareness-light": {
          "description": "Introductietraining over beveiliging voor medewerkers zonder pc.",
          "title": "Cyber- en fysieke beveiligingsbewustzijn (Licht)"
        },
        "cybersecurity-and-physical-security-awareness-medium": {
          "description": "Beveiligingsbewustzijnstraining voor medewerkers met pc-toegang.",
          "title": "Cyber- en fysieke beveiligingsbewustzijn (Medium)"
        },
        "cybersecurity-fundamentals": {
          "description": "Kernprincipes en best practices voor cyberbeveiliging.",
          "title": "Cybersecurity Fundamentals"
        },
        "management-training-in-it-security": {
          "description": "Cybersecurity-bewustzijn voor managers en leidinggevenden.",
          "title": "Managementtraining in IT-beveiliging"
        },
        "security-awareness-essentials-training": {
          "description": "Basis cyberbeveiligingsbewustzijn voor alle medewerkers.",
          "title": "Security Awareness Basistraining"
        }
      },
      "triggers": {
        "date_trigger": "Op een specifieke datum",
        "employee_added_to_audience_trigger": "Wanneer een medewerker wordt toegevoegd aan het sequentiepubliek",
        "employee_created_trigger": "Wanneer een medewerker wordt aangemaakt",
        "simulation_link_clicked_trigger": "Wanneer een medewerker op een link in een simulatie klikt",
        "tag_added_trigger": "Wanneer een medewerker een tag krijgt toegewezen",
        "tag_removed_trigger": "Wanneer een medewerker van een tag wordt verwijderd"
      },
      "triggers_help": {
        "date_trigger": "Schrijft iedereen in de geselecteerde doelgroep in wanneer de trigger wordt geactiveerd. Medewerkers die na die datum aan de doelgroep worden toegevoegd, worden niet automatisch ingeschreven.",
        "employee_added_to_audience_trigger": "Schrijft een medewerker in wanneer die wordt toegevoegd aan de doelgroep die aan de automatisering is gekoppeld.",
        "employee_created_trigger": "Schrijft een medewerker in zodra die aan Moxso wordt toegevoegd.",
        "simulation_link_clicked_trigger": "Schrijft een medewerker in wanneer die op een link in een phishingsimulatie klikt, zodat je gerichte hersteltraining kunt toewijzen."
      },
      "wait_units": {
        "days": "Dag | dagen",
        "hours": "Uur | uren",
        "minutes": "Minuten",
        "months": "Maand | maanden",
        "seconds": "Seconde | seconden",
        "weeks": "Weken"
      }
    },
    "employees": {
      "deactivation_notice": {
        "account_disabled": "Dit account is handmatig uitgeschakeld door een beheerder op {date}.",
        "active_directory": "Dit account is uitgeschakeld vanwege een wijziging in je Active Directory op {date}.",
        "simulation_bounce": "Dit account is uitgeschakeld vanwege een bounce in een simulatie op {date}.",
        "simulation_complaint": "Dit account is uitgeschakeld vanwege een klacht in een simulatie op {date}."
      },
      "recent_activity": {
        "type": {
          "clicked": "{name} klikte op een simulatie link",
          "completed_course": "{name} heeft een cursus voltooid",
          "correct": "{name} heeft een phishingquiz correct beantwoord",
          "delivered": "{name} ontving een simulatie",
          "incorrect": "{name} heeft een phishingquiz onjuist beantwoord",
          "mc_correct": "{name} beantwoordde een meerkeuzevraag correct.",
          "mc_incorrect": "{name} beantwoorde een meerkeuzevraag onjuist",
          "reported": "{name} heeft een simulatie gerapporteerd",
          "sms_clicked": "{name} klikte op een link in een smishing simulatie",
          "sms_delivered": "{name} ontving een smishing simulatie",
          "submission": "{name} heeft ingelogd op een simulatie",
          "submit_delivered": "{name} ontving een simulatie",
          "watched_video": "{name} heeft een video bekeken"
        }
      },
      "status": {
        "active": "Actief",
        "inactive": "Inactief"
      }
    },
    "export_form_fields": {
      "clicked_count": "Simulaties aangeklikt",
      "created_at": "Aangemaakt op",
      "department": "Afdeling",
      "dynamic_group_memberships": "Dynamische groeplidmaatschappen",
      "email": "E-mail",
      "first_name": "Voornaam",
      "group_count": "Groep aantal",
      "last_name": "Achternaam",
      "locale": "Taal",
      "manager_name": "Manager",
      "onboarded": "Status van onboarding",
      "phishing_quizzes_count": "Phishingquizzen voltooid",
      "phone_number": "Telefoonnummer",
      "point_count": "Totaal aantal punten",
      "provider": "Integratieprovider",
      "received_count": "Simulaties ontvangen",
      "reported_count": "Gesimuleerde meldingen",
      "score": "Score",
      "status": "Status",
      "submitted_count": "Inloggen in simulaties",
      "video_quizzes_count": "Voltooide videoquizzen",
      "watched_count": "Bekeken video's"
    },
    "feature_upsell": {
      "bring-your-own-content": {
        "items": [
          "Upload je eigen video's en leermaterialen",
          "Lokaliseer uploads voor verschillende talen en teams",
          "Bied onboarding- en compliancecontent aan die bij je organisatie past",
          "Automatiseer planning, opvolging en rapportage voor eigen content."
        ],
        "summary": "Combineer Moxso-training met je eigen materiaal om content te bieden die past bij jullie workflows, tools en interne communicatie.",
        "title": "Eigen content"
      },
      "compliance-integration": {
        "items": [
          "Koppel Drata en Vanta met minder frictie bij de inrichting.",
          "Verminder handmatig verzamelen van compliance-bewijs.",
          "Breng trainingsactiviteit onder in auditvriendelijke workflows.",
          "Ondersteun terugkerende reviews met minder overdrachtsmomenten."
        ],
        "summary": "Synchroniseer compliance-bewijs en koppel Moxso-activiteit aan Drata- en Vanta-workflows met minder handmatige opvolging.",
        "title": "Drata- en Vanta-compliance-integratie"
      },
      "goal-setting": {
        "items": [
          "Stel meetbare doelen in voor belangrijke prestatiestatistieken.",
          "Volg voortgang ten opzichte van het doel in de tijd.",
          "Gebruik verwachte trends om te zien of het doel realistisch is.",
          "Zie vroeg of prestaties op schema liggen."
        ],
        "summary": "Stel een doel in, volg de voortgang in de tijd en vergelijk die met een verwachte trendlijn om te zien of je doel realistisch is en op schema ligt.",
        "title": "Doelen instellen"
      },
      "human-risk-intelligence": {
        "items": [
          "Monitor menselijke risicosignalen op één plek.",
          "Volg toewijzingen en interventies in de tijd.",
          "Herken opkomend gedragsrisico eerder.",
          "Prioriteer acties met rijkere risicocontext."
        ],
        "summary": "Volg menselijke risicosignalen, interventies en toewijzingen in één overzicht om opkomend gedragsrisico beter te begrijpen.",
        "title": "Inzicht in menselijk risico"
      },
      "industry-benchmarking": {
        "items": [
          "Vergelijk prestaties met benchmarks van vergelijkbare organisaties.",
          "Voeg context toe aan weerbaarheids- en trainingsmetrics.",
          "Signaleer uitschieters sneller over belangrijke KPI's heen.",
          "Versterk rapportage voor stakeholders en management."
        ],
        "summary": "Vergelijk weerbaarheid en trainingsprestaties met benchmarks van vergelijkbare organisaties om je securitymetrics in context te plaatsen.",
        "title": "Branchebenchmarking"
      },
      "phishing-reporting-add-in": {
        "items": [
          "Maak het makkelijker voor medewerkers om verdachte e-mails direct te melden.",
          "Breng aanvallen sneller aan het licht voordat ze zich verspreiden.",
          "Houd securitymelding eenvoudig en top of mind voor iedereen.",
          "Verwerk melden in het dagelijkse werk zonder extra frictie."
        ],
        "summary": "E-mailclient-add-in waarmee medewerkers phishing en verdachte e-mails direct vanuit hun inbox kunnen melden.",
        "title": "Phishing melden"
      },
      "policy-management": {
        "items": [
          "Maak en werk interne beleidsdocumenten bij op één plek",
          "Wijs beleid toe aan de juiste teams op het juiste moment",
          "Verzamel bevestigingen van medewerkers voor beleidsdocumenten",
          "Volg de status en behoud een audit trail"
        ],
        "summary": "Publiceer intern beleid, volg bevestigingen op en houd documentatie overzichtelijk binnen je organisatie.",
        "title": "Beleidsbeheer"
      },
      "risk-based-training": {
        "items": [
          "Adaptief leren op basis van gedrag en risicosignalen.",
          "Verminder menselijk cyberrisico met gepersonaliseerde training.",
          "Richt je op echte kwetsbaarheden, niet op hypothetische dreigingen.",
          "Beperk overbelasting voor gebruikers met een laag risico."
        ],
        "summary": "Security awareness-training die inhoud en intensiteit aanpast op basis van risicosignalen van medewerkers en hun risicoprofiel, afgeleid uit simulaties en geobserveerd gedrag.",
        "title": "Risicogebaseerde training"
      },
      "simulation-builder": {
        "items": [
          "Stem simulaties af op je organisatie en dreigingen.",
          "Richt campagnes op de gebruikers, rollen of groepen die het meest tellen.",
          "Gebruik herkenbare afzenders, berichten en thema’s voor meer authenticiteit.",
          "Ontwerp campagnes op jouw voorwaarden en focus op prioriteiten.",
          "Genereer realistische phishing-simulaties met AI."
        ],
        "summary": "Configuratietools voor het maken en beheren van phishing-simulatiecampagnes, inclusief sjablonen, afzenderprofielen en domeinen.",
        "title": "Simulatiebouwer"
      },
      "smishing": {
        "items": [
          "Voer sms-gebaseerde phishing-simulaties uit.",
          "Test hoe medewerkers reageren op mobiele apparaten.",
          "Breid awareness-training uit voorbij de inbox.",
          "Meet weerbaarheid tegen mobile-first aanvalspatronen."
        ],
        "summary": "Breid simulaties uit voorbij e-mail met sms- en QR-gebaseerde phishing-scenario's die zijn afgestemd op mobile-first aanvallen.",
        "title": "Smishing en quishing"
      },
      "spear-phishing": {
        "items": [
          "Simuleer software-targeting en directiefraude.",
          "Test het buitmaken van inloggegevens in realistischere scenario's.",
          "Breid phishingprogramma's uit met geavanceerde aanvalstypen.",
          "Bereid medewerkers voor op social engineering met een hoger risico."
        ],
        "summary": "Maak geavanceerde phishing-simulaties voor software-targeting, directie-imitatie en scenario's voor het buitmaken van inloggegevens.",
        "title": "Spear phishing"
      },
      "teams-slack-integration": {
        "items": [
          "Koppel samenwerkingskanalen aan securityworkflows.",
          "Stuur relevante meldingen naar de plekken waar teams al werken.",
          "Breid rapportage en awareness uit naar dagelijkse communicatie.",
          "Ondersteun snellere opvolging tussen security en operations."
        ],
        "summary": "Koppel samenwerkingsplatformen om meldingen te synchroniseren en securityworkflows uit te breiden naar dagelijkse communicatiekanalen.",
        "title": "MS Teams- en Slack-integratie"
      },
      "threat-management": {
        "items": [
          "Realtime inzicht in gemelde dreigingen",
          "Branchespecifieke meldingen over nieuwe aanvalspatronen",
          "Analyse van dreigingstrends binnen je organisatie",
          "Werkt rechtstreeks met Outlook en Gmail."
        ],
        "summary": "Onderzoek verdachte e-mails, begrijp risicosignalen en reageer op dreigingen vanuit één workflow voor securityteams.",
        "title": "Dreigingsbeheer"
      }
    },
    "frameworks": {
      "ai_act": "AI Act",
      "dora": "DORA",
      "gdpr": "GDPR",
      "iso_27001": "ISO 27001",
      "iso_27005": "ISO 27005",
      "nis2": "NIS2",
      "soc_2": "SOC 2"
    },
    "goals": {
      "metric": {
        "click_rate": "Klikratio",
        "employees_behind": "Achterlopende medewerkers",
        "report_rate": "Meldratio",
        "resilience_score": "Weerbaarheidsscore"
      },
      "outcome": {
        "achieved": "Behaald",
        "missed": "Gemist"
      },
      "status": {
        "ahead": "Voor op schema",
        "at_risk": "Risico",
        "on_track": "Op schema"
      }
    },
    "group": {
      "sync_failure": {
        "invalid_provider": {
          "subtitle": "Kies een geldige provider en vernieuw de gegevens."
        },
        "invalid_provider_id": {
          "subtitle": "Kies een geldige provider-ID en vernieuw de gegevens."
        },
        "no_available_integration": {
          "subtitle": "Kies een beschikbare integratie."
        },
        "provider_resource_not_found": {
          "subtitle": "Werk het groepsprovider-ID bij."
        },
        "recommended_action": "Aanbevolen actie",
        "title": "Synchronisatie mislukt"
      }
    },
    "groups": {
      "adaptive_conditions": {
        "fields": {
          "department": "Afdeling",
          "email": "E-mail",
          "locale": "Taal",
          "manager_id": "Manager",
          "onboarded": "Onboardingstatus",
          "organizational_role_id": "Rol",
          "provider": "Integratieprovider",
          "score": "Score",
          "status": "Status",
          "timezone": "Tijdzone"
        },
        "operators": {
          "contains": "bevat",
          "ends_with": "eindigt op",
          "equals": "is",
          "greater_than": "is groter dan",
          "greater_than_or_equal": "is groter dan of gelijk aan",
          "is_empty": "is leeg",
          "is_not_empty": "is niet leeg",
          "less_than": "is kleiner dan",
          "less_than_or_equal": "is kleiner dan of gelijk aan",
          "not_equals": "is niet",
          "starts_with": "begint met"
        },
        "values": {
          "active": "Actief",
          "false": "Onwaar",
          "google": "Google Workspace",
          "google_scim": "Google SCIM",
          "inactive": "Inactief",
          "microsoft": "Microsoft Entra ID",
          "microsoft_scim": "Microsoft Entra SCIM",
          "okta_scim": "Okta SCIM",
          "slack": "Slack",
          "true": "Waar"
        }
      }
    },
    "hri_integration_tags": {
      "access_permissions": {
        "description": "Toegangsgebeurtenissen, autorisatie, rechten en toegang tot applicaties.",
        "headline": "Toegang"
      },
      "account_security": {
        "description": "Accountstatus, bescherming, wijzigingen, levenscyclus en risicovolle gebruikers.",
        "headline": "Accountbeveiliging"
      },
      "audit_administration": {
        "description": "Auditlogboeken, beheergebeurtenissen en wijzigingen in beveiligingsinstellingen.",
        "headline": "Auditlogboeken"
      },
      "authentication_mfa": {
        "description": "Aanmeldingen, inlogactiviteit, authenticatieresultaten en MFA-gebeurtenissen.",
        "headline": "Authenticatie"
      },
      "data_protection_insider_risk": {
        "description": "Preventie van gegevensverlies (DLP) en gebeurtenissen rond interne risico's.",
        "headline": "Gegevensbescherming"
      },
      "device_management": {
        "description": "Beheerdekking, agentstatus en beveiligingsstatus van apparaattoegang.",
        "headline": "Apparaatbeheer"
      },
      "device_security": {
        "description": "Versleuteling, schermvergrendeling, endpointbescherming en apparaatcompliance.",
        "headline": "Apparaatbeveiliging"
      },
      "email_security": {
        "description": "E-maildreigingen en accountovername.",
        "headline": "E-mailbeveiliging"
      },
      "incidents_investigations": {
        "description": "Beveiligingsincidenten, ernst en onderzoeksstatus.",
        "headline": "Incidenten"
      },
      "remediation_control_gaps": {
        "description": "Hiaten in de bescherming, bevindingen over beheersmaatregelen en voortgang van herstel.",
        "headline": "Hiaten in beheersmaatregelen"
      },
      "service_health": {
        "description": "Service-incidenten, componentstatus en gepland onderhoud.",
        "headline": "Servicestatus"
      },
      "sharing_data_activity": {
        "description": "Wijzigingen in delen, gegevensverplaatsing, itemgebruik en Git-activiteit.",
        "headline": "Gegevensactiviteit"
      },
      "threats_detections": {
        "description": "Beveiligingswaarschuwingen, dreigingssignalen en risicodetecties.",
        "headline": "Dreigingen"
      },
      "vulnerabilities_exposure": {
        "description": "Kwetsbaarheden, cloudbevindingen, pentestbevindingen en blootstelling.",
        "headline": "Kwetsbaarheden"
      },
      "workforce_organization": {
        "description": "Rollen, teams, dienstverbanden en werkregelingen.",
        "headline": "Personeel"
      }
    },
    "hri_integrations": {
      "abnormal_ai": {
        "bullets": [
          {
            "label": "Echte e-maildreigingen",
            "text": "{label}: Gedetecteerde phishing en andere ondersteunde e-mailaanvallen leveren bewijs naast simulaties."
          },
          {
            "label": "Accountcompromittering",
            "text": "{label}: Bevindingen over accountovername helpen accounts te identificeren die mogelijk dringend onderzoek vereisen."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Gebruik relevant bewijs van aanvallen om advies over phishing en accountbeveiliging specifieker te maken."
          },
          {
            "label": "Responscontext",
            "text": "{label}: Vastgelegde herstelacties en casestatus helpen verklaren wat al is aangepakt."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest dreigings- en responsinformatie zonder berichten te verwijderen of acties op accounts uit te voeren."
          }
        ],
        "description_long": "Abnormal AI detecteert e-mailaanvallen en accountovername. Koppel het zodat Moxso echte aanvalssignalen kan gebruiken om de opvolging van menselijke risico's te richten op de dreigingen waarmee mensen in je omgeving te maken krijgen.",
        "description_short": "Gebruik e-maildreigingen en bevindingen over accountovername voor gerichte beveiligingsopvolging.",
        "title": "Abnormal AI"
      },
      "aikido": {
        "bullets": [
          {
            "label": "Beveiligingsbevindingen",
            "text": "{label}: Kwetsbaarheden en andere ondersteunde problemen wijzen gebieden aan die technische aandacht vereisen."
          },
          {
            "label": "Blootstellingscontext",
            "text": "{label}: Informatie over de ernst en getroffen resources helpt het belang van een bevinding te verklaren."
          },
          {
            "label": "Gerichte actie",
            "text": "{label}: Gebruik relevante bevindingen om technisch herstel en beveiligingsadvies op de juiste teams te richten."
          },
          {
            "label": "Voortgang in de tijd",
            "text": "{label}: Wijzigingen in de bevindingstatus helpen openstaande problemen te onderscheiden van reeds aangepakt werk."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde beveiligingsbevindingen zonder code te wijzigen of oplossingen toe te passen."
          }
        ],
        "description_long": "Aikido Security identificeert zwakke plekken in software en infrastructuur. Koppel het om relevante technische blootstelling mee te nemen in je beoordelingen van menselijke risico's en beveiligingsopvolging.",
        "description_short": "Neem kwetsbaarheden in software en infrastructuur op in je risicobeoordelingen.",
        "title": "Aikido Security"
      },
      "airtable": {
        "bullets": [
          {
            "label": "Accountbescherming",
            "text": "{label}: Beschikbare indicatoren voor authenticatie en rechten helpen toegangsproblemen zichtbaar te maken."
          },
          {
            "label": "Werkelijke activiteit",
            "text": "{label}: Geselecteerde auditgebeurtenissen leveren bewijs van beveiligingsrelevante acties en wijzigingen."
          },
          {
            "label": "Gericht advies",
            "text": "{label}: Gebruik relevante gebeurtenissen om advies te richten op accountbescherming en verantwoorde toegang tot gedeelde informatie."
          },
          {
            "label": "Doorlopende beoordeling",
            "text": "{label}: Bekijk wijzigingen in accountbeveiliging en terugkerende gebeurtenissen samen met ander bewijs."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde beveiligingsinformatie zonder toegang tot tabelrecords. Toegang tot de Enterprise API vereist een geschikt abonnement."
          }
        ],
        "description_long": "Airtable helpt teams met gedeelde bedrijfsinformatie te werken. Koppel het zodat Moxso relevante accountbeveiligings- en auditsignalen kan gebruiken voor inzicht in menselijke risico's en gerichte opvolging.",
        "description_short": "Beoordeel accountbeveiligingssignalen en auditactiviteit rond gedeelde bedrijfsinformatie.",
        "title": "Airtable"
      },
      "asana": {
        "bullets": [
          {
            "label": "Toegangssignalen",
            "text": "{label}: Ondersteunde auditgebeurtenissen identificeren activiteit die invloed heeft op account- en projecttoegang."
          },
          {
            "label": "Wijzigingen in delen",
            "text": "{label}: Geselecteerde gebeurtenissen rond lidmaatschap en linktoegang leveren bewijs van wijzigingen in de toegang voor samenwerking."
          },
          {
            "label": "Relevante opvolging",
            "text": "{label}: Gebruik de omstandigheden van een gebeurtenis voor gerichte toegangsbeoordelingen en advies over veilig delen."
          },
          {
            "label": "Patronen in de tijd",
            "text": "{label}: Bekijk terugkerende toegangswijzigingen samen met ander beveiligingsbewijs."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde auditmetadata zonder toegang tot taakbeschrijvingen of projectinhoud. De beschikbaarheid van audits hangt af van je Asana-abonnement."
          }
        ],
        "description_long": "Asana helpt teams werk te organiseren en te delen. Koppel het zodat Moxso geselecteerde toegangs- en deelgebeurtenissen kan gebruiken voor inzicht in menselijke risico's en om veiliger samenwerken te ondersteunen.",
        "description_short": "Gebruik toegangs- en deelgebeurtenissen om veiliger samenwerken te stimuleren.",
        "title": "Asana"
      },
      "atlassian": {
        "bullets": [
          {
            "label": "Accountbeveiligingssignalen",
            "text": "{label}: Ondersteunde auditgebeurtenissen leveren bewijs van toegangsgerelateerde activiteit."
          },
          {
            "label": "Gevoelige wijzigingen",
            "text": "{label}: Beheeracties helpen wijzigingen te identificeren die nader onderzoek verdienen."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Gebruik relevante gebeurtenissen als leidraad voor toegangsbeoordelingen en advies over accountbeveiliging."
          },
          {
            "label": "Doorlopend bewustzijn",
            "text": "{label}: Bekijk terugkerende activiteit samen met ander bewijs voordat je een actie bepaalt."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde auditmetadata zonder toegang tot de inhoud van Jira-issues of Confluence-pagina's."
          }
        ],
        "description_long": "Atlassian ondersteunt samenwerking binnen je organisatie. Koppel het zodat Moxso geselecteerde account- en beheergebeurtenissen kan gebruiken voor inzicht in menselijke risico's en relevante opvolging.",
        "description_short": "Beoordeel account- en beheeractiviteit in je samenwerkingstools.",
        "title": "Atlassian"
      },
      "auth0": {
        "bullets": [
          {
            "label": "Echte aanmeldsignalen",
            "text": "{label}: Geselecteerde mislukte aanmeldingen, MFA-gebeurtenissen en aanvalsgerelateerde gebeurtenissen brengen toegangsproblemen aan het licht."
          },
          {
            "label": "Accountbescherming",
            "text": "{label}: Wijzigingen in inloggegevens en beveiligingsgerelateerde accountwijzigingen leveren aanvullend bewijs voor beoordeling."
          },
          {
            "label": "Relevante opvolging",
            "text": "{label}: Gebruik activiteit die aan medewerkers kan worden gerelateerd als leidraad voor onderzoek en advies over accountbeveiliging."
          },
          {
            "label": "Patronen in de tijd",
            "text": "{label}: Bekijk herhaalde authenticatieproblemen in de context van de betrokken applicatie."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde activiteit zonder applicatieaccounts of authenticatie-instellingen te wijzigen."
          }
        ],
        "description_long": "Auth0 verzorgt aanmeldingen voor je applicaties. Koppel het zodat Moxso relevante authenticatie- en accountbeveiligingssignalen kan gebruiken voor inzicht in menselijke risico's wanneer de activiteit betrekking heeft op je personeel.",
        "description_short": "Gebruik aanmeld- en accountbeveiligingsgebeurtenissen van personeel voor risicobeoordelingen.",
        "title": "Auth0"
      },
      "clerk": {
        "bullets": [
          {
            "label": "Accountstatus",
            "text": "{label}: Beschikbare vergrendelings- en blokkeringsstatussen helpen accounts te identificeren die mogelijk nader onderzoek vereisen."
          },
          {
            "label": "Toegangscontext",
            "text": "{label}: Organisatielidmaatschap helpt applicatietoegang in perspectief te plaatsen."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Gebruik relevante accountcontext als leidraad voor toegangsbeoordelingen en gesprekken over accountbeveiliging."
          },
          {
            "label": "Actueel beeld",
            "text": "{label}: Bekijk de laatste accountstatus samen met ander bewijs om te bepalen wat aandacht nodig heeft."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest account- en toegangsinformatie zonder Clerk-instellingen te wijzigen. Deze koppeling verzamelt geen aanmeldgebeurtenissen of sessieactiviteit."
          }
        ],
        "description_long": "Clerk beheert de toegang tot je applicaties. Koppel het zodat Moxso accounttoegangscontext kan meewegen naast menselijke risico's en de opvolging van accountbeveiliging relevanter kan maken.",
        "description_short": "Gebruik accountstatus en organisatielidmaatschap voor toegangsbeoordelingen.",
        "title": "Clerk"
      },
      "cloudflare_zero_trust": {
        "bullets": [
          {
            "label": "Beveiligingswijzigingen",
            "text": "{label}: Geselecteerde auditgebeurtenissen identificeren wijzigingen in toegangsgerelateerde instellingen en resources."
          },
          {
            "label": "Toegangscontext",
            "text": "{label}: Beschikbare details over actor, actie en resultaat helpen het belang van een gebeurtenis te verklaren."
          },
          {
            "label": "Gerichte beoordeling",
            "text": "{label}: Gebruik gevoelige wijzigingen om te bepalen waar een toegangsbeoordeling of beveiligingsopvolging nodig is."
          },
          {
            "label": "Doorlopend inzicht",
            "text": "{label}: Bekijk herhaalde beheerwijzigingen samen met ander beveiligingsbewijs."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde beveiligingsinformatie zonder toegangsbeleid te wijzigen. Deze koppeling biedt geen verkeersmonitoring of aanmeldtelemetrie van Access."
          }
        ],
        "description_long": "Cloudflare Zero Trust beschermt de toegang tot bedrijfsresources. Koppel het zodat Moxso geselecteerde wijzigingen in beveiliging en toegangsbeheer kan gebruiken als context voor menselijke risico's en onderzoek.",
        "description_short": "Beoordeel wijzigingen in beveiliging en toegangsbeheer die bedrijfsresources beïnvloeden.",
        "title": "Cloudflare Zero Trust"
      },
      "comp_ai": {
        "bullets": [
          {
            "label": "Beveiligingsbevindingen",
            "text": "{label}: Ondersteunde bevindingen maken omstandigheden zichtbaar die beoordeling of herstel vereisen."
          },
          {
            "label": "Beschermingscontext",
            "text": "{label}: Beschikbare apparaatbeveiligingscontroles, waaronder de versleutelingsstatus, helpen het probleem te verklaren."
          },
          {
            "label": "Praktische actie",
            "text": "{label}: Gebruik relevant bewijs voor gerichte opvolging met de medewerker, het IT-team of de eigenaar van de beheersmaatregel."
          },
          {
            "label": "Veranderende omstandigheden",
            "text": "{label}: Updates van bevindingen en beschermingsstatus helpen aanhoudende problemen te onderscheiden van opgelost werk."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerd beveiligingsbewijs zonder taken af te ronden of beleid te wijzigen."
          }
        ],
        "description_long": "Comp AI volgt beveiligingsmaatregelen en compliancebevindingen. Koppel het zodat Moxso relevante hiaten in de bescherming kan meewegen bij het beoordelen van menselijke risico's en het bepalen waar opvolging nodig is.",
        "description_short": "Gebruik beveiligingsbevindingen en hiaten in apparaatbescherming voor gerichte opvolging.",
        "title": "Comp AI"
      },
      "crowdstrike": {
        "bullets": [
          {
            "label": "Echte aanvalssignalen",
            "text": "{label}: Endpointwaarschuwingen leveren bewijs van verdachte of kwaadaardige activiteit."
          },
          {
            "label": "Blootstellingscontext",
            "text": "{label}: Ernst, getroffen resources en beschikbare kwetsbaarheidsdetails helpen bevindingen in perspectief te plaatsen."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Gebruik relevante bevindingen om onderzoek, apparaatherstel en advies aan medewerkers te coördineren."
          },
          {
            "label": "Onderzoeksvoortgang",
            "text": "{label}: De status van bevindingen en cases helpt zichtbaar te maken welke problemen nog aandacht nodig hebben."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde beveiligingsbevindingen zonder hosts te isoleren of onderzoeken te wijzigen."
          }
        ],
        "description_long": "CrowdStrike Falcon detecteert dreigingen op werkapparaten. Koppel het zodat Moxso relevante endpointbevindingen kan gebruiken voor inzicht in menselijke risico's en opvolging gericht op echte beveiligingsproblemen.",
        "description_short": "Neem endpointwaarschuwingen en kwetsbaarheidsbevindingen op in je risicobeoordelingen.",
        "title": "CrowdStrike"
      },
      "datadog": {
        "bullets": [
          {
            "label": "Beveiligingssignalen",
            "text": "{label}: Geselecteerde bevindingen leveren bewijs van activiteit die onderzoek rechtvaardigt."
          },
          {
            "label": "Accountactiviteit",
            "text": "{label}: Ondersteunde gebeurtenissen rond authenticatie, toegang en beveiligingsconfiguratie voegen context toe."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Gebruik medewerkergerelateerd bewijs als leidraad voor accountbeveiligingsbeoordelingen en relevant advies."
          },
          {
            "label": "Patronen in de tijd",
            "text": "{label}: Bekijk terugkerende gebeurtenissen en updates van bevindingen samen met ander risicobewijs."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde beveiligingsinformatie zonder algemene applicatiemetrieken te importeren of instellingen te wijzigen."
          }
        ],
        "description_long": "Datadog identificeert beveiligingsactiviteit in gemonitorde omgevingen. Koppel het zodat Moxso relevante beveiligingsbevindingen en accountgebeurtenissen kan gebruiken voor beoordelingen van menselijke risico's.",
        "description_short": "Voeg beveiligingsbevindingen en accountactiviteit uit gemonitorde omgevingen toe.",
        "title": "Datadog"
      },
      "deel": {
        "bullets": [
          {
            "label": "Rolcontext",
            "text": "{label}: Verantwoordelijkheden en afdelingen helpen beveiligingsproblemen in perspectief te plaatsen."
          },
          {
            "label": "Personeelswijzigingen",
            "text": "{label}: Wijzigingen in de dienstverbandstatus bieden context om te beoordelen of toegang nog passend is."
          },
          {
            "label": "Relevant advies",
            "text": "{label}: Houd rekening met iemands werkcontext bij het kiezen van beveiligingsadvies en bewustwordingsonderwerpen."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Gebruik rol- en levenscycluscontext samen met beveiligingsbewijs als leidraad voor gesprekken met de juiste mensen."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest relevante personeelsinformatie zonder personeelsdossiers te wijzigen of salarisverwerking uit te voeren."
          }
        ],
        "description_long": "Deel helpt bij het beheren van personeel met verschillende rollen en werkregelingen. Koppel het zodat Moxso relevante personeelscontext kan meewegen bij het beoordelen van menselijke risico's en het plannen van beveiligingsopvolging.",
        "description_short": "Voeg personeelscontext uit wereldwijde medewerkersdossiers toe.",
        "title": "Deel"
      },
      "drata": {
        "bullets": [
          {
            "label": "Beschermingssignalen",
            "text": "{label}: Ondersteunde controles op versleuteling, antivirus, firewall, updates en schermvergrendeling helpen zwakke plekken te identificeren."
          },
          {
            "label": "Dagelijkse beveiliging",
            "text": "{label}: Controles op wachtwoordmanagers en andere beschikbare beheersmaatregelen voegen context toe voor praktische beveiligingsgewoonten."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Gebruik specifieke hiaten om te bepalen waar advies aan medewerkers nodig is en waar IT actie moet ondernemen."
          },
          {
            "label": "Doorlopende verbetering",
            "text": "{label}: Bekijk veranderende controleresultaten samen met ander bewijs van menselijke risico's."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerd beveiligingsbewijs zonder resultaten van beheersmaatregelen of apparaatinstellingen te wijzigen."
          }
        ],
        "description_long": "Drata verzamelt bewijs over beveiligingsmaatregelen op de werkplek. Koppel het zodat Moxso relevante hiaten in beheersmaatregelen kan gebruiken als context voor menselijke risico's en gerichtere opvolging.",
        "description_short": "Gebruik beveiligingscontroles voor apparaten en werkplekken om hiaten in de bescherming te identificeren.",
        "title": "Drata"
      },
      "duo": {
        "bullets": [
          {
            "label": "Echte authenticatiesignalen",
            "text": "{label}: Gebeurtenissen rond geslaagde, geweigerde en mislukte authenticatie en gemelde fraude helpen activiteit te identificeren die beoordeling vereist."
          },
          {
            "label": "Nuttige context",
            "text": "{label}: Beschikbare authenticatiefactoren en redenen voor resultaten helpen verklaren wat er is gebeurd."
          },
          {
            "label": "Gericht advies",
            "text": "{label}: Richt advies op het herkennen van onverwachte verzoeken en het beschermen van toegang waar relevante gebeurtenissen optreden."
          },
          {
            "label": "Herhaalde activiteit",
            "text": "{label}: Bekijk terugkerende weigeringen of mislukkingen samen met ander bewijs voordat je een actie bepaalt."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest authenticatie- en geselecteerde beveiligingsactiviteit zonder verzoeken goed te keuren of Duo-beleid te wijzigen."
          }
        ],
        "description_long": "Duo helpt accounts te beschermen met multifactorauthenticatie. Koppel het zodat Moxso echte authenticatieresultaten kan gebruiken als leidraad voor opvolging rond MFA-gewoonten en accountbeveiliging.",
        "description_short": "Gebruik authenticatieresultaten voor gerichte opvolging rond MFA en accountbeveiliging.",
        "title": "Duo"
      },
      "fortinet_fortianalyzer": {
        "bullets": [
          {
            "label": "Toegangssignalen",
            "text": "{label}: Ondersteunde authenticatieresultaten helpen accountactiviteit te identificeren die onderzoek verdient."
          },
          {
            "label": "Gevoelige wijzigingen",
            "text": "{label}: Beheergebeurtenissen voegen bewijs toe van wijzigingen die je omgeving beïnvloeden."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Gebruik relevante accountactiviteit als leidraad voor onderzoek en advies over toegangsbeveiliging."
          },
          {
            "label": "Terugkerende patronen",
            "text": "{label}: Bekijk herhaalde toegangsproblemen samen met andere signalen voordat je een reactie kiest."
          },
          {
            "label": "Gegevenstoegang",
            "text": "{label}: Gebruikt logzoekopdrachten om geselecteerde gebeurtenissen te lezen zonder de firewallconfiguratie te wijzigen."
          }
        ],
        "description_long": "FortiAnalyzer verzamelt beveiligingsactiviteit uit je Fortinet-omgeving. Koppel het zodat Moxso geselecteerde toegangs- en beheergebeurtenissen kan gebruiken voor beoordelingen van menselijke risico's.",
        "description_short": "Beoordeel authenticatie- en beheergebeurtenissen uit je Fortinet-omgeving.",
        "title": "FortiAnalyzer"
      },
      "github_enterprise": {
        "bullets": [
          {
            "label": "Gevoelige wijzigingen",
            "text": "{label}: Geselecteerde auditgebeurtenissen maken wijzigingen in toegang, rechten en accountbeveiliging zichtbaar."
          },
          {
            "label": "Codetoegangsactiviteit",
            "text": "{label}: Ondersteunde Git-gebeurtenissen leveren aanvullend bewijs over toegang tot repositories."
          },
          {
            "label": "Relevant advies",
            "text": "{label}: Gebruik medewerkergerelateerde gebeurtenissen voor advies gericht op de bescherming van inloggegevens en veilige ontwikkelpraktijken."
          },
          {
            "label": "Patronen in de tijd",
            "text": "{label}: Bekijk herhaalde toegangsactiviteit en gevoelige wijzigingen in hun werkcontext."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde activiteitsmetadata zonder toegang tot de broncode in repositories."
          }
        ],
        "description_long": "GitHub Enterprise beschermt de toegang tot je broncode en ontwikkelworkflows. Koppel het zodat Moxso relevante activiteit van ontwikkelaarsaccounts kan gebruiken voor inzicht in menselijke risico's en gerichte beveiligingsopvolging.",
        "description_short": "Gebruik activiteit van ontwikkelaarsaccounts en repositorytoegang voor gerichte beveiligingsopvolging.",
        "title": "GitHub Enterprise"
      },
      "google_workspace": {
        "bullets": [
          {
            "label": "Signalen van werkelijke activiteit",
            "text": "{label}: Geselecteerde aanmeld-, accountbeveiligings- en beheerdersgebeurtenissen maken activiteit zichtbaar die beoordeling verdient."
          },
          {
            "label": "Risico's bij delen",
            "text": "{label}: Ondersteunde downloads, wijzigingen in delen en applicatieautorisatiegebeurtenissen leveren bewijs van hoe informatie wordt benaderd."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Richt advies op accountbescherming, apps van derden en veilig delen waar het bewijs op een behoefte wijst."
          },
          {
            "label": "Patronen in de tijd",
            "text": "{label}: Bekijk herhaalde gebeurtenissen en veranderend toegangsgedrag samen met bewustwordingsresultaten."
          },
          {
            "label": "Leestoegang",
            "text": "{label}: Leest geselecteerde beveiligingsmetadata zonder Gmail-berichten of de inhoud van Drive-bestanden te lezen."
          }
        ],
        "description_long": "Google Workspace is waar mensen zich aanmelden, bestanden delen en applicaties autoriseren. Koppel het zodat Moxso beveiligingsrelevante activiteit kan gebruiken voor inzicht in menselijke risico's en om opvolging relevanter te maken voor het dagelijkse werk.",
        "description_short": "Beoordeel aanmeld-, deel- en applicatietoegangsactiviteit voor inzicht in menselijke risico's.",
        "title": "Google Workspace"
      },
      "gusto": {
        "bullets": [
          {
            "label": "Inzicht in rollen",
            "text": "{label}: Functie- en afdelingscontext helpen het werk achter de activiteit van een account te verklaren."
          },
          {
            "label": "Wijzigingen in dienstverband",
            "text": "{label}: Beschikbare informatie over de dienstverbandstatus ondersteunt gesprekken over toegang wanneer omstandigheden veranderen."
          },
          {
            "label": "Relevant advies",
            "text": "{label}: Houd rekening met verantwoordelijkheden bij het kiezen van bewustwordingsonderwerpen en praktisch beveiligingsadvies."
          },
          {
            "label": "Gerichte beoordelingen",
            "text": "{label}: Gebruik dienstverbandcontext samen met beveiligingssignalen om te bepalen wat aandacht nodig heeft."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest relevante dienstverbandinformatie zonder beloning te wijzigen of salarisverwerking uit te voeren."
          }
        ],
        "description_long": "Gusto houdt dienstverbandinformatie bij wanneer mensen in dienst komen, van rol veranderen en vertrekken. Koppel het zodat Moxso die context kan meewegen bij het beoordelen van menselijke risico's en het afstemmen van opvolging op iemands verantwoordelijkheden.",
        "description_short": "Voeg personeelscontext uit medewerkersdossiers toe.",
        "title": "Gusto"
      },
      "hibob": {
        "bullets": [
          {
            "label": "Rolcontext",
            "text": "{label}: Verantwoordelijkheden en afdelingen helpen beveiligingsactiviteit in perspectief te plaatsen."
          },
          {
            "label": "Werkomgeving",
            "text": "{label}: Beschikbare informatie over de werklocatie voegt context toe om iemands omstandigheden te begrijpen."
          },
          {
            "label": "Levenscycluswijzigingen",
            "text": "{label}: Wijzigingen in de dienstverbandstatus kunnen gesprekken over accounttoegang en beveiligingsverantwoordelijkheden ondersteunen."
          },
          {
            "label": "Relevante opvolging",
            "text": "{label}: Gebruik de werkcontext samen met daadwerkelijk beveiligingsbewijs als leidraad voor praktisch advies."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest relevante personeelsinformatie zonder HR-dossiers te wijzigen of via deze koppeling toegang te krijgen tot prestatiebeoordelingen."
          }
        ],
        "description_long": "HiBob biedt context over de rollen en werkomgeving van mensen. Koppel het zodat Moxso die context kan meewegen naast menselijke risico's en beveiligingsopvolging relevanter kan maken voor het dagelijkse werk.",
        "description_short": "Voeg medewerker- en functiecontext uit je HR-systeem toe.",
        "title": "HiBob"
      },
      "hubspot": {
        "bullets": [
          {
            "label": "Aanmeldsignalen",
            "text": "{label}: Geslaagde en mislukte aanmeldgebeurtenissen helpen problemen met accounttoegang te identificeren."
          },
          {
            "label": "Gevoelige acties",
            "text": "{label}: Geselecteerde gebeurtenissen rond rechten, inloggegevens, integraties en gegevensverplaatsing voegen context toe."
          },
          {
            "label": "Relevant advies",
            "text": "{label}: Gebruik medewerkergerelateerde activiteit voor advies gericht op accountbeveiliging en het omgaan met klantinformatie."
          },
          {
            "label": "Terugkerende problemen",
            "text": "{label}: Bekijk herhaalde gebeurtenissen samen met ander risicobewijs voordat je een reactie kiest."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde beveiligingsactiviteit zonder toegang tot CRM-contacten, deals of marketinginhoud."
          }
        ],
        "description_long": "HubSpot ondersteunt het werken met klantinformatie. Koppel het zodat Moxso relevante accounttoegangs- en beveiligingsgebeurtenissen kan gebruiken voor inzicht in menselijke risico's en om opvolging op dat werk af te stemmen.",
        "description_short": "Beoordeel aanmeld- en beveiligingsactiviteit rond toegang tot klantinformatie.",
        "title": "HubSpot"
      },
      "iru": {
        "bullets": [
          {
            "label": "Beschermingsdekking",
            "text": "{label}: Indicatoren voor beheer- en agentstatus helpen apparaten te identificeren die aandacht nodig hebben."
          },
          {
            "label": "Apparaatbeschikbaarheid",
            "text": "{label}: Indicatoren voor de laatste check-in en ontbrekende apparaten bieden context over de actualiteit van beschermingsinformatie."
          },
          {
            "label": "Relevante activiteit",
            "text": "{label}: Geselecteerde beveiligingsgerelateerde auditgebeurtenissen helpen wijzigingen te verklaren die beoordeling rechtvaardigen."
          },
          {
            "label": "Praktische opvolging",
            "text": "{label}: Gebruik hiaten in de bescherming als leidraad voor actie met medewerkers en IT."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde apparaatbeveiligingsinformatie zonder acties op apparaten uit te voeren."
          }
        ],
        "description_long": "Iru helpt organisaties werkapparaten te beheren en te beschermen. Koppel het zodat Moxso hiaten in de dekking van apparaatbeheer kan meewegen bij het beoordelen van menselijke risico's.",
        "description_short": "Identificeer hiaten in de dekking van apparaatbeheer en agentbescherming.",
        "title": "Iru"
      },
      "jamf_pro": {
        "bullets": [
          {
            "label": "Apparaatbescherming",
            "text": "{label}: Ondersteunde informatie over FileVault en toegangscodes kan beveiligingsinstellingen zichtbaar maken die aandacht nodig hebben."
          },
          {
            "label": "Beheerdekking",
            "text": "{label}: De beschikbare beheerstatus helpt vast te stellen of een apparaat onder controle van de organisatie staat."
          },
          {
            "label": "Praktische opvolging",
            "text": "{label}: Hiaten in de bescherming kunnen richting geven aan gesprekken met medewerkers en het IT-team dat verantwoordelijk is voor hun apparaten."
          },
          {
            "label": "Onderbouwde beoordelingen",
            "text": "{label}: Bekijk de toestand van apparaten samen met ander bewijs in plaats van een niet-geslaagde controle als bewijs van onveilig gedrag te beschouwen."
          },
          {
            "label": "Koppelingsstatus",
            "text": "{label}: Deze integratie kan momenteel niet worden gekoppeld via de geregistreerde providercatalogus."
          }
        ],
        "description_long": "Beschikbaarheid: Momenteel niet beschikbaar. Jamf Pro helpt de Apple-apparaten te beschermen die mensen voor hun werk gebruiken. Apparaatbeveiligingsinformatie kan menselijke risico's in context plaatsen en hiaten in de bescherming onderscheiden van problemen die advies aan medewerkers vereisen.",
        "description_short": "Beheer van Apple-apparaten. Deze integratie is momenteel niet beschikbaar.",
        "title": "Jamf Pro"
      },
      "jumpcloud": {
        "bullets": [
          {
            "label": "Authenticatiebewijs",
            "text": "{label}: Geselecteerde Directory Insights-gebeurtenissen tonen geslaagde en mislukte toegangspogingen."
          },
          {
            "label": "Gevoelige activiteit",
            "text": "{label}: Ondersteunde beheer- en geprivilegieerde-toegangsgebeurtenissen maken wijzigingen zichtbaar die aandacht verdienen."
          },
          {
            "label": "Relevante opvolging",
            "text": "{label}: Gebruik accountgerelateerd bewijs als leidraad voor onderzoek en advies over toegangsbeveiliging."
          },
          {
            "label": "Patronen in de tijd",
            "text": "{label}: Beoordeel terugkerende authenticatieproblemen en gevoelige wijzigingen samen met andere signalen."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde beveiligingsinformatie zonder JumpCloud-instellingen te wijzigen."
          }
        ],
        "description_long": "JumpCloud helpt de toegang tot applicaties en apparaten te beveiligen. Koppel het zodat Moxso echte authenticatie- en beheersignalen kan gebruiken voor inzicht in menselijke risico's en opvolging gericht op relevante toegangsproblemen.",
        "description_short": "Gebruik authenticatie- en beheergebeurtenissen om toegangsrisico's te beoordelen.",
        "title": "JumpCloud"
      },
      "lattice": {
        "bullets": [
          {
            "label": "Inzicht in rollen",
            "text": "{label}: Functie- en afdelingscontext helpen iemands verantwoordelijkheden te verklaren."
          },
          {
            "label": "Accountlevenscyclus",
            "text": "{label}: Beschikbare accountstatusinformatie voegt context toe wanneer mensen een applicatie gaan gebruiken of verlaten."
          },
          {
            "label": "Relevant advies",
            "text": "{label}: Houd rekening met werkverantwoordelijkheden bij het kiezen van beveiligingsonderwerpen en praktisch advies."
          },
          {
            "label": "Gerichte beoordelingen",
            "text": "{label}: Gebruik organisatiecontext samen met beveiligingsbewijs bij het bespreken van toegang en opvolging."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest relevante account- en organisatie-informatie zonder via deze koppeling toegang te krijgen tot prestatiebeoordelingen, feedback of beloning."
          }
        ],
        "description_long": "Lattice biedt context over rollen en organisatorische verantwoordelijkheden. Koppel het zodat Moxso die context kan meewegen bij het beoordelen van menselijke risico's en het kiezen van relevante beveiligingsopvolging.",
        "description_short": "Voeg context over medewerkersprofielen en teamstructuur toe.",
        "title": "Lattice"
      },
      "linear": {
        "bullets": [
          {
            "label": "Accountwijzigingen",
            "text": "{label}: Ondersteunde auditgebeurtenissen identificeren beveiligingsrelevante wijzigingen, zoals accountopschorting."
          },
          {
            "label": "Toegangscontext",
            "text": "{label}: Beschikbare details over actor en actie helpen verklaren wat er is gebeurd."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Gebruik relevante gebeurtenissen als leidraad voor accounttoegangsbeoordelingen en beveiligingsgesprekken."
          },
          {
            "label": "Patronen in de tijd",
            "text": "{label}: Bekijk terugkerende wijzigingen samen met andere beveiligingssignalen."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde auditmetadata zonder toegang tot de inhoud van issues. Auditlogboeken vereisen een geschikt Enterprise-abonnement."
          }
        ],
        "description_long": "Linear ondersteunt samenwerking tussen product- en engineeringteams. Koppel het zodat Moxso geselecteerde account- en toegangswijzigingen kan gebruiken voor inzicht in menselijke risico's en gerichte beveiligingsopvolging.",
        "description_short": "Beoordeel account- en toegangswijzigingen binnen product- en engineeringteams.",
        "title": "Linear"
      },
      "microsoft_defender_xdr": {
        "bullets": [
          {
            "label": "Echte dreigingssignalen",
            "text": "{label}: Waarschuwingen en incidenten identificeren activiteit die Microsoft als verdacht of kwaadaardig beschouwt."
          },
          {
            "label": "Blootstellingscontext",
            "text": "{label}: Beschikbare endpointbevindingen en kwetsbaarheden helpen de omstandigheden rond een gebeurtenis te verklaren."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Geef prioriteit aan onderzoek en relevant beveiligingsadvies wanneer bevindingen betrekking hebben op mensen of hun werkapparaten."
          },
          {
            "label": "Onderzoeksvoortgang",
            "text": "{label}: Wijzigingen in de bevindingstatus helpen actieve problemen te onderscheiden van opgelost werk."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde bevindingen zonder apparaten te isoleren, incidenten te sluiten of oplossingen toe te passen."
          }
        ],
        "description_long": "Microsoft Defender XDR identificeert dreigingen in je Microsoft-omgeving. Koppel het zodat Moxso relevante waarschuwingen en incidenten kan gebruiken om beoordelingen van menselijke risico's te baseren op echte beveiligingsgebeurtenissen.",
        "description_short": "Neem Microsoft-beveiligingswaarschuwingen, incidenten en kwetsbaarheden op in risicobeoordelingen.",
        "title": "Microsoft Defender XDR"
      },
      "microsoft_entra": {
        "bullets": [
          {
            "label": "Echte aanvalssignalen",
            "text": "{label}: Gelekte inloggegevens, password spraying, ongebruikelijke reisbewegingen en onbekende aanmeldingen kunnen accounts aan het licht brengen die aandacht nodig hebben."
          },
          {
            "label": "Context van menselijke risico's",
            "text": "{label}: Risiconiveaus en detectiedetails helpen verdachte activiteit in perspectief te plaatsen."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Richt onderzoek en advies over accountbeveiliging op de mensen die door relevante gebeurtenissen worden getroffen."
          },
          {
            "label": "Risico in de tijd",
            "text": "{label}: Wijzigingen van actief risico naar verholpen of afgewezen helpen bepalen wat nog aandacht nodig heeft."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest de status van risicovolle gebruikers en risicodetecties. Het detailniveau van signalen hangt af van Microsoft-licenties; premiumdetecties kunnen Entra ID P2 vereisen."
          }
        ],
        "description_long": "Entra ID Protection markeert aanmeldingen en accounts die gecompromitteerd lijken. Koppel het zodat Moxso echte identiteitsrisicosignalen kan gebruiken voor gerichte opvolging, gebaseerd op wat er naast simulaties in je omgeving gebeurt.",
        "description_short": "Gebruik risicovolle aanmeldingen en signalen van accountcompromittering voor gerichte beveiligingsopvolging.",
        "title": "Microsoft Entra ID Protection"
      },
      "microsoft_intune": {
        "bullets": [
          {
            "label": "Apparaatbeveiligingssignalen",
            "text": "{label}: Beschikbare compliance- en versleutelingsstatussen maken hiaten in de bescherming zichtbaar."
          },
          {
            "label": "Relevante wijzigingen",
            "text": "{label}: Geselecteerde beheergebeurtenissen voegen context toe over acties die apparaatbeveiliging beïnvloeden."
          },
          {
            "label": "Praktische opvolging",
            "text": "{label}: Help een apparaatprobleem dat IT-aandacht vereist te onderscheiden van een onderwerp dat geschikt is voor advies aan medewerkers."
          },
          {
            "label": "Veranderende beveiligingsstatus",
            "text": "{label}: Houd bij het beoordelen van risico's rekening met de huidige beschermingsstatus en terugkerende hiaten."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde apparaatbeveiligings- en auditinformatie zonder apparaatinstellingen te wijzigen. Vereist de relevante Intune-toegang en -licentie."
          }
        ],
        "description_long": "Microsoft Intune helpt de apparaten te beschermen die mensen voor hun werk gebruiken. Koppel het zodat Moxso de endpointbeveiligingsstatus kan meewegen naast menselijke risico's en richting kan geven aan praktische opvolging.",
        "description_short": "Beoordeel apparaatcompliance en hiaten in versleuteling naast menselijke risico's.",
        "title": "Microsoft Intune"
      },
      "microsoft_purview": {
        "bullets": [
          {
            "label": "Gegevensbeschermingssignalen",
            "text": "{label}: Ondersteunde DLP-gebeurtenissen identificeren activiteit die een regel voor gegevensverwerking heeft geactiveerd."
          },
          {
            "label": "Aanvullende risicocontext",
            "text": "{label}: Geselecteerde gebeurtenissen rond interne risico's voegen waar beschikbaar bewijs voor onderzoek toe."
          },
          {
            "label": "Relevant advies",
            "text": "{label}: Gebruik de omstandigheden van een gebeurtenis voor advies gericht op het veilig verwerken en delen van bedrijfsinformatie."
          },
          {
            "label": "Onderbouwde beoordeling",
            "text": "{label}: Bekijk herhaalde signalen en hun context voordat je conclusies trekt over gedrag of intentie."
          },
          {
            "label": "Beperkte toegang",
            "text": "{label}: Leest geselecteerde activiteitsmetadata en kan de vereiste feeds initialiseren. Het gegevensbeschermingsbeleid wordt niet gewijzigd."
          }
        ],
        "description_long": "Microsoft Purview helpt risicovolle omgang met gevoelige informatie te identificeren. Koppel het zodat Moxso relevante gegevensbeschermingssignalen kan gebruiken als leidraad voor beoordelingen van menselijke risico's en gerichtere opvolging.",
        "description_short": "Gebruik gebeurtenissen rond gegevensbescherming en interne risico's om veilige omgang met informatie te stimuleren.",
        "title": "Microsoft Purview"
      },
      "microsoft_sentinel": {
        "bullets": [
          {
            "label": "Echte incidenten",
            "text": "{label}: Ernst en incidentdetails leveren bewijs van beveiligingsproblemen die al worden onderzocht."
          },
          {
            "label": "Nuttige context",
            "text": "{label}: Beschikbare bron- en aanvalsinformatie helpen verklaren waarom een incident belangrijk is."
          },
          {
            "label": "Gecoördineerde opvolging",
            "text": "{label}: Gebruik relevant incidentbewijs om advies aan medewerkers af te stemmen op de respons van het beveiligingsteam."
          },
          {
            "label": "Onderzoeksvoortgang",
            "text": "{label}: Statuswijzigingen helpen nieuwe, actieve en opgeloste problemen te onderscheiden."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest incidentinformatie zonder onderzoeken te wijzigen of algemene logzoekopdrachten uit te voeren."
          }
        ],
        "description_long": "Microsoft Sentinel brengt beveiligingsincidenten samen voor onderzoek. Koppel het zodat Moxso relevante incidenten kan meewegen naast menselijke risico's en de opvolging kan helpen afstemmen met je beveiligingsteam.",
        "description_short": "Gebruik beveiligingsincidenten en onderzoeksstatus om opvolging te coördineren.",
        "title": "Microsoft Sentinel"
      },
      "monday": {
        "bullets": [
          {
            "label": "Accountstatus",
            "text": "{label}: Beschikbare actieve en inactieve statussen helpen accounts te identificeren die mogelijk beoordeling vereisen."
          },
          {
            "label": "Toegangscontext",
            "text": "{label}: Accounttypen en teamrelaties helpen applicatietoegang in perspectief te plaatsen."
          },
          {
            "label": "Gerichte beoordelingen",
            "text": "{label}: Bekijk accountcontext samen met beveiligingssignalen om te bepalen waar aandacht nodig is."
          },
          {
            "label": "Relevante opvolging",
            "text": "{label}: Gebruik die context als leidraad voor gesprekken over accountbeveiliging en passende toegang."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest accounttoegangsinformatie zonder monday.com-instellingen te wijzigen of toegang te krijgen tot de inhoud van borden en items."
          }
        ],
        "description_long": "monday.com helpt teams werk te organiseren en over afdelingen heen samen te werken. Koppel het zodat Moxso applicatietoegangscontext kan meewegen naast menselijke risico's en de opvolging van accountbeveiliging relevanter kan maken.",
        "description_short": "Gebruik accountstatus en teamrelaties voor toegangsbeoordelingen.",
        "title": "monday.com"
      },
      "new_relic": {
        "bullets": [
          {
            "label": "Toegangscontext",
            "text": "{label}: Beschikbare accountrelaties helpen toegang tot je monitoringomgeving in perspectief te plaatsen."
          },
          {
            "label": "Organisatiecontext",
            "text": "{label}: Groepslidmaatschap biedt achtergrond voor het beoordelen van de manier waarop toegang is georganiseerd."
          },
          {
            "label": "Gerichte beoordelingen",
            "text": "{label}: Bekijk applicatietoegang samen met ander bewijs om te bepalen wat aandacht nodig heeft."
          },
          {
            "label": "Relevante opvolging",
            "text": "{label}: Gebruik toegangscontext als leidraad voor gesprekken over accountbeveiliging met de verantwoordelijke teams."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest accounttoegangsinformatie zonder New Relic-instellingen te wijzigen. Deze koppeling verzamelt geen monitoringwaarschuwingen, applicatietelemetrie of auditgebeurtenissen."
          }
        ],
        "description_long": "New Relic ondersteunt de teams die verantwoordelijk zijn voor het monitoren van je systemen. Koppel het zodat Moxso applicatietoegangscontext kan meewegen naast menselijke risico's en gerichte accountbeveiligingsbeoordelingen kan ondersteunen.",
        "description_short": "Voeg gebruikersdirectory- en groepslidmaatschapscontext uit New Relic toe.",
        "title": "New Relic"
      },
      "okta": {
        "bullets": [
          {
            "label": "Authenticatiesignalen",
            "text": "{label}: Aanmeldresultaten en geselecteerde beveiligingsgebeurtenissen leveren bewijs van hoe accounts worden gebruikt."
          },
          {
            "label": "Gevoelige wijzigingen",
            "text": "{label}: Account- en rechtenwijzigingen helpen toegang te identificeren die nader onderzoek verdient."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Gebruik relevante gebeurtenissen als leidraad voor onderzoek en praktisch advies over accountbeveiliging."
          },
          {
            "label": "Terugkerende problemen",
            "text": "{label}: Bekijk herhaalde authenticatieproblemen samen met ander bewijs van menselijke risico's."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde beveiligingsinformatie zonder Okta-accounts of toegangsbeleid te wijzigen."
          }
        ],
        "description_long": "Okta beschermt de toegang tot bedrijfsapplicaties. Koppel het zodat Moxso authenticatie- en accountbeveiligingssignalen kan gebruiken om echte toegangsrisico's te begrijpen en richting te geven aan relevantere opvolging.",
        "description_short": "Beoordeel authenticatie- en accountbeveiligingsgebeurtenissen om toegangsrisico's te begrijpen.",
        "title": "Okta"
      },
      "oneleet": {
        "bullets": [
          {
            "label": "Bevestigde zwakke plekken",
            "text": "{label}: Beschikbare pentestbevindingen beschrijven problemen die tijdens beveiligingstests zijn vastgesteld."
          },
          {
            "label": "Risicocontext",
            "text": "{label}: Prioriteit, getroffen doelen en hersteladvies helpen verklaren wat aandacht nodig heeft."
          },
          {
            "label": "Gerichte actie",
            "text": "{label}: Gebruik relevante bevindingen als leidraad voor technisch herstel en beveiligingsgesprekken met de verantwoordelijke teams."
          },
          {
            "label": "Voortgang in de tijd",
            "text": "{label}: De bevindingstatus helpt openstaande problemen te onderscheiden van reeds aangepakt werk."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest bevindingen zonder tests uit te voeren of hun oplossingsstatus te wijzigen."
          }
        ],
        "description_long": "Oneleet identificeert beveiligingszwakheden via penetratietests en compliancewerk. Koppel het om relevante technische bevindingen toe te voegen aan de context voor beoordelingen van menselijke risico's en beveiligingsopvolging.",
        "description_short": "Voeg penetratietestbevindingen en herstelcontext toe aan beveiligingsbeoordelingen.",
        "title": "Oneleet"
      },
      "onepassword": {
        "bullets": [
          {
            "label": "Aanmeldsignalen",
            "text": "{label}: Geslaagde en mislukte pogingen leveren bewijs van accounttoegangsactiviteit."
          },
          {
            "label": "Gevoelige acties",
            "text": "{label}: Ondersteunde itemgebruiks- en beheergebeurtenissen voegen context toe over hoe de wachtwoordmanager wordt gebruikt."
          },
          {
            "label": "Gerichte opvolging",
            "text": "{label}: Richt advies over de beveiliging van inloggegevens en onderzoek op relevante activiteit."
          },
          {
            "label": "Patronen in de tijd",
            "text": "{label}: Bekijk herhaalde toegangsproblemen samen met ander accountbeveiligingsbewijs."
          },
          {
            "label": "Geen geheime inhoud",
            "text": "{label}: Leest activiteitsmetadata zonder toegang tot wachtwoorden, beveiligde notities of kluisdocumenten."
          }
        ],
        "description_long": "1Password helpt mensen hun inloggegevens te beschermen en te gebruiken. Koppel het zodat Moxso aanmeld- en wachtwoordmanageractiviteit kan gebruiken voor inzicht in menselijke risico's zonder toegang tot de geheimen die in je kluizen zijn opgeslagen.",
        "description_short": "Beoordeel aanmeld- en wachtwoordmanageractiviteit zonder toegang tot opgeslagen geheimen.",
        "title": "1Password"
      },
      "ping_one": {
        "bullets": [
          {
            "label": "Accountstatus",
            "text": "{label}: Beschikbare informatie over ingeschakelde accounts biedt context voor toegangsbeoordelingen."
          },
          {
            "label": "Toegangsrelaties",
            "text": "{label}: Groepslidmaatschap helpt verklaren hoe accounts zijn georganiseerd."
          },
          {
            "label": "Gerichte beoordelingen",
            "text": "{label}: Bekijk toegangscontext samen met beveiligingsgebeurtenissen uit je andere gekoppelde tools."
          },
          {
            "label": "Relevante opvolging",
            "text": "{label}: Gebruik het gecombineerde bewijs als leidraad voor gesprekken over accountbeveiliging en toegangsbeoordelingen."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest accounttoegangsinformatie zonder PingOne-beleid te wijzigen. Deze koppeling verzamelt geen authenticatiegebeurtenissen."
          }
        ],
        "description_long": "PingOne helpt toegang tot bedrijfsapplicaties te beheren. Koppel het zodat Moxso relevante accounttoegangscontext kan meewegen naast menselijke risico's en richting kan geven aan gerichtere beveiligingsbeoordelingen.",
        "description_short": "Voeg gebruikersdirectory- en lidmaatschapscontext uit PingOne toe.",
        "title": "PingOne"
      },
      "remote": {
        "bullets": [
          {
            "label": "Rolcontext",
            "text": "{label}: Beschikbare informatie over verantwoordelijkheden en afdelingen helpt beveiligingsproblemen in perspectief te plaatsen."
          },
          {
            "label": "Werkregelingen",
            "text": "{label}: Context over land en dienstverbandvorm kan helpen advies af te stemmen op iemands omstandigheden."
          },
          {
            "label": "Wijzigingen in dienstverband",
            "text": "{label}: Beschikbare levenscyclusinformatie ondersteunt gesprekken over toegang wanneer werkregelingen veranderen."
          },
          {
            "label": "Relevante opvolging",
            "text": "{label}: Bekijk personeelscontext samen met beveiligingsbewijs bij het kiezen van praktisch advies."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest relevante dienstverbandinformatie zonder contracten te wijzigen of salarisverwerking uit te voeren."
          }
        ],
        "description_long": "Remote helpt mensen in verschillende landen en dienstverbandvormen te beheren. Koppel het zodat Moxso relevante werkcontext kan meewegen bij het beoordelen van menselijke risico's en het plannen van beveiligingsopvolging.",
        "description_short": "Voeg personeelscontext toe voor wereldwijde en verspreide teams.",
        "title": "Remote"
      },
      "rippling": {
        "bullets": [
          {
            "label": "Inzicht in rollen",
            "text": "{label}: Informatie over functie en werkcontext helpt de verantwoordelijkheden achter accountactiviteit te verklaren."
          },
          {
            "label": "Dienstverbandcontext",
            "text": "{label}: Beschikbare personeelsstatus voegt achtergrond toe voor toegangsbeoordelingen wanneer omstandigheden veranderen."
          },
          {
            "label": "Relevant advies",
            "text": "{label}: Houd rekening met iemands verantwoordelijkheden bij het kiezen van beveiligingsadvies en bewustwordingsonderwerpen."
          },
          {
            "label": "Gerichte beoordelingen",
            "text": "{label}: Gebruik dienstverbandcontext samen met beveiligingsbewijs als basis voor gesprekken over toegang en opvolging."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest relevante personeelsinformatie zonder salarisadministratie, arbeidsvoorwaarden of toegangsinstellingen in Rippling te wijzigen."
          }
        ],
        "description_long": "Rippling houdt context bij over de rollen en dienstverbanden van mensen. Koppel het zodat Moxso die context kan meewegen naast menselijke risico's en beveiligingsopvolging relevant kan maken wanneer verantwoordelijkheden veranderen.",
        "description_short": "Voeg medewerker- en personeelscontext uit Rippling toe.",
        "title": "Rippling"
      },
      "sentinel_one": {
        "bullets": [
          {
            "label": "Echte dreigingssignalen",
            "text": "{label}: Dreigingen en waarschuwingen identificeren verdachte activiteit die werkapparaten beïnvloedt."
          },
          {
            "label": "Risicocontext",
            "text": "{label}: Beschikbare informatie over ernst, classificatie en kwetsbaarheden helpt verklaren wat aandacht nodig heeft."
          },
          {
            "label": "Gerichte actie",
            "text": "{label}: Gebruik het bewijs om onderzoek te coördineren en te bepalen of opvolging bij IT, beveiliging of een medewerker hoort."
          },
          {
            "label": "Veranderende status",
            "text": "{label}: Updates van bevindingen helpen aanhoudende problemen te onderscheiden van reeds aangepakte activiteit."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde beveiligingsinformatie zonder apparaten te isoleren of dreigingen te verhelpen."
          }
        ],
        "description_long": "SentinelOne detecteert en onderzoekt endpointdreigingen. Koppel het zodat Moxso relevante dreigingssignalen kan gebruiken voor inzicht in menselijke risico's en gerichte beveiligingsopvolging.",
        "description_short": "Gebruik endpointdreigingen en kwetsbaarheidsbevindingen voor gerichte beveiligingsopvolging.",
        "title": "SentinelOne"
      },
      "slack": {
        "bullets": [
          {
            "label": "Werkelijke accountactiviteit",
            "text": "{label}: Ondersteunde aanmeld- en toegangsgebeurtenissen helpen accountbeveiligingsproblemen aan het licht te brengen."
          },
          {
            "label": "Deelsignalen",
            "text": "{label}: Geselecteerde bestandsgerelateerde en deelgebeurtenissen voegen bewijs toe over hoe met informatie wordt omgegaan."
          },
          {
            "label": "Gericht advies",
            "text": "{label}: Richt advies op veilig samenwerken, accountbescherming en informatie delen waar relevante gebeurtenissen optreden."
          },
          {
            "label": "Patronen in de tijd",
            "text": "{label}: Bekijk terugkerende activiteit samen met bewustwordings- en simulatieresultaten."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde auditmetadata zonder berichten of bestandsinhoud te lezen. Audittoegang vereist een geschikte Slack Enterprise-organisatie."
          }
        ],
        "description_long": "Slack is waar mensen de hele dag samenwerken en informatie delen. Koppel het zodat Moxso relevante aanmeld- en deelsignalen kan gebruiken voor inzicht in menselijke risico's en praktischere opvolging.",
        "description_short": "Gebruik aanmeld- en deelactiviteit om veiligere dagelijkse samenwerking te stimuleren.",
        "title": "Slack"
      },
      "splunk": {
        "bullets": [
          {
            "label": "Beveiligingsbevindingen",
            "text": "{label}: Geselecteerde bevindingen maken activiteit zichtbaar die je beveiligingsmonitoring heeft aangemerkt voor aandacht."
          },
          {
            "label": "Accountactiviteit",
            "text": "{label}: Ondersteunde authenticatie- en beheergebeurtenissen leveren aanvullend bewijs voor onderzoek."
          },
          {
            "label": "Relevante opvolging",
            "text": "{label}: Gebruik bevindingen die betrekking hebben op mensen of hun accounts als leidraad voor beveiligingsacties en advies."
          },
          {
            "label": "Veranderend risico",
            "text": "{label}: Een bijgewerkte bevindingstatus helpt aanhoudende problemen in context te plaatsen."
          },
          {
            "label": "Gegevenstoegang",
            "text": "{label}: Gebruikt zoekopdrachten om geselecteerde beveiligingsinformatie te lezen zonder de onderliggende bevindingen te wijzigen."
          }
        ],
        "description_long": "Splunk brengt beveiligingsbewijs uit je hele omgeving samen. Koppel het zodat Moxso geselecteerde bevindingen en accountgerelateerde gebeurtenissen kan gebruiken voor inzicht in menselijke risico's en gerichte opvolging.",
        "description_short": "Breng beveiligingsbevindingen en accountactiviteit samen voor beoordelingen van menselijke risico's.",
        "title": "Splunk"
      },
      "statuspage": {
        "bullets": [
          {
            "label": "Service-incidenten",
            "text": "{label}: Gepubliceerde incidentinformatie verklaart storingen die door de service-eigenaar zijn gemeld."
          },
          {
            "label": "Getroffen services",
            "text": "{label}: Componentstatus helpt identificeren welke onderdelen van een service zijn getroffen."
          },
          {
            "label": "Gepland onderhoud",
            "text": "{label}: Onderhoudsmeldingen bieden context voor verwachte onderbrekingen."
          },
          {
            "label": "Responsvoortgang",
            "text": "{label}: Incidentupdates helpen verklaren of een probleem wordt onderzocht of is opgelost."
          },
          {
            "label": "Operationele context",
            "text": "{label}: Een servicestoring op zichzelf bewijst geen accountcompromittering of onveilig gedrag van medewerkers."
          }
        ],
        "description_long": "Redactionele status: Concept; de reikwijdte van de Moxso-integratie is niet geverifieerd in deze repository. Statuspage communiceert service-incidenten en onderhoud. Servicestatusinformatie kan nuttige achtergrond bieden tijdens beveiligingsopvolging en teams helpen begrijpen wanneer een toegangsprobleem samenvalt met een bekende storing.",
        "description_short": "Context over service-incidenten en onderhoud. De reikwijdte van de integratie is nog niet geverifieerd.",
        "title": "Statuspage"
      },
      "tailscale": {
        "bullets": [
          {
            "label": "Toegangsbeveiligingsstatus",
            "text": "{label}: Apparaatautorisatie en de status van externe toegang helpen omstandigheden te identificeren die controle verdienen."
          },
          {
            "label": "Beschermingscontext",
            "text": "{label}: Informatie over het verlopen van sleutels en de verbindingsstatus biedt aanvullende context rond netwerktoegang."
          },
          {
            "label": "Praktische opvolging",
            "text": "{label}: Gebruik relevante toegangsproblemen als leidraad voor apparaatbeveiligingscontroles met het verantwoordelijke team."
          },
          {
            "label": "Huidige omstandigheden",
            "text": "{label}: Beoordeel de toegangsbeveiligingsstatus wanneer deze verandert, in plaats van een oude momentopname als permanent te beschouwen."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest apparaattoegangsinformatie zonder netwerkautorisatie te wijzigen of verkeer vast te leggen."
          }
        ],
        "description_long": "Tailscale verbindt apparaten met je privénetwerk. Koppel het om de beveiligingsstatus van netwerktoegang toe te voegen aan de beveiligingscontext voor beoordelingen van menselijke risico's.",
        "description_short": "Beoordeel apparaatautorisatie en de bescherming van netwerktoegang naast menselijke risico's.",
        "title": "Tailscale"
      },
      "vanta": {
        "bullets": [
          {
            "label": "Signalen van beveiligingsmaatregelen",
            "text": "{label}: Beschikbare controles op versleuteling, schermvergrendeling, antivirus en wachtwoordmanagers maken hiaten in de bescherming zichtbaar."
          },
          {
            "label": "Duidelijkere context",
            "text": "{label}: Afzonderlijke controleresultaten bieden nuttigere details dan één enkel compliancelabel."
          },
          {
            "label": "Praktische opvolging",
            "text": "{label}: Gebruik relevante hiaten als leidraad voor actie met medewerkers en IT."
          },
          {
            "label": "Wijzigingen in de tijd",
            "text": "{label}: Houd bij het beoordelen van risico's rekening met huidige controleresultaten en terugkerende mislukkingen."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerd beveiligingsbewijs zonder complianceresultaten of apparaatinstellingen te wijzigen."
          }
        ],
        "description_long": "Vanta controleert of belangrijke beveiligingsmaatregelen aanwezig zijn. Koppel het zodat Moxso relevante hiaten in de bescherming kan meewegen naast menselijke risico's en kan helpen opvolging praktisch te maken.",
        "description_short": "Gebruik versleutelings-, schermvergrendelings- en endpointcontroles om hiaten in de bescherming te identificeren.",
        "title": "Vanta"
      },
      "wiz": {
        "bullets": [
          {
            "label": "Cloudbeveiligingsbevindingen",
            "text": "{label}: Ondersteunde problemen maken blootstellingen zichtbaar die onderzoek of herstel vereisen."
          },
          {
            "label": "Nuttige context",
            "text": "{label}: Informatie over ernst en getroffen resources helpt de omstandigheden achter een bevinding te verklaren."
          },
          {
            "label": "Gerichte actie",
            "text": "{label}: Gebruik relevante blootstelling als basis voor gesprekken over verantwoordelijkheid en technische opvolging."
          },
          {
            "label": "Veranderende blootstelling",
            "text": "{label}: Updates van bevindingen helpen actieve problemen te onderscheiden van opgelost werk."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest geselecteerde cloudbevindingen zonder de cloudconfiguratie te wijzigen."
          }
        ],
        "description_long": "Wiz identificeert beveiligingsrisico's in cloudomgevingen. Koppel het om relevante cloudblootstelling toe te voegen aan de context voor beoordelingen van menselijke risico's en gecoördineerde beveiligingsopvolging.",
        "description_short": "Voeg cloudbeveiligingsbevindingen en blootstellingscontext toe aan je risicobeoordelingen.",
        "title": "Wiz"
      },
      "workos": {
        "bullets": [
          {
            "label": "Accountstatus",
            "text": "{label}: Beschikbare accountstatusinformatie biedt context voor het beoordelen van applicatietoegang."
          },
          {
            "label": "Toegangsrelaties",
            "text": "{label}: Organisatie- en groepsrelaties helpen accounttoegang in perspectief te plaatsen."
          },
          {
            "label": "Gerichte beoordelingen",
            "text": "{label}: Bekijk accountcontext samen met beveiligingsgebeurtenissen uit andere gekoppelde tools."
          },
          {
            "label": "Relevante opvolging",
            "text": "{label}: Gebruik het gecombineerde bewijs als leidraad voor toegangsbeoordelingen en gesprekken over accountbeveiliging."
          },
          {
            "label": "Alleen-lezen",
            "text": "{label}: Leest directorytoegangsinformatie zonder accounts te wijzigen. Deze koppeling verzamelt geen aanmeldgebeurtenissen of sessieactiviteit."
          }
        ],
        "description_long": "WorkOS verbindt applicaties met toegangssystemen van organisaties. Koppel het zodat Moxso relevante accounttoegangscontext kan meewegen naast menselijke risico's en gerichte beveiligingsbeoordelingen kan ondersteunen.",
        "description_short": "Voeg directory- en organisatielidmaatschapscontext uit WorkOS toe.",
        "title": "WorkOS"
      }
    },
    "human_risk_intelligence": {
      "assignment": {
        "rule_labels": {
          "cooldown_days": "Afkoelvenster",
          "interval_days": "Toewijzingsinterval",
          "respect_mandatory_training": "Houd rekening met verplichte training"
        }
      },
      "assignment_status": {
        "awaiting_assignment": "Nog niet ingepland",
        "completed": "Voltooid",
        "due_soon": "Binnenkort vervaldatum",
        "overdue": "Achterstallig"
      },
      "intervention": {
        "notification_type": {
          "hri_employee_intervention_email": "Interventie-e-mail voor medewerker",
          "hri_intervention_email": "Interventie-e-mail voor medewerker"
        }
      },
      "onboarding": {
        "glance": {
          "notifications_behavior": {
            "continue_until_completion": "Meldingen worden na de deadline verzonden tot voltooiing",
            "stop_after_deadline": "Meldingen stoppen zodra de deadline is verstreken"
          },
          "notifications_frequency": {
            "intense": "Intens",
            "loose": "Los",
            "normal": "Normaal"
          }
        }
      },
      "polarity": {
        "neutral": "Neutraal",
        "risky": "Risicovol",
        "vigilant": "Waakzaam"
      },
      "risk_level": {
        "critical": "Kritiek",
        "high": "Hoog",
        "low": "Laag",
        "minimal": "Minimaal",
        "moderate": "Gemiddeld",
        "severe": "Ernstig"
      },
      "risk_matrix": {
        "columns": {
          "somewhat_likely": "Enigszins waarschijnlijk",
          "very_likely": "Zeer waarschijnlijk",
          "very_unlikely": "Zeer onwaarschijnlijk"
        },
        "rows": {
          "high": "Hoog",
          "low": "Laag",
          "medium": "Gemiddeld"
        }
      },
      "settings": {
        "interventions": {
          "actions": {
            "assignment": "Nieuwe les toewijzen",
            "notify_admin": "Beheerders informeren",
            "notify_employee": "Medewerker informeren",
            "notify_manager": "Manager informeren"
          },
          "groups": {
            "breach_exposure": {
              "description": "Reageer wanneer een medewerker voorkomt in een bekend datalek.",
              "title": "Datalekblootstelling"
            },
            "critical_phishing_interactions": {
              "description": "Reageer wanneer een medewerker een kritieke phishingactie uitvoert, zoals het indienen van inloggegevens, het openen van een bijlage of antwoorden.",
              "title": "Kritieke phishinginteracties"
            },
            "phishing_interactions": {
              "description": "Reageer wanneer een medewerker op een link klikt in een e-mail- of sms-phishingsimulatie.",
              "title": "Phishinginteracties"
            },
            "simulation_non_reporting": {
              "description": "Reageer wanneer een medewerker een phishingsimulatie niet binnen 2 of 7 dagen meldt.",
              "title": "Niet-gemelde simulatie"
            },
            "training_inactivity": {
              "description": "Reageer wanneer de verplichte training van een medewerker te laat is.",
              "title": "Trainingsinactiviteit"
            }
          },
          "severities": {
            "high": "Hoog (60+ dagen te laat)",
            "low": "Laag (7 dagen te laat)",
            "medium": "Gemiddeld (30 dagen te laat)"
          },
          "timeframe_options": {
            "intense": "Intens",
            "loose": "Los",
            "normal": "Normaal"
          }
        },
        "strategy": {
          "compliance": {
            "description": "Wijst training toe om te voldoen aan gedocumenteerde vereisten in ISO 27001, SOC 2 en gerelateerde compliance-raamwerken.",
            "glance": "om te voldoen aan de compliance-eisen van je organisatie",
            "title": "Compliance-training"
          },
          "group": {
            "description": "Past training aan met geaggregeerde gedragstrends over teams en afdelingen, zonder individuen te targeten.",
            "glance": "op basis van geaggregeerde gedragsrisicosignalen",
            "title": "Groepsgebaseerde training"
          },
          "intervention": {
            "description": "Zet gerichte interventies in op basis van gedragssignalen van medewerkers. Biedt op maat gemaakte training en corrigerende acties om geïdentificeerde risicopatronen aan te pakken en de blootstelling van de organisatie meetbaar te verkleinen.",
            "title": "Interventiestrategie"
          },
          "risk": {
            "description": "Wijst training toe op basis van functie, toegangsniveau en verantwoordelijkheidsgedreven risico, in lijn met NIS2-verwachtingen.",
            "glance": "op basis van het risicoprofiel van de rol van elke medewerker",
            "title": "Risicogebaseerde training"
          }
        },
        "summary_signals": {
          "impact": {
            "high": "Hoge impact",
            "low": "Lage impact",
            "medium": "Gemiddelde impact"
          },
          "signal_labels": {
            "failed_simulation": "Mislukte phishing-simulatie",
            "low_score": "Lage trainingsscore"
          }
        }
      },
      "trend": {
        "down": "Omlaag",
        "stable": "Stabiel",
        "up": "Omhoog"
      }
    },
    "indicators": {
      "A_10": "A.10",
      "A_11": "A.11",
      "A_13": "A.13",
      "A_14": "A.14",
      "A_15": "A.15",
      "A_16": "A.16",
      "A_17": "A.17",
      "A_19": "A.19",
      "A_21_2_A": "A.21(2)(a)",
      "A_21_2_B": "A.21(2)(b)",
      "A_21_2_C": "A.21(2)(c)",
      "A_21_2_D": "A.21(2)(d)",
      "A_21_2_F": "A.21(2)(f)",
      "A_21_2_G": "A.21(2)(g)",
      "A_21_2_I": "A.21(2)(i)",
      "A_23": "A.23",
      "A_24": "A.24",
      "A_26": "A.26",
      "A_28": "A.28",
      "A_30": "A.30",
      "A_32": "A.32",
      "A_33": "A.33",
      "A_34": "A.34",
      "A_39_1_B": "A.39(1)(b)",
      "A_4": "A.4",
      "A_5": "A.5",
      "A_5_15": "A.5.15",
      "A_5_17": "A.5.17",
      "A_5_1_C": "A.5(1)(c)",
      "A_5_1_E": "A.5(1)(e)",
      "A_5_1_F": "A.5(1)(f)",
      "A_5_23": "A.5.23",
      "A_5_24": "A.5.24",
      "A_5_25": "A.5.25",
      "A_5_26": "A.5.26",
      "A_5_27": "A.5.27",
      "A_5_28": "A.5.28",
      "A_5_31": "A.5.31",
      "A_5_34": "A.5.34",
      "A_5_7": "A.5.7",
      "A_6": "A.6",
      "A_6_3": "A.6.3",
      "A_6_7": "A.6.7",
      "A_7_1": "A.7.1",
      "A_7_2": "A.7.2",
      "A_7_3": "A.7.3",
      "A_7_4": "A.7.4",
      "A_8": "A.8",
      "A_8_1": "A.8.1",
      "A_8_2": "A.8.2",
      "A_8_23": "A.8.23",
      "A_8_5": "A.8.5",
      "A_8_7": "A.8.7",
      "A_8_9": "A.8.9",
      "A_9": "A.9",
      "CC1_1": "CC1.1",
      "CC2_1": "CC2.1",
      "CC3_2": "CC3.2",
      "CC4_1": "CC4.1",
      "CC5_2": "CC5.2",
      "CC6_1": "CC6.1",
      "CC7_2": "CC7.2",
      "CC8_1": "CC8.1",
      "CC9_2": "CC9.2",
      "C_10": "C.10",
      "C_6": "C.6",
      "C_7": "C.7",
      "C_8": "C.8",
      "C_9": "C.9",
      "administration": "Administratie",
      "ai_act": "AI Act",
      "customer-support-success": "Klantenservice en klantsucces",
      "data-analytics": "Data en analyse",
      "dora": "DORA",
      "education-training": "Onderwijs en training",
      "elevated": "Verhoogde toegang",
      "engineering-development": "Engineering en ontwikkeling",
      "executive-leadership": "Directie",
      "facilities-services": "Faciliteiten en diensten",
      "finance": "Financiën",
      "human-resources": "HR",
      "individual_contributor": "Uitvoerend medewerker",
      "iso_27001": "ISO 27001",
      "iso_27005": "ISO 27005",
      "it-systems": "IT en systemen",
      "leadership": "Leiderschap",
      "legal-compliance": "Juridische zaken en compliance",
      "management-team-leadership": "Management en teamleiding",
      "managerial": "Leidinggevend",
      "marketing-communications": "Marketing en communicatie",
      "nis2": "NIS2",
      "operations": "Bedrijfsvoering",
      "product-design": "Product en design",
      "project-program-management": "Project- en programmamanagement",
      "quality-process": "Kwaliteit en proces",
      "research-science": "Onderzoek en wetenschap",
      "sales": "Verkoop",
      "security": "Beveiliging",
      "soc_2": "SOC 2",
      "standard": "Standaardtoegang",
      "supply-chain-logistics": "Toeleveringsketen en logistiek"
    },
    "industries": {
      "aerospace_defence": "Lucht- en ruimtevaart en defensie",
      "automotive": "Auto-industrie",
      "banking": "Bankwezen en kapitaalmarkten",
      "capital_infrastructure": "Kapitaalprojecten en infrastructuur",
      "consumer_markets": "Consumentenmarkten",
      "energy_resources": "Energie, nutsvoorzieningen en middelen",
      "engineering_construction": "Techniek en bouw",
      "financial_services": "Financiële dienstverlening",
      "government_public": "Overheid en openbare diensten",
      "healthcare": "Gezondheidszorg",
      "hospitality_leisure": "Gastvrijheid en vrije tijd",
      "industrial_manufacturing": "Industriële productie",
      "insurance": "Verzekeringen",
      "media": "Media",
      "paper_packaging": "Bos, papier en verpakkingen",
      "pharmaceuticals": "Farmaceutische producten en levenswetenschappen",
      "private_equity": "Particuliere investeringen",
      "technology": "Technologie",
      "telecommunications": "Telecommunicatie",
      "transportation": "Vervoer en logistiek",
      "wealth_management": "Vermogens- en vermogensbeheer"
    },
    "integrations": {
      "conzentrate": {
        "description": "Synchroniseer trainingsgegevens met Learning Arena",
        "title": "Leeromgeving"
      },
      "csv": {
        "description": "Medewerkers importeren vanuit een CSV-bestand",
        "title": "CSV-import"
      },
      "drata": {
        "description": "Synchroniseer bewijs van cursusvoltooiing met Drata.",
        "title": "Drata"
      },
      "google": {
        "description": "Synchroniseer medewerkers en groepen van Google Workspace",
        "group_description": "Groepen importeren van Google Workspace",
        "title": "Google Workspace"
      },
      "google_scim": {
        "title": "Google"
      },
      "microsoft": {
        "description": "Synchroniseer medewerkers en groepen van Microsoft Entra ID",
        "group_description": "Groepen importeren uit Microsoft Entra ID",
        "title": "Microsoft Entra-ID"
      },
      "microsoft_scim": {
        "title": "Microsoft Entra ID"
      },
      "microsoft_teams": {
        "description": "Stuur trainingsmeldingen rechtstreeks in Teams",
        "title": "Microsoft Teams"
      },
      "okta_scim": {
        "title": "Okta"
      },
      "sabacloud": {
        "description": "Trainingsgegevens synchroniseren met Saba Cloud",
        "title": "Saba Cloud"
      },
      "slack": {
        "description": "Synchroniseer medewerkers en groepen van Slack",
        "group_description": "Groepen importeren uit Slack",
        "title": "Slack"
      },
      "slack_notifications": {
        "description": "Stuur trainingsmeldingen rechtstreeks in Slack",
        "title": "Slack-meldingen"
      },
      "sync_failures": {
        "default": "De synchronisatie van deze integratie is mislukt.",
        "unauthorized": "Synchronisatie mislukt. Werk de verificatie-instellingen voor deze integratie bij."
      },
      "vanta": {
        "description": "Synchroniseer bewijs van cursusvoltooiing met Vanta.",
        "title": "Vanta"
      }
    },
    "invalid_user": "Het huidige wachtwoord is onjuist.",
    "language": {
      "da_DK": "Deens",
      "de_DE": "Duits",
      "en_US": "Engels",
      "es_ES": "Spaans",
      "fi_FI": "Fins",
      "fr_FR": "Frans",
      "nb_NO": "Noors (Bokmål)",
      "nl_NL": "Nederlands",
      "pl_PL": "Pools",
      "pt_PT": "Portugees",
      "sv_SE": "Zweeds"
    },
    "learning_profile": {
      "data_privacy": {
        "description": "Zorgen voor de privacy en bescherming van gevoelige gegevens",
        "long": "Gegevensprivacy (AVG)",
        "short": "Gegevensprivacy"
      },
      "device_security": {
        "description": "Beveiliging van fysieke apparaten en eindpunten",
        "long": "Apparaatbeveiliging",
        "short": "Apparaatbeveiliging"
      },
      "digital_threats": {
        "description": "Bescherming tegen verschillende online dreigingen",
        "long": "Digitale Dreigingen",
        "short": "Digitale Dreigingen"
      },
      "hybrid_work": {
        "description": "Beveiligingsoverwegingen voor thuis- en kantoorbaan.",
        "long": "Hybride Werk",
        "short": "Hybride Werken"
      },
      "incidents_breaches": {
        "description": "Behandeling en preventie van beveiligingsincidenten",
        "long": "Incidenten & Datalekken",
        "short": "Incidenten en Datalekken"
      },
      "passwords_accounts": {
        "description": "Sterkte en beheer van wachtwoorden en accounts",
        "long": "Wachtwoorden & Accounts",
        "short": "Wachtwoorden & Accounts"
      },
      "phishing": {
        "description": "Bewustwording en preventie van phishing-aanvallen",
        "long": "Phishing",
        "short": "Phishing"
      },
      "physical_security": {
        "description": "Bescherming van fysieke activa en ruimtes",
        "long": "Fysieke beveiliging",
        "short": "Fysieke beveiliging"
      },
      "secure_browsing": {
        "description": "Veilige praktijken voor internetbrowsen",
        "long": "Beveiligd browsen",
        "short": "Beveiligd browsen"
      }
    },
    "onboarding": {
      "data_privacy": {
        "category": "Gegevensbescherming (GDPR)",
        "options": {
          "high": "We hebben duidelijke beleidslijnen en handhaven strikte gegevensbeschermingsmaatregelen",
          "low": "Wij beheren de naleving van persoonlijke gegevens niet actief.",
          "medium": "We verzamelen gegevens maar hebben geen formele beleidsregels opgesteld"
        },
        "question": "Hoe gaat je bedrijf om met persoonlijke gegevens volgens de GDPR-regelgeving?"
      },
      "device_security": {
        "category": "Apparaatbeveiliging",
        "options": {
          "high": "Apparaten worden centraal beheerd, versleuteld en bewaakt",
          "low": "Medewerkers gebruiken hun eigen apparaten zonder opgelegde beveiligingsrichtlijnen.",
          "medium": "Er worden enkele beveiligingsmaatregelen toegepast, maar niet consequent."
        },
        "question": "Welke beveiligingsmaatregelen zijn er getroffen voor bedrijfsapparaten?"
      },
      "digital_threats": {
        "category": "Digitale Dreigingen",
        "options": {
          "high": "We gebruiken endpointbeveiliging, firewalls en werknemersopleiding",
          "low": "Wij vertrouwen erop dat medewerkers hun eigen beveiliging beheren.",
          "medium": "Enkele beschermingsmaatregelen zijn aanwezig, maar niet voor het hele bedrijf."
        },
        "question": "Hoe beschermt je bedrijf zich tegen malware en cyberdreigingen?"
      },
      "hybrid_work": {
        "category": "Hybride Werk",
        "options": {
          "high": "Medewerkers gebruiken VPN's, beveiligde Wi-Fi en door het bedrijf goedgekeurde apparaten.",
          "low": "Medewerkers gebruiken persoonlijke apparaten en niet-beveiligde netwerken",
          "medium": "Sommige beveiligingsmaatregelen worden aangemoedigd maar zijn niet verplicht"
        },
        "question": "Hoe wordt de beveiliging voor externe medewerkers beheerd?"
      },
      "incidents_breaches": {
        "category": "Incidenten en Datalekken",
        "options": {
          "high": "We hebben een responsplan voor incidenten en testen dit regelmatig.",
          "low": "We behandelen incidenten reactief zonder formeel plan",
          "medium": "We hebben een plan maar hebben het nog nooit getest."
        },
        "question": "Wat is de aanpak van je bedrijf voor incidentrespons?"
      },
      "passwords_accounts": {
        "category": "Wachtwoorden & Accounts",
        "options": {
          "high": "Wachtwoordmanagers en MFA zijn vereist voor alle medewerkers",
          "low": "Medewerkers beheren hun eigen wachtwoorden zonder vereisten",
          "medium": "MFA is optioneel, en wachtwoordbeleid wordt niet strikt gehandhaafd."
        },
        "question": "Hoe handhaaft je bedrijf de beveiliging van wachtwoorden?"
      },
      "phishing": {
        "category": "Phishing",
        "options": {
          "high": "Medewerkers ondergaan regelmatig bewustwordingstrainingen voor phishing.",
          "low": "Er is geen formele phishingtraining beschikbaar",
          "medium": "Er wordt enige training gegeven, maar niet regelmatig."
        },
        "question": "Hoe beperkt je bedrijf de dreiging van phishing?"
      },
      "physical_security": {
        "category": "Fysieke beveiliging",
        "options": {
          "high": "Toegangscontrole, bezoekerslogboeken en beveiligde opslag zijn aanwezig",
          "low": "Er zijn geen formele fysieke beveiligingsmaatregelen",
          "medium": "Sommige beveiligingsmaatregelen bestaan, maar worden inconsistent toegepast"
        },
        "question": "Hoe wordt de fysieke beveiliging in je kantoor beheerd?"
      },
      "secure_browsing": {
        "category": "Beveiligd browsen",
        "options": {
          "high": "Medewerkers gebruiken veilige browsers met inhoudsfiltering",
          "low": "Geen beperkingen of beveiligingsbeleid voor browsen",
          "medium": "Enkele beveiligingsmaatregelen zijn aanwezig, maar worden niet afgedwongen."
        },
        "question": "Hoe zorgt je bedrijf voor veilig internetgebruik?"
      }
    },
    "organizational_role": {
      "access_level": {
        "elevated": "Verhoogde toegang",
        "standard": "Standaardtoegang"
      },
      "responsibility_tier": {
        "individual_contributor": "Uitvoerend medewerker",
        "leadership": "Leiderschap",
        "managerial": "Leidinggevend"
      }
    },
    "policies": {
      "audit_notifications_frequency": {
        "intense": "Intens",
        "loose": "Losjes",
        "normal": "Normaal"
      },
      "audit_status": {
        "completed": "Voltooid",
        "draft": "Inactief",
        "expired": "Verlopen",
        "running": "Controle"
      }
    },
    "report": {
      "labels": {
        "assignment": "Toewijzing",
        "assignment_completion": "Voltooiing van opdrachten",
        "click_rate": "Klikpercentage",
        "clicked": "Geklikt",
        "company_score": "Bedrijfsscore",
        "completed": "Voltooid",
        "course": "Cursus",
        "course_completed": "Voltooide cursussen",
        "critical": "Kritiek",
        "handling_rate": "Afhandelingspercentage bedreigingen",
        "handling_time": "Afhandelingstijd van dreigingen",
        "high": "Hoog",
        "in_progress": "Bezig",
        "interventions": "Interventies",
        "low": "Laag",
        "medium": "Gemiddeld",
        "missed_deadlines": "Gemiste deadlines",
        "negative": "Negatief",
        "neutral": "Neutraal",
        "notify_admin": "Beheerder geïnformeerd",
        "notify_employee": "Medewerker geïnformeerd",
        "notify_manager": "Manager geïnformeerd",
        "onboarding": "Onboardingpercentage",
        "overdue": "Te laat",
        "phishing_quizzes": "Phishingquizzen",
        "phishing_susceptibility": "Phishinggevoeligheid",
        "policy": "Beleid",
        "positive": "Positief",
        "report_rate": "Rapportagepercentage",
        "reported": "Gerapporteerd",
        "reporting_behavior": "Rapportagegedrag",
        "resilience_score": "Weerbaarheidsscore",
        "score": "Veerkrachtscore",
        "sent": "Verzonden simulaties",
        "signals": "Signalen",
        "simulations_received": "Ontvangen simulaties",
        "team_score": "Teamscore",
        "video": "Video",
        "video_quizzes": "Videoquizzen",
        "videos_watched": "Bekeken video's"
      }
    },
    "reports": {
      "frequencies": {
        "bimonthly": "Om de maand",
        "monthly": "Maandelijks",
        "quarterly": "Kwartaallijks",
        "weekly": "Wekelijks",
        "yearly": "Jaarlijks"
      },
      "periods": {
        "prev_month": "Vorige maand",
        "prev_quarter": "Vorige kwartaal",
        "prev_week": "Vorige week",
        "prev_year": "Afgelopen 12 maanden",
        "ytd": "Jaar tot nu toe"
      },
      "status": {
        "active": "Actief",
        "inactive": "Inactief"
      },
      "types": {
        "manager": "Managerrapport",
        "workspace": "Organisatierapport"
      }
    },
    "risk_categories": {
      "agentic_ai": "Agentische AI",
      "communication_security": "Communicatiebeveiliging",
      "data_protection": "Gegevensbescherming",
      "digital_exposure_risk": "Risico op digitale blootstelling",
      "endpoint_device_security": "Beveiliging van eindapparaten",
      "engagement_awareness": "Bewustzijn en betrokkenheid",
      "human_use_of_ai": "Menselijk gebruik van AI",
      "identity_access_risk": "Identiteits- en toegangsrisico",
      "incident_response_readiness": "Paraatheid voor incidentrespons",
      "mobile_security": "Mobiele beveiliging",
      "physical_security": "Fysieke beveiliging",
      "policy_regulatory_compliance": "Beleid en naleving van regelgeving",
      "remote_work_risk": "Risico bij werken op afstand",
      "social_engineering_risks": "Risico's van social engineering",
      "third_party_risk": "Risico van derden",
      "web_cloud_usage": "Gebruik van web en cloud"
    },
    "roles": {
      "administration": "Administratie",
      "customer-support-success": "Klantenondersteuning en klantsucces",
      "data-analytics": "Data en analyse",
      "education-training": "Onderwijs en training",
      "engineering-development": "Engineering en ontwikkeling",
      "executive-leadership": "Directie en leiderschap",
      "facilities-services": "Faciliteiten en diensten",
      "finance": "Financiën",
      "human-resources": "Human resources",
      "it-systems": "IT en systemen",
      "legal-compliance": "Juridische zaken en compliance",
      "management-team-leadership": "Management en teamleiderschap",
      "marketing-communications": "Marketing en communicatie",
      "operations": "Bedrijfsvoering",
      "product-design": "Product en design",
      "project-program-management": "Project- en programmamanagement",
      "quality-process": "Kwaliteit en processen",
      "research-science": "Onderzoek en wetenschap",
      "sales": "Verkoop",
      "security": "Beveiliging",
      "supply-chain-logistics": "Toeleveringsketen en logistiek"
    },
    "saml": {
      "name_id_formats": {
        "emailAddress": "E-mailadres",
        "persistent": "Persistent",
        "transient": "Transient",
        "unspecified": "Niet gespecificeerd"
      },
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    },
    "scim": {
      "providers": {
        "auth0_scim": "Auth0",
        "google_scim": "Google",
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    },
    "services": {
      "category": {
        "authentication": "Verificatie",
        "collaboration": "Samenwerking",
        "crm": "CRM",
        "digital_signature": "Digitale handtekening",
        "document_management": "Documentbeheer",
        "file_sharing": "Bestandsdeling",
        "hrm": "HRM",
        "marketing": "Marketing",
        "other": "Andere",
        "support": "Klantenservice",
        "survey": "Enquête",
        "video_conferencing": "Videoconferentie"
      },
      "target": {
        "all": "Iedereen",
        "design": "Ontwerp",
        "engineering": "Techniek",
        "finance": "Financiën",
        "marketing": "\"Marketing\"",
        "sales": "Verkoop",
        "support": "Ondersteuning"
      }
    },
    "signals": {
      "key": {
        "access_level": "Toegangsniveau",
        "ai_act_reference": "AI Act-referentie",
        "breach_found": "Datalek gevonden",
        "cybersecurity_culture_initiative_participated": "Neemt deel aan cyberbeveiligingsinitiatieven",
        "dora_reference": "DORA-referentie",
        "email_simulation_clicked": "Op e-mailsimulatie geklikt",
        "email_simulation_credentials_submitted": "Inloggegevens ingestuurd in e-mailsimulatie",
        "email_simulation_delivered": "E-mailsimulatie afgeleverd",
        "email_simulation_reported": "E-mailsimulatie gerapporteerd",
        "email_simulation_reported_without_clicking": "E-mailsimulatie gerapporteerd zonder te klikken",
        "employee_imported": "Medewerker geïmporteerd",
        "frameworks": "Raamwerken",
        "high_confidence_in_phishing_self_assessment": "Herhaaldelijk phishingquizzen correct beantwoord",
        "iso27001_reference": "ISO27001-referentie",
        "iso27005_reference": "ISO27005-referentie",
        "legitimate_email_reported_as_phishing": "Rapporteert legitieme e-mails als phishingmails",
        "low_confidence_in_phishing_self_assessment": "Herhaaldelijk phishingquizzen onjuist beantwoord",
        "low_score": "Laag score",
        "missed_deadline_30_days": "Verplichte training 30 dagen te laat",
        "missed_deadline_60_days": "Verplichte training 60 dagen te laat",
        "missed_deadline_7_days": "Verplichte training 7 dagen te laat",
        "multiple_choice_answered_correctly": "Meerkeuzevraag correct beantwoord",
        "multiple_choice_answered_incorrectly": "Meerkeuzevraag onjuist beantwoord",
        "nis2_reference": "NIS2-referentie",
        "optional_training_engaged": "Vrijwillige training voltooid",
        "real_phishing_email_clicked": "Op een echte phishingmail geklikt",
        "real_phishing_email_opened": "Echte phishingmail geopend",
        "real_phishing_email_opened_attachment": "Bijlage van een echte phishingmail geopend",
        "real_phishing_email_reported": "Echte phishingmail gerapporteerd",
        "real_phishing_email_targeted": "Getarget in echte phishingmails",
        "responsibility_tier": "Verantwoordelijkheidsniveau",
        "risk_level": "Risiconiveau",
        "risk_themes": "Risicothema's",
        "risk_threshold": "Risicodrempel",
        "role": "Rol",
        "role_fallback_used": "Fallback-rol gebruikt",
        "simulation_not_reported_2_days": "Simulatie na 2 dagen niet gemeld",
        "simulation_not_reported_7_days": "Simulatie na 7 dagen niet gemeld",
        "sms_simulation_clicked": "SMS-simulatie geklikt",
        "sms_simulation_delivered": "SMS-simulatie afgeleverd",
        "sms_simulation_reported": "SMS-simulatie gerapporteerd",
        "soc2_reference": "SOC2-referentie",
        "threat_reported": "Dreiging gerapporteerd",
        "training_completed": "Toegewezen training voltooid",
        "training_completed_after_deadline": "Voltooid na deadline",
        "training_completed_on_time": "Toegewezen training op tijd voltooid",
        "training_inactivity": "Trainingsinactiviteit",
        "training_video_watched": "Trainingsvideo bekeken"
      },
      "sentiment": {
        "negative": "Negatief",
        "neutral": "Neutraal",
        "positive": "Positief"
      },
      "severity": {
        "critical": "Kritiek",
        "high": "Hoog",
        "low": "Laag",
        "medium": "Gemiddeld",
        "neutral": "Neutraal"
      }
    },
    "simulations": {
      "delivery_method": {
        "email": "E-mail",
        "sms": "Tekstbericht"
      },
      "delivery_rate": {
        "high": "Hoog",
        "low": "Laag",
        "medium": "Middelmatig"
      },
      "failures": {
        "failed_to_deliver": "Leveringsfout",
        "failed_to_send": "Verzendfout",
        "invalid_receiver": "Ontvangerfout",
        "invalid_template": "Sjabloonfout",
        "no_template_available": "Sjabloonfout"
      },
      "preview": {
        "CampaignClick": "{name} klikte op een link",
        "CampaignReport": "{name} rapporteerde de simulatie",
        "CampaignSent": "De simulatie is verzonden naar {name}",
        "CampaignSubmission": "{name} heeft een inlogformulier ingediend",
        "activity": "Activiteit",
        "title": "Voorbeeld"
      },
      "schedule_type": {
        "missing": "Geen bezorgmethode",
        "one_off": "Eenmalig",
        "recurring": "Terugkerend"
      },
      "status": {
        "cancelled": "Geannuleerd",
        "completed": "Voltooid",
        "draft": "Concept",
        "paused": "Gepauzeerd",
        "running": "Bezig",
        "sending": "Verzenden"
      },
      "templates": {
        "editor": {
          "sidebar_blocks": {
            "button": "Knop",
            "columns": "Kolommen",
            "container": "Container",
            "divider": "Scheidingslijn",
            "heading1": "Kop 1",
            "heading2": "Kop 2",
            "heading3": "Kop 3",
            "image": "Afbeelding",
            "spacer": "Ruimte",
            "text": "Tekst"
          }
        }
      }
    },
    "statistics": {
      "activities_by_type": {
        "completed_courses": "Voltooide cursussen",
        "phishing_quiz_correct_answers": "Correcte antwoorden op phishingquiz",
        "phishing_quiz_incorrect_answers": "Onjuiste antwoorden op phishingquiz",
        "quiz_answers": "Quiz-antwoorden",
        "quiz_correct_answers": "Correcte quizantwoorden",
        "quiz_incorrect_answers": "Onjuiste quizantwoorden",
        "simulations_delivered": "Simulaties afgeleverd",
        "simulations_failed": "Mislukte simulaties",
        "simulations_passed": "Geslaagde simulaties",
        "simulations_reported": "Gerapporteerde simulaties",
        "text": "Hoe je medewerkers aan het trainen zijn",
        "threats_reported": "Gemelde dreigingen",
        "title": "Voltooide activiteiten",
        "videos_watched": "Video's bekeken"
      },
      "benchmarks": {
        "above_benchmark_tooltip": "Waarde ligt boven de benchmark.",
        "below_benchmark_tooltip": "Waarde ligt onder de benchmark.",
        "benchmark_tooltip": "Benchmark"
      },
      "breaches": {
        "critical": "Kritiek",
        "noncritical": "Niet-kritiek"
      },
      "employees": {
        "beginner": "Beginner",
        "expert": "Deskundige",
        "intermediate": "Gemiddeld"
      },
      "onboarding": {
        "not_onboarded": "Niet aangemeld",
        "onboarded": "Gestart"
      },
      "participant_partition": {
        "active": "Actief",
        "completed": "Voltooid",
        "halted": "Gestopt"
      },
      "threats": {
        "status_partition": {
          "forwarded": "Doorgestuurd",
          "fraudulent": "Frauduleus",
          "legitimate": "Rechtmatig",
          "spam": "Spam"
        }
      },
      "time_units": {
        "days": "Dag | Dagen",
        "hours": "Uur | Uren",
        "minutes": "Minuut | Minuten",
        "seconds": "Seconde | seconden",
        "weeks": "Week | Weken"
      },
      "training": {
        "quizzing": {
          "correct": "Correct",
          "incorrect": "Incorrect"
        }
      }
    },
    "tables": {
      "columns": {
        "actor": "Actor",
        "app": "App",
        "automation_status": "Status",
        "available_at": "Beschikbaar",
        "breached_at": "Gelekt op",
        "click_rate": "@:simulations.click_rate.title",
        "completed": "Voltooid",
        "completed_at": "Voltooid",
        "content_id": "Inhoud",
        "content_type": "Inhoudstype",
        "created_at": "Aangemaakt",
        "data_class": "Dataklasse",
        "deadline_at": "Deadline",
        "delivery": "@:simulations.summary.schedule_type",
        "delivery_type": "@:tables.delivery_method",
        "employee_id": "Medewerker",
        "employee_status": "Status",
        "event": "Gebeurtenis",
        "group_id": "Groep",
        "key": "Signaal",
        "last_learning_interaction": "Laatste interactie",
        "published_at": "Gepubliceerd op",
        "report_rate": "@:simulations.report_rate.title",
        "risk_matrix": "Risicomatrix",
        "role": "Rol",
        "sentiment": "Sentiment",
        "severity": "Ernst",
        "signal_group": "Signaalgroep",
        "submission_rate": "@:simulations.submission_rate.title",
        "test": "@:simulations.summary.test",
        "translations": "Vertalingen",
        "type": "Type",
        "zone": "Zone"
      },
      "date_operators": {
        "<": "vóór",
        "<=": "op of vóór",
        "<>": "niet op",
        "=": "op",
        ">": "na",
        ">=": "op of na"
      },
      "enum_values": {
        "access": "Toegang",
        "access_revoke": "Toegang ingetrokken",
        "active": "Actief",
        "admin": "Beheerder",
        "all": "Allemaal",
        "analyst": "Analist",
        "api_token_create": "API-token aangemaakt",
        "api_token_delete": "API-token verwijderd",
        "assignment": "Toewijzing",
        "auth_activity": "Authenticatieactiviteit",
        "authenticate": "Authenticatie",
        "authentication_activity": "Authenticatieactiviteit",
        "authorized_integration": "Integratie geautoriseerd",
        "breach_config": "Lekinstellingen bijgewerkt",
        "breach_exposure": "Datalekblootstelling",
        "breach_found": "Lek gevonden",
        "cancelled": "@:dynamic_keys.simulations.status.cancelled",
        "change": "Wijziging",
        "changed_data": "Gegevens gewijzigd",
        "completed": "@:dynamic_keys.simulations.status.completed",
        "course": "Cursus",
        "course_delete": "Cursus verwijderd",
        "created_campaign_domain": "Campagnedomein aangemaakt",
        "created_integration": "Integratie aangemaakt",
        "created_warehouse_token": "Datawarehouse-token aangemaakt",
        "credential_update": "Inloggegevens bijgewerkt",
        "critical": "Kritiek",
        "critical_phishing_interactions": "Phishing-inloggegevens ingediend",
        "cybersecurity_culture_initiative_participated": "Neemt deel aan cyberbeveiligingsinitiatieven",
        "data_change": "Gegevens gewijzigd",
        "deleted_warehouse_token": "Datawarehouse-token verwijderd",
        "domain_create": "Domein aangemaakt",
        "draft": "@:dynamic_keys.simulations.status.draft",
        "email": "@:dynamic_keys.simulations.delivery_method.email",
        "email_simulation_clicked": "Geklikt op e-mailsimulatie",
        "email_simulation_credentials_submitted": "Inloggegevens ingediend in e-mailsimulatie",
        "email_simulation_delivered": "E-mailsimulatie afgeleverd",
        "email_simulation_reported": "E-mailsimulatie gerapporteerd",
        "email_simulation_reported_without_clicking": "E-mailsimulatie gerapporteerd zonder te klikken",
        "employee_training_exclude": "Medewerker uitgesloten van training",
        "employee_training_exclusion_expire": "Trainingsuitsluiting van medewerker verlopen",
        "employee_training_include": "Medewerker opgenomen in training",
        "high": "Hoog",
        "high-somewhat_likely": "Hoge impact / Enigszins waarschijnlijk",
        "high-very_likely": "Hoge impact / Zeer waarschijnlijk",
        "high-very_unlikely": "Hoge impact / Zeer onwaarschijnlijk",
        "high_confidence_in_phishing_self_assessment": "Herhaaldelijk phishingquizzen correct beantwoord",
        "hub": "Hub",
        "inactive": "Inactief",
        "integration_auth": "Integratie geautoriseerd",
        "integration_config": "Integratie-instellingen bijgewerkt",
        "integration_create": "Integratie aangemaakt",
        "integration_delete": "Integratie verwijderd",
        "integration_update": "Integratie bijgewerkt",
        "intel_config": "Human risk intelligence-instellingen bijgewerkt",
        "invited_user": "Gebruiker uitgenodigd",
        "legitimate_email_reported_as_phishing": "Rapporteert legitieme e-mails als phishingmails",
        "login": "Ingelogd",
        "login_verify": "Inloggen geverifieerd",
        "logout": "Uitgelogd",
        "low": "Laag",
        "low-somewhat_likely": "Lage impact / Enigszins waarschijnlijk",
        "low-very_likely": "Lage impact / Zeer waarschijnlijk",
        "low-very_unlikely": "Lage impact / Zeer onwaarschijnlijk",
        "low_confidence_in_phishing_self_assessment": "Herhaaldelijk phishingquizzen onjuist beantwoord",
        "manage": "Beheer",
        "med-somewhat_likely": "Gemiddelde impact / Enigszins waarschijnlijk",
        "med-very_likely": "Gemiddelde impact / Zeer waarschijnlijk",
        "med-very_unlikely": "Gemiddelde impact / Zeer onwaarschijnlijk",
        "medium": "Gemiddeld",
        "missed_deadline_30_days": "Verplichte training 30 dagen te laat",
        "missed_deadline_60_days": "Verplichte training 60 dagen te laat",
        "missed_deadline_7_days": "Verplichte training 7 dagen te laat",
        "multiple_choice_answered_correctly": "Meerkeuzevraag correct beantwoord",
        "multiple_choice_answered_incorrectly": "Meerkeuzevraag onjuist beantwoord",
        "negative": "Negatief",
        "neutral": "Neutraal",
        "notification": "Melding",
        "notify_admin": "Beheerders informeren",
        "notify_employee": "Medewerker informeren",
        "notify_manager": "Manager informeren",
        "one_off": "@:dynamic_keys.simulations.schedule_type.one_off",
        "optional_training_engaged": "Vrijwillige training voltooid",
        "paused": "Gepauzeerd",
        "phishing_interactions": "Phishinginteracties",
        "policy": "Beleid",
        "positive": "Positief",
        "privacy_config": "Privacy-instellingen bijgewerkt",
        "quiz": "Quiz",
        "real_phishing_email_opened": "Echte phishingmail geopend",
        "real_phishing_email_reported": "Echte phishingmail gerapporteerd",
        "real_phishing_email_targeted": "Getarget in echte phishingmails",
        "recurring": "@:dynamic_keys.simulations.schedule_type.recurring",
        "register": "Registratie",
        "removed_user_access": "Gebruikerstoegang verwijderd",
        "running": "@:dynamic_keys.simulations.status.running",
        "sending": "@:dynamic_keys.simulations.status.sending",
        "signed_in": "Ingelogd",
        "signed_out": "Uitgelogd",
        "simulation_config": "Simulatie-instellingen bijgewerkt",
        "simulation_non_reporting": "Niet-gemelde simulatie",
        "simulation_not_reported_2_days": "Simulatie na 2 dagen niet gemeld",
        "simulation_not_reported_7_days": "Simulatie na 7 dagen niet gemeld",
        "sms": "@:dynamic_keys.simulations.delivery_method.sms",
        "sms_simulation_clicked": "Geklikt op sms-simulatie",
        "sms_simulation_delivered": "Sms-simulatie afgeleverd",
        "started": "Gestart",
        "support": "Support",
        "switched_workspace": "Werkruimte gewisseld",
        "threat_analyst": "Dreigingsanalist",
        "threat_config": "Threat management-instellingen bijgewerkt",
        "threat_reported": "Dreiging gerapporteerd",
        "training_completed": "Toegewezen training voltooid",
        "training_completed_after_deadline": "Voltooiing na deadline",
        "training_completed_on_time": "Toegewezen training op tijd voltooid",
        "training_config": "Trainingsinstellingen bijgewerkt",
        "training_inactivity": "Trainingsinactiviteit",
        "training_video_watched": "Trainingsvideo bekeken",
        "updated_breach_settings": "Instellingen voor lekken bijgewerkt",
        "updated_gdpr_settings": "AVG-instellingen bijgewerkt",
        "updated_human_risk_intelligence_settings": "Human risk intelligence-instellingen bijgewerkt",
        "updated_integration": "Integratie bijgewerkt",
        "updated_integration_settings": "Integratie-instellingen bijgewerkt",
        "updated_integration_token": "Integratietoken bijgewerkt",
        "updated_simulation_settings": "Simulatie-instellingen bijgewerkt",
        "updated_threat_management_settings": "Instellingen voor dreigingsbeheer bijgewerkt",
        "updated_training_settings": "Trainingsinstellingen bijgewerkt",
        "updated_workspace_settings": "Werkruimte-instellingen bijgewerkt",
        "user_invite": "Gebruiker uitgenodigd",
        "verified_sign_in": "Geverifieerd ingelogd",
        "video": "Video",
        "video_delete": "Video verwijderd",
        "viewed_resource": "Bron bekeken",
        "workspace_config": "Werkruimte-instellingen bijgewerkt",
        "workspace_switch": "Werkruimte gewisseld"
      },
      "operators": {
        "<>": "is niet",
        "=": "is"
      }
    },
    "threats": {
      "status": {
        "all": "Allemaal",
        "forwarded": "Doorgestuurd",
        "fraudulent": "Frauduleus",
        "legitimate": "Legitiem",
        "spam": "Ongewenste berichten",
        "unhandled": "Onbehandeld"
      }
    },
    "training": {
      "type": {
        "course-type": "Cursus",
        "policy-type": "Beleidsregels",
        "quiz-type": "Quiz",
        "video-type": "Video"
      }
    },
    "types": {
      "boolean": "Booleaans",
      "date": "Datum",
      "number": "Getal",
      "string": "Tekenreeks"
    },
    "users": {
      "roles": {
        "admin": {
          "text": "Beheerders kunnen instellingen beheren, gebruikers uitnodigen en producten configureren.",
          "title": "Beheerder"
        },
        "analyst": {
          "text": "Analisten kunnen gegevens bekijken en analyseren.",
          "title": "Analist"
        },
        "threat_analyst": {
          "text": "Dreigingsanalisten kunnen dreigingen beheren en gegevens bekijken/analyseren.",
          "title": "Dreigingsanalist"
        }
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "title": "Gevorderd",
          "tooltip": "Word in een mum van tijd een hackingexpert"
        },
        "ai": {
          "title": "AI en cybersecurity",
          "tooltip": "Ontdek de complexe rol van AI in cyberbeveiliging"
        },
        "compliance": {
          "title": "Certificeringen en naleving",
          "tooltip": "Begrijp het belang van certificeringen en naleving"
        },
        "gdpr": {
          "title": "AVG",
          "tooltip": "Leer de belangrijkste vereisten en regels van de AVG en hoe je hier in je dagelijks leven aan kunt voldoen."
        },
        "hacking": {
          "title": "Het leven van een hacker",
          "tooltip": "Leer de mensen kennen achter cyberaanvallen, de hackers van de wereld"
        },
        "money_laundering": {
          "title": "Witwassen",
          "tooltip": "Leer de verschillende methoden kennen die criminelen gebruiken om geld wit te wassen en hoe witwassen kan worden opgespoord en voorkomen"
        },
        "phishing": {
          "title": "Phishing",
          "tooltip": "Ontdek de aspecten van de meest voorkomende cyberaanval ter wereld"
        },
        "physical_security": {
          "title": "Fysieke beveiliging",
          "tooltip": "Ontdek waarom fysieke beveiliging een cruciaal element is in goede cyberbeveiliging"
        },
        "tips_and_tricks": {
          "title": "Tips en trucs",
          "tooltip": "Leer hoe je je persoonlijke cyberbeveiliging kunt verbeteren"
        },
        "types_of_hacking": {
          "title": "Typen hacking",
          "tooltip": "Krijg inzicht in de verschillende methoden die hackers gebruiken"
        },
        "uploads": {
          "title": "Uploads",
          "tooltip": "Bekijk video's die door je organisatie zijn geüpload voor je specifieke beveiligingsbehoeften"
        }
      }
    },
    "workspace_onboarding": {
      "kick_off": {
        "validation": {
          "employee_import": "Minimaal 1 AD-integratie is correct ingesteld",
          "invite_admins": "Beheerders uitnodigen",
          "reporting_add_in": "Reporting-add-in instellen",
          "simulation": "Simulaties instellen",
          "training": "Training instellen",
          "verify_domain": "Minimaal 1 domein is geverifieerd",
          "whitelisting": "Allowlisting is voltooid"
        }
      }
    }
  },
  "editor": {
    "loading": "Laden"
  },
  "employees": {
    "active_directory": "Active Directory",
    "add_employees": "Medewerkers toevoegen",
    "anonymous_name": "Anoniem",
    "bulk_actions": {
      "activate": "Gebruiker activeren | Gebruikers activeren",
      "deactivate": "Deactiveer gebruiker | Deactiveer gebruikers",
      "success": "Statussen bijgewerkt",
      "x_of_n_selected": "{x} van {n} geselecteerd"
    },
    "current_manager": "Huidige manager",
    "deleted_user": "Verwijderde gebruiker",
    "department": "Afdeling",
    "filter": {
      "status": {
        "active": "Alleen actieve medewerkers",
        "all": "Alle medewerkers",
        "inactive": "Alleen inactieve medewerkers"
      }
    },
    "form": {
      "department": "Afdeling",
      "edit_title": "Instellingen",
      "email": "E-mail",
      "first_name": "Voornaam",
      "language": "Taal",
      "last_name": "Achternaam",
      "manager": "Manager",
      "organisational_role": "Rol",
      "placeholder": {
        "manager": "Kies manager",
        "role": "Kies rol",
        "timezone": "Kies tijdzone"
      },
      "save_settings": "Instellingen opslaan",
      "scim_enabled_info": "Je kunt de instellingen van de medewerker niet bewerken omdat SCIM is ingeschakeld voor deze workspace.",
      "timezone": "Tijdzone"
    },
    "manual": "Handleiding",
    "no_email_found": "Geen e-mail gevonden",
    "preview": {
      "close_edit": "Sluiten",
      "edit": "Bewerken",
      "email": "E-mail",
      "groups": "Groepen",
      "locale": "Taal",
      "manager": {
        "active_directory": "Active Directory",
        "button": "Profiel bekijken",
        "email": "E-mail",
        "manual": "Handleiding",
        "name": "Naam",
        "source": "Bron",
        "subtitle": "Overzicht van managergegevens",
        "title": "Manager"
      },
      "phone_number": "Telefoonnummer",
      "profile": "Bekijk profiel",
      "provider": "Aanbieder",
      "provider_id": "Provider-ID",
      "source": "Bron",
      "status": "Status",
      "tags": "Labels",
      "title": "Voorbeeldweergave"
    },
    "recent_activity": "Recente activiteit",
    "resilience_score": {
      "text": "Huidige weerbaarheidsscore op basis van de prestaties van de afgelopen 90 dagen.",
      "title": "Weerbaarheidsscore"
    },
    "search": {
      "button": "Zoeken",
      "empty": "Zoeken naar medewerkers...",
      "no_results": "Geen medewerkers gevonden"
    },
    "settings": {
      "settings_saved": "Instellingen opgeslagen",
      "status": {
        "active": {
          "description": "Deze medewerker ontvangt simulaties en trainingen.",
          "title": "Actief"
        },
        "inactive": {
          "description": "Deze medewerker ontvangt GEEN simulaties en oefenprogramma's.",
          "title": "Inactief"
        }
      }
    },
    "simulations": {
      "click_rate": {
        "title": "Klikpercentage",
        "tooltip": "Percentage van simulaties aangeklikt."
      },
      "email_validated": "E-mail gevalideerd: {date}",
      "received": {
        "title": "Simulaties ontvangen",
        "tooltip": "Totaal aantal ontvangen simulaties.",
        "unit": "Simulaties"
      },
      "report_rate": {
        "title": "Rapporteerpercentage",
        "tooltip": "Percentage van gerapporteerde simulaties."
      },
      "submission_rate": {
        "title": "Aanmeldingspercentage",
        "tooltip": "Percentage van ingediende inlogformulieren.",
        "x_received": "{count} ontvangen"
      }
    },
    "status": "Status",
    "training": {
      "reminder": {
        "reminder_sent": "Herinnering verzonden",
        "subject": "Cybersecuritytraining",
        "text": "De dreiging van hackers neemt toe en je moet op de hoogte blijven om jezelf en je bedrijf veilig te houden.",
        "title": "Hoi!"
      }
    },
    "videos": {
      "title": "Video's",
      "unit": "Video's bekeken"
    }
  },
  "empty": {
    "activity": {
      "title": "Geen activiteit"
    },
    "assigned_learning": {
      "description": "De gebruiker heeft geen training toegewezen gekregen.",
      "title": "Geen toegewezen leermateriaal"
    },
    "automations": {
      "button": "Trainingsreeks maken",
      "description": "Begin met het maken van een automatisering.",
      "title": "Geen automatiseringen"
    },
    "breaches": {
      "description": "Datalekken die verband houden met e-mailadressen die aan de hub zijn toegevoegd, verschijnen hier.",
      "title": "Nog geen datalekken"
    },
    "custom_uploads": {
      "button": "Video maken",
      "description": "Begin met het maken van een video",
      "title": "Geen video's gevonden"
    },
    "domains": {
      "button": "Domein toevoegen",
      "description": "Begin door een domein toe te voegen.",
      "title": "Geen domeinen"
    },
    "employee_simulations": {
      "button": "Ga naar simulaties",
      "description": "Begin met het toevoegen van een simulatie.",
      "title": "Geen simulaties"
    },
    "employees": {
      "button": "Medewerker toevoegen",
      "description_with_button": "Begin door een medewerker toe te voegen.",
      "description_without_button": "Geen medewerkers gevonden.",
      "title": "Geen medewerkers"
    },
    "employees_activity": {
      "description": "Er is geen activiteit geweest voor deze medewerker.",
      "title": "Geen activiteit"
    },
    "employees_group": {
      "description": "Deze groep heeft geen bijbehorende medewerkers.",
      "title": "Geen medewerkers"
    },
    "employees_training": {
      "description": "Dit {type} is door geen enkele medewerker voltooid.",
      "title": "Geen deelnemers"
    },
    "generic": {
      "description": "Geen records gevonden.",
      "title": "Geen records"
    },
    "groups": {
      "button": "Groep aanmaken",
      "description_with_button": "Begin door een groep toe te voegen.",
      "description_without_button": "Geen groepen gevonden.",
      "title": "Geen groepen"
    },
    "imports": {
      "description": "Er zijn synchronisaties voor deze integratie.",
      "title": "Geen synchronisaties"
    },
    "participants": {
      "description": "Geen deelnemers gevonden.",
      "title": "Geen deelnemers"
    },
    "policies": {
      "description": "Maak je eerste beleidsregel.",
      "title": "Nog geen beleidsregels"
    },
    "reports": {
      "description": "Maak een gepland rapport aan om te beginnen.",
      "title": "Geen geplande rapporten"
    },
    "scim_connections": {
      "description": "Maak een verbinding aan voor Microsoft Entra ID of Okta.",
      "title": "Geen SCIM-verbindingen"
    },
    "scim_tokens": {
      "description": "Er zijn geen SCIM-tokens aangemaakt voor deze workspace.",
      "title": "Geen SCIM-tokens"
    },
    "simulation_events": {
      "description": "Er zijn geen gebeurtenissen gevonden voor deze simulatie.",
      "title": "Geen evenementen"
    },
    "simulations": {
      "description": "Begin met het toevoegen van een simulatie.",
      "title": "Geen simulaties"
    },
    "simulations_custom_templates": {
      "description": "Begin door een template toe te voegen.",
      "title": "Geen templates"
    },
    "simulations_sequence": {
      "button": "Automatisering bewerken",
      "description": "Voeg acties toe om de automatiseringsflow op te bouwen",
      "title": "Deze automatisering is leeg"
    },
    "threats": {
      "attachments": "Geen bijlagen gevonden",
      "description": "Begin met het rapporteren van verdachte e-mails met de Moxso e-mail add-in",
      "title": "Geen dreigingen gevonden"
    },
    "tokens": {
      "description": "Begin met het aanmaken van een token.",
      "title": "Geen tokens"
    },
    "training": {
      "button": "Filters wissen",
      "description": "Er zijn geen trainingsmaterialen gevonden die overeenkomen met de zoekopdracht.",
      "title": "Geen trainingsmateriaal gevonden"
    },
    "training_deadlines": {
      "description": "Nog geen deadlines gevonden.",
      "title": "Nog geen deadlines"
    },
    "user_courses": {
      "description": "Er zijn nog geen cursussen toegewezen.",
      "title": "Geen cursussen"
    },
    "users": {
      "description": "Er zijn geen gebruikers gevonden.",
      "title": "Geen gebruikers"
    }
  },
  "error": {
    "button": "Ga terug naar start",
    "text": "Er is een onbekende fout opgetreden, en we konden je verzoek niet voltooien. Onze excuses voor het ongemak. Probeer het later opnieuw.",
    "title": "Er is iets misgegaan"
  },
  "forgot_password": {
    "button": "Stuur instructies",
    "heading": "Stel je wachtwoord opnieuw in",
    "instructions": {
      "heading": "E-mail verzonden",
      "text": "Instructies zijn naar je e-mail verstuurd."
    },
    "text": "Voer het e-mailadres in dat je gebruikte toen je je aanmeldde en we sturen je instructies om je wachtwoord opnieuw in te stellen."
  },
  "forms": {
    "employee": {
      "add_employees": "Medewerkers toevoegen",
      "buttons": {
        "add": "Medewerker toevoegen | Medewerkers toevoegen",
        "add_row": "Rij toevoegen",
        "send_reminder": "Stuur trainingsherinnering",
        "settings": "Instellingen"
      },
      "delete_row": "Rij verwijderen",
      "employee_added": "Medewerker toegevoegd | Medewerkers toegevoegd",
      "import": {
        "text": "Importeer medewerkers uit een CSV-bestand.",
        "title": "Medewerkers importeren"
      },
      "labels": {
        "email": "E-mail",
        "first_name": "Voornaam",
        "language": "Taal",
        "last_name": "Achternaam",
        "phone_number": "Telefoonnummer"
      },
      "manual": {
        "text": "Maak handmatig medewerkers en hun gegevens aan.",
        "title": "Medewerkers handmatig aanmaken"
      },
      "placeholders": {
        "email": "Name{'@'}company.com",
        "first_name": "Voornaam",
        "last_name": "Achternaam",
        "phone_number": "Voer telefoonnummer in"
      }
    },
    "filters": {
      "all": "Alle medewerkers",
      "completed": "Voltooid",
      "completed_default": "Alle",
      "incomplete": "Onvoltooid",
      "only_active": "Alleen actieve medewerkers",
      "only_inactive": "Alle inactieve medewerkers"
    },
    "group": {
      "adaptive": {
        "text": "Leden worden automatisch ingeschreven op basis van regels.",
        "title": "Maak een adaptieve groep"
      },
      "add_group": "Groep toevoegen",
      "buttons": {
        "add": "Groep aanmaken",
        "back": "Terug",
        "import": "Groepen importeren",
        "next": "Volgende stap",
        "save": "Instellingen opslaan"
      },
      "group_added": "Groep toegevoegd",
      "group_updated": "Groep bijgewerkt",
      "import": {
        "text": "Groepen importeren vanuit integraties.",
        "title": "Groepen importeren"
      },
      "labels": {
        "groups": "Groepen",
        "import_from_provider": "Importeren van provider",
        "name": "Naam",
        "provider": "Aanbieder",
        "provider_id": "Providergroep-ID"
      },
      "manual": {
        "text": "Leden worden handmatig toegevoegd.",
        "title": "Maak een handmatige groep"
      },
      "placeholders": {
        "name": "Groepsnaam",
        "provider": "Kies provider",
        "provider_id": "ABC-123",
        "search_groups": "Groepen zoeken"
      },
      "scim_enabled_info": "Je kunt de instellingen van de groep niet bewerken omdat SCIM is ingeschakeld voor deze workspace."
    },
    "login": {
      "buttons": {
        "reset_password": "Wachtwoord resetten"
      },
      "labels": {
        "email": "E-mail",
        "password": "Wachtwoord",
        "password_repeat": "Herhaal wachtwoord"
      },
      "placeholders": {
        "email": "Naam{'@'}company.com"
      }
    },
    "search": "Zoeken"
  },
  "general": {
    "locked_feature": "Deze functie is vergrendeld"
  },
  "go_back": "Ga terug",
  "goals": {
    "actions": {
      "delete_are_you_sure": "Weet je zeker dat je dit doel wilt annuleren?",
      "delete_goal": "Doel annuleren",
      "deleted": "Doel geannuleerd",
      "edit_goal": "Doel bewerken",
      "edit_goal_title": "Doel voor {metric} bewerken",
      "new_goal": "Nieuw doel voor {metric}",
      "save_goal": "Doel opslaan",
      "target_description": "Stel een doelwaarde in en kies de datum waarop je die wilt bereiken."
    },
    "chart": {
      "lifetime": "Volledige periode",
      "recent": "Recent"
    },
    "detail": {
      "achieved": "Behaald",
      "active_and_scheduled": "Actieve en geplande doelen",
      "actual_at_date": "Werkelijke waarde op datum",
      "in_progress": "Bezig",
      "missed": "Gemist",
      "no_past_goals": "Nog geen eerdere doelen",
      "outcome": "Resultaat",
      "past_goals": "Eerdere doelen",
      "scheduled": "Gepland",
      "trajectory": "Ontwikkeling",
      "trajectory_description": "Werkelijke voortgang ten opzichte van elk doel voor deze meetwaarde. De punten zijn gekleurd op basis van de uitkomst — groen behaald, rood gemist, blauw in uitvoering en grijs gepland."
    },
    "form": {
      "target": {
        "label": "Doel",
        "placeholder": "Doel"
      },
      "target_date": {
        "label": "Doeldatum",
        "placeholder": "Selecteer doeldatum"
      }
    },
    "legend": {
      "actual": "Werkelijk",
      "projected": "Verwacht"
    },
    "no_data": "Geen gegevens",
    "overview": {
      "add_goal": "Doel toevoegen",
      "current": "huidig",
      "description": "Stel tijdgebonden doelen per meetwaarde in om een meetbaar verbeteringstraject te creëren.",
      "employees_behind_tooltip": "Medewerkers met ten minste één toewijzing waarvan de vervaldatum is verstreken.",
      "from_now": "vanaf nu",
      "gap_from_previous_target": "Verschil met het vorige doel",
      "next_target": "Volgend doel",
      "no_goal_description": "Deze meetwaarde wordt gevolgd zonder doel. Voeg er een toe om voortgang te meten.",
      "no_goals": "Geen actieve doelen ingesteld",
      "time_elapsed": "Verstreken tijd",
      "title": "Doelen",
      "view": "Bekijken"
    }
  },
  "groups": {
    "adaptive_conditions": {
      "boolean_operators": {
        "and": "en",
        "or": "of"
      },
      "empty": "Nog geen regels. Voeg een regel toe om te bepalen wie tot deze groep behoort.",
      "preview_count_label": "medewerkers voldoen aan de criteria",
      "subtitle": "Lidmaatschap wordt bepaald door regels in plaats van handmatig ingesteld.",
      "title": "Adaptieve groep"
    },
    "assign_manager": {
      "button": "Beheerder toewijzen",
      "description": "Wijs in één keer een manager toe aan alle groepsleden",
      "form": {
        "overwrite_managers": {
          "help": "Als deze optie is ingeschakeld, worden medewerkers die al een manager hebben, opnieuw toegewezen aan de geselecteerde manager.",
          "label": "Bestaande managers overschrijven"
        },
        "select_manager": {
          "help": "Kies een manager die aan alle medewerkers van deze groep wordt toegewezen.",
          "label": "Manager",
          "placeholder": "Kies manager"
        }
      },
      "manager_assigned": "Manager toegewezen aan groepsleden",
      "message": "Handmatig bijwerken van managers van medewerkers stopt de synchronisatie van Active Directory om ze bij te werken.",
      "title": "Groepsgewijs toewijzen van manager"
    },
    "assign_role": {
      "button": "Rol toewijzen",
      "form": {
        "overwrite_roles": {
          "help": "Indien ingeschakeld, worden medewerkers die al een rol hebben opnieuw toegewezen aan de geselecteerde rol.",
          "label": "Bestaande rollen overschrijven"
        },
        "select_role": {
          "help": "Kies een rol die aan alle leden van deze groep wordt toegewezen.",
          "label": "Rol",
          "placeholder": "Kies rol"
        }
      },
      "role_assigned": "Rol toegewezen aan groepsleden",
      "title": "Rol in bulk toewijzen"
    },
    "assign_timezone": {
      "button": "Tijdzone toewijzen",
      "description": "Ken een tijdzone toe aan alle groepsleden tegelijk",
      "form": {
        "overwrite_timezones": {
          "help": "Indien ingeschakeld, worden medewerkers die al een tijdzone hebben, opnieuw toegewezen aan de geselecteerde tijdzone.",
          "label": "Bestaande tijdzones overschrijven"
        },
        "select_timezone": {
          "help": "Kies een tijdzone die aan alle medewerkers van deze groep wordt toegewezen.",
          "label": "Tijdzone",
          "placeholder": "Kies tijdzone"
        }
      },
      "timezone_assigned": "Tijdzone toegewezen aan groepsleden",
      "title": "Tijdzone in bulk toewijzen"
    },
    "average_resilience_score_text": "Gemiddelde veerkrachttenscore voor medewerkers in deze groep",
    "average_resilience_score_title": "Gemiddelde weerbaarheidsscore",
    "buttons": {
      "add_rule": "Regel toevoegen",
      "assign_manager": "Manager toewijzen",
      "assign_role": "Rol toewijzen",
      "assign_timezone": "Tijdzone toewijzen",
      "cancel": "Annuleren",
      "manage_group": "Beheer medewerkers",
      "remove_managers": "Managers verwijderen",
      "update_group": "Leden bijwerken"
    },
    "delete": {
      "are_you_sure": "Weet je zeker dat je deze groep wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      "button": "Verwijderen",
      "group_deleted": "Groep verwijderd"
    },
    "manage_members": "Groepsleden bewerken",
    "members_count": "Eén lid | {count} medewerkers",
    "membership_rules": "Lidmaatschapsregels",
    "provider": {
      "error": {
        "back": "Kies een andere provider",
        "button": "Integratie configureren",
        "text": "Groepen konden niet worden opgehaald",
        "title": "Kan geen contact opnemen met integratieprovider"
      },
      "group_copied": "Provider-ID gekopieerd naar klembord",
      "heading": "Aanbieder",
      "hide_id": "Id verbergen",
      "id": "ID",
      "latest_sync": "Laatste synchronisatie",
      "never_synced": "Nooit gesynchroniseerd",
      "provider_id": "Provider-ID",
      "refresh": "Gegevens vernieuwen",
      "show_id": "Toon id",
      "sync_started": "Synchronisatie aan de wachtrij toegevoegd",
      "synced": "Gesynchroniseerd",
      "text": "Gegevens gesynchroniseerd met provider"
    },
    "remove_managers": {
      "button": "Alle managers verwijderen",
      "description": "Verwijder de manager van ieder lid van deze groep.",
      "managers_removed": "Managers verwijderd uit groepsleden",
      "message": "Je staat op het punt de manager van alle medewerkers van deze groep te verwijderen. Weet je zeker dat je wilt doorgaan? Deze actie kan niet ongedaan worden gemaakt.",
      "title": "Verwijder alle managers"
    },
    "risk_level": {
      "calculated": "Geërfd risiconiveau",
      "country": "Land",
      "group": "Groep",
      "organisation": "Organisatie",
      "text": "Overzicht van risiconiveaus",
      "title": "Risiconiveau"
    },
    "search": {
      "empty": {
        "title": "Geen groepen gevonden"
      }
    },
    "segment_members": "Groepssegmentatie",
    "segmentation": "Groepering",
    "segments": {
      "create": "Groep aanmaken",
      "create_success": "Groep gemaakt",
      "empty": "Geen groepen gevonden",
      "form": {
        "all": "Alles",
        "any": "Willekeurig",
        "exclude": "Sluit medewerkers met de volgende tags uit:",
        "include": "Leden met de volgende tags opnemen:",
        "name": "Naam",
        "operator": "Operator",
        "select": "Kies tags"
      },
      "heading": "Groepen",
      "members_count": "Eén lid | {count} medewerkers",
      "text": "Gebruik groepen om medewerkers te filteren",
      "update": "Groep bijwerken",
      "update_success": "Groep bijgewerkt"
    },
    "settings": {
      "caution": "Waarschuwing",
      "provider_change_warning": "{caution}: Het wijzigen van de providergegevens voor deze groep zal een nieuwe groepssynchronisatie activeren. Wees ervan bewust dat medewerkers die momenteel aan deze groep zijn toegewezen, mogelijk worden verwijderd als ze niet zijn opgenomen in de bijgewerkte Active Directory-groep. Ga voorzichtig te werk om onbedoelde wijzigingen te voorkomen.",
      "subtitle": "Stel de instellingen van je groep in.",
      "title": "Groepsinstellingen"
    },
    "sync_failed": {
      "button": "Instellingen",
      "recommended_action": "Aanbevolen actie",
      "title": "Synchronisatie mislukt",
      "tooltip": "De synchronisatie van deze groep is mislukt."
    },
    "tags": {
      "create": "Een tag maken",
      "create_success": "Tag aangemaakt",
      "delete_success": "Tag verwijderd",
      "empty": "Geen tags gevonden",
      "heading": "Labels",
      "text": "Gebruik tags om medewerkers te groeperen"
    }
  },
  "human_risk_intelligence": {
    "assignment": {
      "associated_risk_categories": "Gekoppelde risicocategorieën",
      "available": "Beschikbaar",
      "completed": "Voltooid",
      "contextual_risk_factors": "Contextuele risicofactoren",
      "deadline": "Deadline op",
      "details": "Gegevens",
      "details_title": "Toewijzingsdetails",
      "osint": "OSINT",
      "osint_sources_summary": {
        "label": "Geanalyseerde bronnen: {count}",
        "results_count": "{count} resultaat | {count} resultaten"
      },
      "passed": "Geslaagd",
      "rules": "Regels",
      "signals": "Signalen",
      "signals_description": "Signalen die deze toewijzing hebben getriggerd",
      "strategy": "Strategie",
      "title": "Toewijzing"
    },
    "common": {
      "powered_by": "Mogelijk gemaakt door {risk_framework}"
    },
    "content_preview": {
      "title": "Inhoudsvoorbeeld"
    },
    "dashboard_card": {
      "assignments_90_days": "Toewijzingen",
      "enable_button": "Menselijke risico-intelligentie inschakelen",
      "interventions_90_days": "Interventies",
      "score_90_days": "Score",
      "signals_90_days": "Signalen",
      "title": "Menselijke risico-intelligentie"
    },
    "dashboard_signal_collection": {
      "average_day": "Gemiddelde dag",
      "avg_daily": "Gem. per dag",
      "last_90_days": "Laatste 90 dagen",
      "less": "Minder",
      "lowest_day": "Laagste dag",
      "more": "Meer",
      "negative": "Negatief",
      "negative_count": "Negatief: {count}",
      "no_signals_in_range": "Geen signalen in dit bereik",
      "peak_day": "Piekdag",
      "positive": "Positief",
      "positive_count": "Positief: {count}",
      "signal_count": "1 signaal | {count} signalen",
      "signal_count_on_date": "{count} op {date}",
      "signal_range": "{min}-{max} signalen",
      "signals_on_date": "Signalen op {date}",
      "title": "Signaalinname",
      "total_signals": "totale signalen"
    },
    "employee_preview": {
      "access_level": "Toegangsniveau",
      "info": "Info",
      "organizational_role": "Organisatorische rol",
      "resilience_score": "Veerkrachtscore",
      "responsibility_tier": "Verantwoordelijkheidsniveau",
      "role": "Rol",
      "title": "Medewerker"
    },
    "filters": {
      "back": "Terug",
      "data": "Data filteren",
      "filter_by": "Filteren op",
      "search": "Zoeken",
      "select_date": "Selecteer datum"
    },
    "group_breakdown": {
      "columns": {
        "assignments": "Toewijzingen",
        "avg_score": "Gem. score",
        "employees": "Medewerkers",
        "group": "Groep",
        "interventions": "Interventies",
        "signals": "Signalen"
      },
      "description": "Geaggregeerde signalen, toewijzingen en interventies per groep",
      "signals_slideover": {
        "activity_links_title": "Activiteit",
        "links_title": "Signalen",
        "member_count": "{count} leden",
        "title": "Signaaluitsplitsing",
        "view_assignments": "Toewijzingen bekijken",
        "view_interventions": "Interventies bekijken",
        "view_signals": "{sentiment} signalen bekijken"
      },
      "title": "Uitsplitsing per groep"
    },
    "intervention": {
      "details_title": "Interventie",
      "preview_body": "In productie bevat deze e-mail gedragsgebaseerde context en richtlijnen voor de volgende stap.",
      "preview_cta": "Controleer je beveiligingsactiviteit en voltooi eventuele gevraagde vervolgtraining.",
      "preview_from_name": "Moxso Security Team",
      "preview_greeting": "Hoi {name},",
      "preview_intro": "Dit is een voorbeeldweergave van een interventiemelding.",
      "preview_subject": "Beveiligingsmelding",
      "sent_at": "Verzonden",
      "signals_description": "Signalen die deze interventie hebben geactiveerd",
      "title": "Interventie"
    },
    "navigation": {
      "assignments": "Toewijzingen",
      "interventions": "Interventies",
      "osint": "OSINT",
      "overview": "Overzicht",
      "risk_framework": "Risicoraamwerk",
      "signals": "Signalen"
    },
    "notification_title": "Melding",
    "notification_type": "Meldingstype",
    "onboarding": {
      "common": {
        "back": "Terug",
        "cancel": "Annuleren",
        "next": "Volgende"
      },
      "glance": {
        "assignment_limits": "Tot {max} lessen per medewerker, met minimaal {cooldown} dagen tussen toewijzingen",
        "eligibility": "Medewerkers komen in aanmerking voor training {min_days} dagen na start.",
        "lesson_selection": "Lessen worden automatisch toegewezen: {selection}",
        "notifications_disabled": "Meldingen uitgeschakeld",
        "notifications_enabled": "Meldingen ingeschakeld met frequentie {frequency}. {behavior}"
      },
      "interventions": {
        "heading": "Gedraggestuurde interventies",
        "subheading": "Bepaal welke gedragssignalen een directe reactie buiten de reguliere cadans activeren: een corrigerende trainingstoewijzing, een melding aan de manager van de medewerker of een waarschuwing aan uw beveiligingsbeheerders."
      },
      "intro": {
        "benefits": {
          "better_outcomes": {
            "description": "Richt middelen waar ze het meest tellen",
            "title": "Betere resultaten"
          },
          "continuous_adaptation": {
            "description": "Het systeem leert en past zich aan op basis van doorlopend gedrag",
            "title": "Doorlopende aanpassing"
          },
          "personalized_experience": {
            "description": "Elke medewerker krijgt training op maat",
            "title": "Gepersonaliseerde ervaring"
          }
        },
        "description": "Human Risk Intelligence zet gedragssignalen om in individuele risicoprofielen en wijst vervolgens de trainingen en simulaties toe die elke medewerker daadwerkelijk nodig heeft. Content wordt gekalibreerd op basis van waar iemand zich bevindt in het Moxso Risk Framework en opnieuw gekalibreerd wanneer er nieuwe signalen binnenkomen. Het risico daalt zonder het trainingsvolume te verhogen.",
        "heading": "Wat is Human Risk Intelligence?",
        "setup_button": "Human Risk Intelligence instellen",
        "subheading": "Train elke medewerker op de risico's die echt op hen van toepassing zijn, en stop met trainen op risico's die dat niet zijn."
      },
      "review": {
        "at_a_glance": "In één oogopslag",
        "enable_button": "Human Risk Intelligence inschakelen",
        "heading": "Klaar om in te schakelen",
        "next": {
          "heading": "Wat gebeurt er daarna",
          "items": {
            "analysis_starts_immediately": "Moxso begint direct met het verzamelen van gedragssignalen in de hele organisatie.",
            "no_lessons_assigned_immediately_prefix": "Training wordt na 24 uur geleverd.",
            "no_lessons_assigned_immediately_suffix": "Tegen die tijd heeft het systeem genoeg geleerd om voor elke medewerker een betrouwbaar risicoprofiel op te bouwen.",
            "settings_can_be_changed_anytime": "Deze instellingen kunnen op elk moment worden gewijzigd, of Human Risk Intelligence kan worden uitgeschakeld."
          }
        },
        "settings_link": "Meer controle nodig? Pas geavanceerde instellingen aan",
        "subheading": "Dit gebeurt wanneer je Human Risk Intelligence inschakelt."
      },
      "selection": {
        "heading": "Trainingsstrategie",
        "subheading": "Kies hoe Moxso doorlopende training in de hele organisatie prioriteert en toewijst."
      },
      "signals": {
        "heading": "Signalen",
        "subheading": "Configureer hoe signalen beslissingen van menselijke risico-intelligentie beïnvloeden"
      },
      "steps": {
        "interventions": "Interventies",
        "introduction": "Introductie",
        "review": "Controleren en inschakelen",
        "training_strategy": "Trainingsstrategie"
      }
    },
    "osint_explanation": {
      "description": "De Moxso OSINT-engine bewaakt continu het wereldwijde dreigingslandschap en zet openbare cybersecurity-informatie om in bruikbare inzichten over menselijke risico's.",
      "title": "De Moxso OSINT-engine (Open-Source Intelligence)"
    },
    "osint_news": {
      "empty": {
        "description": "Geen OSINT-gegevens gevonden voor dit risico",
        "heading": "OSINT-gegevens niet beschikbaar"
      },
      "title": "Threat intelligence-feed"
    },
    "pages": {
      "assignments": {
        "heading": "Adaptieve toewijzingen",
        "subheading": "Bekijk en beheer toewijzingen van menselijke risico-intelligentie."
      },
      "interventions": {
        "heading": "Interventies",
        "subheading": "Interventies die worden geactiveerd door gedrag van medewerkers binnen beveiligingsactiviteiten."
      },
      "osint": {
        "article": {
          "associated_risk_indicators": "Gekoppelde risico-indicatoren",
          "hide": "Verbergen",
          "indicator_count": "{count} indicator | {count} indicatoren",
          "neutral_count": "{count} neutraal | {count} neutrale",
          "risky_count": "{count} risicovol | {count} risicovolle",
          "show": "Tonen",
          "vigilant_count": "{count} waakzaam | {count} waakzame"
        },
        "breaches": "Lekken",
        "current": "Huidig",
        "heading": "Dreigingsinformatiefeed",
        "indicators": {
          "description": "Top in de afgelopen 24 uur",
          "empty": {
            "description": "Indicatoractiviteit wordt hier weergegeven wanneer de feed getagde risico's bevat.",
            "heading": "Nog geen indicatoren"
          },
          "title": "Risico-indicatoren"
        },
        "negative_neutral": "Aandacht nodig: Signaalactiviteit verslechtert",
        "negative_risky": "Waarschuwing: Dreigingsactiviteit neemt toe",
        "negative_vigilant": "Aandacht nodig: Beveiligingsmaatregelen nemen af",
        "news": {
          "description": "Afgelopen 24 uur",
          "title": "Nieuws"
        },
        "no_change": "Geen verandering in signaalactiviteit",
        "positive_neutral": "Positieve trend: Signaalactiviteit verbetert",
        "positive_risky": "Positieve trend: Dreigingsactiviteit neemt af",
        "positive_vigilant": "Positieve trend: Beveiligingshouding verbetert",
        "previous": "Vorige",
        "risk_themes": "Risicothema's",
        "signal_change": "Signaalverandering",
        "sources": {
          "description": "Actieve bronnen in de afgelopen 24 uur",
          "empty": {
            "description": "Bronactiviteit wordt hier weergegeven wanneer de feed artikelen bevat.",
            "heading": "Nog geen bronnen"
          },
          "title": "Bronnen"
        },
        "subheading": "Volg externe signalen die gekoppeld zijn aan je gemonitorde risicothema's."
      },
      "overview": {
        "subheading": "Overzicht van activiteit en inzichten van menselijke risico-intelligentie."
      },
      "risk_framework": {
        "heading": "Risicoraamwerk",
        "subheading": "Het Moxso-raamwerk voor het beoordelen en beheren van menselijke beveiligingsrisico's."
      },
      "signals": {
        "heading": "Gedragssignalen",
        "subheading": "Bekijk alle signalen verzameld uit gedrag van medewerkers."
      }
    },
    "risk_category": {
      "change": "Verandering",
      "consequences": "Gevolgen",
      "details_title": "Details van risicocategorie",
      "importance": "Belang",
      "indicators": "Indicatoren",
      "overview_title": "Overzicht risicocategorie",
      "relevance": "Relevantie",
      "tabs": {
        "details": "Details",
        "indicators": "Indicatoren"
      }
    },
    "risk_framework": {
      "change_tooltip": "Verandering in de laatste 90 dagen",
      "description_1": "Het Moxso-risicoraamwerk is een datagedreven model om menselijke cyberrisico's in moderne organisaties te identificeren, kwantificeren en operationaliseren.",
      "description_2": "Het is afgestemd op industriestandaarden zoals MITRE ATT&CK en het NIST Cybersecurity Framework en breidt traditionele controlegerichte modellen uit door specifiek te focussen op menselijk gedrag als aanvalsvector. Het raamwerk zet gedragsdata uit de praktijk, signalen over dreigingsblootstelling en structurele risicofactoren om in meetbare en auditbare risico-indicatoren.",
      "description_3": "Het raamwerk is georganiseerd in 16 mensgerichte risicocategorieën (R.01-R.16) en levert consistente scores, bruikbare inzichten en compliancegerichte rapportage.",
      "references": "Raamwerkreferenties",
      "short_description": "Het Moxso-risicoraamwerk is een datagedreven model om menselijke cyberrisico's in moderne organisaties te identificeren, kwantificeren en operationaliseren.",
      "title": "Risicoraamwerk"
    },
    "risk_matrix": {
      "axes": {
        "impact": "Impact",
        "likelihood": "Waarschijnlijkheid"
      },
      "legend": {
        "high": "Hoog",
        "low": "Laag",
        "med": "Gem."
      },
      "title": "Signaalrisicomatrix",
      "tooltip": {
        "change": "Verandering",
        "current": "Huidig",
        "high": "Signalen met hoog risico",
        "low": "Signalen met laag risico",
        "medium": "Signalen met gemiddeld risico",
        "previous": "Vorige"
      }
    },
    "sections": {
      "recent_assignments": "Recente toewijzingen",
      "recent_interventions": "Recente interventies",
      "recent_signals": "Recente signalen"
    },
    "settings": {
      "common": {
        "days": "{days} dagen",
        "disabled": "Uitgeschakeld",
        "enabled": "Ingeschakeld",
        "every_days": "Elke {days} dagen",
        "no": "Nee",
        "none": "Geen",
        "yes": "Ja"
      },
      "eligibility": {
        "criteria_title": "Geschiktheidscriteria",
        "description": "Bepaal wie in aanmerking komt voor menselijke risico-intelligentie",
        "excluded_groups": "Uitgesloten groepen",
        "excluded_groups_help": "Sluit specifieke groepen uit van geautomatiseerde trainingsflows",
        "excluded_roles": "Uitgesloten rollen",
        "excluded_roles_help": "Sluit specifieke organisatorische rollen uit van geautomatiseerde trainingsflows",
        "minimum_employment_duration_help": "Medewerkers moeten minimaal dit aantal dagen in dienst zijn om in aanmerking te komen",
        "minimum_employment_duration_label": "Minimale dienstduur (dagen)",
        "targeting_title": "Targeting",
        "title": "Geschiktheid"
      },
      "interventions": {
        "actions": {
          "add_action": "Actie toevoegen",
          "assign_new_lesson": "Nieuwe les toewijzen",
          "assignment_description": "Wijs corrigerende training toe aan de betreffende medewerker.",
          "empty": "Nog geen acties. Voeg er een toe om te bepalen wat er gebeurt wanneer deze groep wordt geactiveerd.",
          "heading": "Acties bij activatie",
          "notify_admin": "Beheerders informeren",
          "notify_admin_description": "E-mail een in aanmerking komende Moxso-workspacebeheerder.",
          "notify_employee": "Medewerker informeren",
          "notify_employee_description": "E-mail de betreffende medewerker over het gedetecteerde gedrag.",
          "notify_manager": "Manager informeren",
          "notify_manager_description": "E-mail de actieve manager van de medewerker.",
          "remove_action": "{action} verwijderen"
        },
        "enable_subtitle": "Laat menselijke risico-intelligentie normale toewijzingsregels doorbreken wanneer hoogrisicogedrag wordt gedetecteerd, en escaleren naar managers en beveiligingsbeheerders.",
        "enable_title": "Interventies inschakelen",
        "excluded_groups": "Uitgesloten groepen",
        "excluded_groups_help": "Medewerkers in deze groepen worden nooit gericht met interventie-overschrijvingen.",
        "excluded_roles": "Uitgesloten rollen",
        "excluded_roles_description": "Medewerkers in deze rollen worden nooit gericht met interventie-overschrijvingen.",
        "groups_description": "Kies welke signaalgroepen u wilt bewaken en configureer de reactie voor elke groep.",
        "groups_title": "Interventiesignaalgroepen",
        "severity_label": "Ernst van overschrijding",
        "threshold_label": "Activeringsdrempel",
        "threshold_occurrences": "{count} gebeurtenis | {count} gebeurtenissen",
        "timeframe_days": "Elke {days} dagen",
        "timeframe_label": "Tijdsperiode",
        "timeframe_within_90_days": "Binnen 90 dagen",
        "triggers": {
          "breach_exposure": {
            "description": "Sta directe toewijzing toe wanneer een medewerker voorkomt in een bekend datalek.",
            "title": "Datalekblootstelling"
          },
          "phishing_failures": {
            "description": "Sta directe toewijzing toe nadat medewerkers een simulatie niet halen.",
            "title": "Mislukte phishing-simulaties"
          },
          "training_non_compliance": {
            "description": "Sta directe toewijzing toe wanneer verplichte training over tijd is.",
            "title": "Niet-naleving van training"
          }
        },
        "triggers_description": "Kies welke gebeurtenissen directe training en escalatie naar managers of beveiligingsbeheerders kunnen activeren, ook als een medewerker recent andere training kreeg.",
        "triggers_title": "Interventie triggers"
      },
      "notifications": {
        "continuous_sending_subtitle": "Stuur herinneringsmeldingen tot voltooiing",
        "continuous_sending_title": "Doorlopend verzenden",
        "enable_subtitle": "Stuur e-mailmeldingen voor nieuwe toewijzingen",
        "enable_title": "Inschakelen meldingen",
        "frequency": {
          "intense": "Intens",
          "loose": "Los",
          "normal": "Normaal (Per toewijzing)",
          "per_assignment": "Per toewijzing"
        },
        "frequency_label": "Meldingsfrequentie",
        "title": "Meldingen"
      },
      "review": {
        "enable_subtitle": "Start gepersonaliseerde trainingstoewijzingen op basis van gedrag van medewerkers",
        "enable_title": "Menselijke risico-intelligentie inschakelen",
        "frequency": "Frequentie",
        "max_assignments_per_run": "Max. toewijzingen per run: {value}",
        "notifications": "Meldingen",
        "reminders_until_completion": "Herinneringen tot voltooiing",
        "save_settings": "Instellingen opslaan",
        "selection": "Selectie",
        "title": "Controleren en inschakelen"
      },
      "selection_strategy": {
        "avoid_repetition_help": "Wijs dezelfde les niet opnieuw toe binnen deze periode.",
        "avoid_repetition_label": "Vermijd herhaling van dezelfde training (dagen)",
        "cooldown_help": "Wacht voordat nieuwe menselijke risico-intelligentie wordt toegewezen na een training.",
        "cooldown_label": "Afkoelperiode (dagen)",
        "enable_subtitle": "Laat Human Risk Intelligence doorlopende training toewijzen op basis van risicoprofielen van medewerkers.",
        "enable_title": "Human Risk Intelligence inschakelen",
        "excluded_videos": "Uitgesloten video's",
        "excluded_videos_description": "Deze video's worden nooit toegewezen door Human Risk Intelligence.",
        "excluded_videos_placeholder": "Selecteer video's",
        "frameworks_help": "Selecteer een of meer raamwerken om training te prioriteren die aansluit op je compliance-doelen.",
        "frameworks_label": "Raamwerken",
        "frameworks_placeholder": "Selecteer raamwerken",
        "hide_advanced_settings": "Geavanceerde instellingen verbergen",
        "interval_help": "Minimaal aantal dagen tussen voltooide trainingen en nieuwe toewijzingen.",
        "interval_label": "Interval (dagen)",
        "label": "Selectiestrategie",
        "max_assignments_per_run_help": "Maximum aantal nieuwe trainingen per medewerker in één evaluatie.",
        "max_assignments_per_run_label": "Max. toewijzingen per run",
        "show_advanced_settings": "Geavanceerde instellingen tonen"
      },
      "signals": {
        "failed_simulation": "Mislukte simulatie",
        "failed_simulation_help": "Weging die wordt toegepast wanneer een medewerker op een phishing-simulatie klikt",
        "low_score": "Laag score",
        "low_score_help": "Weging die wordt toegepast wanneer trainingsquizscores onder de drempel liggen"
      },
      "summary_eligibility": {
        "description": "Bepaalt wie in aanmerking komt voor menselijke risico-intelligentie",
        "excluded_roles": "Uitgesloten rollen",
        "minimum_employment_duration": "Minimale duur van dienstverband",
        "title": "Geschiktheid"
      },
      "summary_selection": {
        "description": "Bepaalt hoe lessen worden geselecteerd en hoe medewerkers worden geïnformeerd",
        "email_notifications": "E-mail meldingen",
        "lesson_selection": "Lesselectie",
        "maximum_lessons_per_employee": "Maximum aantal lessen per medewerker",
        "minimum_time_between_lessons": "Minimale tijd tussen lessen",
        "notification_settings": "Meldingsinstellingen",
        "notification_style": "Meldingsstijl",
        "prioritize_mandatory_training": "Prioriteer verplichte training",
        "selection_approach": "Selectiebenadering",
        "send_reminders_until_complete": "Stuur herinneringen tot voltooid",
        "standard_training_interval": "Standaard trainingsinterval",
        "title": "Selecties en meldingen"
      },
      "summary_signals": {
        "description": "Bepaalt hoe signalen beslissingen van menselijke risico-intelligentie beïnvloeden",
        "impact": {
          "high": "Hoge impact",
          "low": "Lage impact",
          "medium": "Gemiddelde impact"
        },
        "signal_labels": {
          "failed_simulation": "Mislukte phishing-simulatie",
          "low_score": "Lage trainingsscore"
        },
        "title": "Signalen"
      }
    },
    "signal": {
      "associated_risk_categories": "Gekoppelde risicocategorieën",
      "behaviour": "Gedrag",
      "category": "Categorie",
      "indicator": "Indicator",
      "intel": "Informatie",
      "no": "Nee",
      "polarity": "Polariteit",
      "sentiment": "Gevoel",
      "title": "Signaal",
      "value": "Waarde",
      "yes": "Ja"
    },
    "signal_preview": {
      "breach": {
        "title": "Darkwebmonitor"
      },
      "multiple_choice_quiz_answer": {
        "answer": "Antwoord",
        "question": "Vraag",
        "title": "Quizantwoord"
      },
      "phishing_quiz_answer": {
        "correct": "Correct",
        "incorrect": "Onjuist",
        "question": "Vraag",
        "result": "Resultaat",
        "subject": "Onderwerp",
        "time": "Tijd",
        "title": "Antwoord op phishingquiz"
      }
    },
    "stats": {
      "assignments": "Toewijzingen",
      "completed_assignments": "Voltooide toewijzingen",
      "interventions": "Interventies",
      "negative_signals": "Negatieve signalen",
      "positive_signals": "Positieve signalen",
      "risk_level": {
        "country_risk": "Landrisico",
        "industry_risk": "Branche risico",
        "levels": {
          "high": "Hoog",
          "loading": "Laden",
          "low": "Laag",
          "medium": "Gemiddeld"
        },
        "title": "Risiconiveau"
      },
      "signals": "Signalen"
    },
    "tables": {
      "negative": "Negatief",
      "neutral": "Neutraal",
      "sentiment": "Gevoel",
      "severity": "Ernst",
      "signal_count": "1 signaal | {count} signalen",
      "signal_type": "Signaal"
    },
    "title": "Human Risk Intelligence",
    "tooltips": {
      "compared_to_prior_period": "Vergeleken met de vorige periode van gelijke lengte.",
      "previous_value": "Vorige waarde"
    },
    "trending_risk_indicators": "Trending risico-indicatoren"
  },
  "image_library": {
    "empty_button": "Afbeelding uploaden",
    "empty_description": "Upload je eerste afbeelding om een herbruikbare bibliotheek op te bouwen.",
    "empty_title": "Nog geen afbeeldingen",
    "image_format": "JPG/JPEG/PNG · Tot 1MB",
    "image_uploaded": "Afbeelding succesvol geüpload",
    "insert_button": "Afbeelding invoegen",
    "library_tab": "Afbeeldingenbibliotheek",
    "refresh": "Vernieuwen",
    "show_more": "Meer weergeven",
    "title": "Afbeelding invoegen",
    "upload_tab": "Uploaden",
    "upload_title": "Nieuwe afbeelding uploaden"
  },
  "locale": {
    "current": "Nederlands",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "french": "Français",
    "norwegian": "Norwegian",
    "polish": "Polski",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "back_to_login": "Terug naar inloggen",
    "button": "Inloggen",
    "change_email": "E-mail wijzigen?",
    "continue": "Doorgaan",
    "forgot_password": {
      "link": "Stel het nu opnieuw in",
      "text": "Wachtwoord vergeten?"
    },
    "heading": "Welkom terug",
    "loading": "Laden",
    "preparing_session": "Sessie voorbereiden",
    "sso": {
      "provider_found": "SSO is beschikbaar voor {provider}. Ga verder om in te loggen via je identity provider.",
      "redirecting": "Doorsturen naar SSO",
      "redirecting_text": "We bereiden je aanmeldverzoek voor.",
      "validating": "SSO valideren",
      "validating_text": "We ronden je aanmelding af."
    },
    "text": "Meld je aan bij je organisatie"
  },
  "manager_report": {
    "assignment": "Opdracht",
    "assignments": "Opdrachten",
    "company_average": "Bedrijfsgemiddelde",
    "compared_against": "Vergeleken met {period}",
    "completed": "Voltooid",
    "date": "Datum",
    "days_overdue": "Dagen te laat",
    "deadline": "Deadline",
    "deadlines_description": "{count} opdrachten overschreden hun deadline tijdens {period}.",
    "department": "Afdeling",
    "employee": "Medewerker",
    "employees_affected": "Betrokken medewerkers",
    "employees_at_risk": "Medewerkers met risico",
    "gap_to_company": "Verschil met bedrijf",
    "generated": "Gegenereerd op {date}",
    "human_risk_intelligence": "Human Risk Intelligence",
    "individual_reports": "Individuele trainings- en risicorapporten · {count} medewerkers | Individueel trainings- en risicorapport · {count} medewerker | Individuele trainings- en risicorapporten · {count} medewerkers",
    "interventions": "Recente interventies geactiveerd door Moxso",
    "loading": "Managementrapport laden…",
    "missed_deadlines": "Gemiste deadlines",
    "missed_team_deadlines": "Gemiste teamdeadlines",
    "most_dangerous_signals": "De 3 gevaarlijkste signalen in deze periode",
    "no_assignments": "Geen opdrachten",
    "no_dangerous_signals": "Geen gevaarlijke signalen",
    "no_employees_at_risk": "Geen medewerkers met risico",
    "no_interventions": "Geen interventies geactiveerd",
    "no_missed_deadlines": "Geen gemiste deadlines",
    "no_recent_signals": "Geen recente signalen",
    "no_sentiment_data": "Geen sentimentgegevens",
    "no_severity_data": "Geen ernstgegevens",
    "oldest_deadline": "Oudste deadline",
    "overdue_assignments": "Achterstallige opdrachten",
    "period_over_period": "Vergeleken met de vorige periode",
    "points": "{points} pt",
    "recent_signals": "Recente signalen",
    "risk_indicator": "Risico-indicator",
    "score": "Score",
    "sentiment": "Sentiment",
    "severity": "Ernst",
    "signal": "Signaal",
    "signals": "Signalen",
    "signals_by_sentiment": "Signalen per sentiment",
    "signals_by_severity": "Signalen per ernst",
    "sorted_by_deadline": "Gesorteerd op deadline",
    "status": "Status",
    "summary": "Samenvatting",
    "team_average": "Teamgemiddelde",
    "threshold": "Drempel {value}% · laag naar hoog",
    "title": "Managementrapport",
    "total": "{count} totaal",
    "training_report": "Trainingsrapport",
    "trend_title": "Weerbaarheid, klik- en rapportagepercentage",
    "type": "Type",
    "unavailable": "Rapport niet beschikbaar",
    "unavailable_description": "Het rapport kon niet worden geladen. Controleer of de rapportlink geldig en niet verlopen is."
  },
  "navigation": {
    "assigned_learning": "Toegewezen leerinhoud",
    "at_risk": "Medewerkers met verhoogd risico",
    "audit": {
      "index": "Controle",
      "settings": "Instellingen"
    },
    "automation": {
      "flow_builder": "Sequentiebouwer",
      "index": "Automatisering",
      "sequence": "Automatisering",
      "settings": "Instellingen"
    },
    "breaches": "Datalekken",
    "configuration": "Configuratie",
    "custom_upload": {
      "edit": "Bewerk",
      "quiz": "Kwis"
    },
    "dashboard": "Analyses",
    "employees": "Medewerkers",
    "goals": "Doelen",
    "groups": {
      "index": "Groepen",
      "settings": "Instellingen",
      "single": "Groep"
    },
    "human_risk_intelligence": "Menselijke risico-intelligentie",
    "integration": {
      "activity": "Activiteit",
      "settings": "Instellingen"
    },
    "integrations": "Integraties",
    "knowledge_base": "Kennisbank",
    "lessons_courses": "Cursussen",
    "lessons_deadlines": "Deadlines",
    "lessons_videos": "Video's",
    "no_workspaces": "Geen werkruimten gevonden",
    "overview": "Overzicht",
    "policies": "Beleidsregels",
    "policy": {
      "edit": "Bewerken",
      "quiz": "Quiz"
    },
    "resilience": "Weerbaarheid",
    "search_workspaces": "Werkruimtes zoeken",
    "settings": {
      "administration": "Beheer",
      "admins": "Beheerders",
      "apis_and_data": "API’s en gegevens",
      "audit_logs": "Auditlogboeken",
      "authentication": "Authenticatie",
      "back_to_app": "Terug naar de app",
      "breaches": "Datalekken",
      "close_navigation": "Navigatie sluiten",
      "compliance": "Naleving",
      "domains": "Domeinen",
      "e_learning": "Training",
      "export": "Exporteren",
      "exports": "Export",
      "goals": "Doelen",
      "human_risk_intelligence": "Menselijke risico-intelligentie",
      "import": "Importeren",
      "index": "Instellingen",
      "interventions": "Interventies",
      "personal": "Persoonlijk",
      "reporting": "Rapportage",
      "risk": "Risico",
      "simulations": "Simulaties",
      "threats": "Dreigingen",
      "workspace": "Werkruimte"
    },
    "sign_out": "Afmelden",
    "simulations": {
      "custom_templates": "Aangepaste templates",
      "index": "Simulaties",
      "scheduled": "Gepland",
      "single": "Activiteit",
      "single_settings": "Instellingen"
    },
    "team": "Medewerkers",
    "threats": "Dreigingen",
    "training": "Training",
    "user_settings": "Beveiliging en toegang",
    "your_workspaces": "Jouw werkruimten"
  },
  "oauth": {
    "back_to_home": "Terug naar start",
    "error": "Integratie kon niet worden geconfigureerd",
    "login": "Inloggen",
    "success": "Provider succesvol opgeslagen"
  },
  "onboarding": {
    "building_training_paths": "Trainingpaden opbouwen",
    "calculating_risk_score": "Weerbaarheidsscore berekenen",
    "choose_provider": "Kies je identiteitsprovider",
    "continue_button": "Doorgaan",
    "exit": "Afsluiten",
    "gmail_integration": "Gmail-integratie",
    "google_manual_setup": {
      "access_google_admin_console_heading": "Google Admin Console openen",
      "access_google_admin_console_text": "Log in bij de Google Workspace-beheerconsole: {google_admin_console_link}",
      "allow_moxso_ip_addresses_bullet_1": "Vouw de sectie {email_allowlist} uit.",
      "allow_moxso_ip_addresses_bullet_2": "Voer de volgende Moxso IP-adressen in: {ip_1} {ip_2}",
      "allow_moxso_ip_addresses_bullet_3": "Klik op {save_button}.",
      "allow_moxso_ip_addresses_heading": "Sta Moxso IP-adressen toe",
      "configure_inbound_gateway_bullet_1": "Vouw de sectie {inbound_gateway} uit.",
      "configure_inbound_gateway_bullet_2": "Schakel de gateway in door de schakelaar om te zetten.",
      "configure_inbound_gateway_bullet_3": "Voer de volgende Moxso IP-adressen in onder {gateway_ips}: {ip_1} {ip_2}",
      "configure_inbound_gateway_bullet_4": "Schakel {require_tls} in.",
      "configure_inbound_gateway_bullet_5": "In de sectie {message_tagging_section}, schakel {message_spam_eval_header} in.",
      "configure_inbound_gateway_bullet_6": "Voer de volgende waarde in het {regexp_field}-veld in: {uuid}",
      "configure_inbound_gateway_bullet_7": "Schakel {disable_gmail_spam_eval} in.",
      "configure_inbound_gateway_bullet_8": "Klik op {save_button} om de instellingen toe te passen.",
      "configure_inbound_gateway_heading": "Inbound Gateway configureren",
      "configure_spam_rule_bullet_1": "Navigeer naar {spam_settings}: Zoek in hetzelfde menu {menu_path} de sectie Spam.",
      "configure_spam_rule_bullet_2": "Voeg een nieuwe regel toe: Klik op {add_rule} (of bewerk een bestaande Moxso-regel) en geef deze een naam zoals {rule_name}.",
      "configure_spam_rule_bullet_3": "Configureer de bypass: Selecteer {bypass_option}",
      "configure_spam_rule_bullet_4": "Waarschuwingen verbergen (kritiek): Zorg dat je {hide_warnings_option} aanvinkt",
      "configure_spam_rule_bullet_5": "Zorg dat de simulatiedomeinen aan de adressenlijst van deze regel worden toegevoegd door de CSV te downloaden:",
      "configure_spam_rule_bullet_6": "Sla de regel op.",
      "configure_spam_rule_heading": "Spamregel configureren (waarschuwingen omzeilen)",
      "disable_gmail_spam_eval": "Schakel Gmail-spamevaluatie uit voor mail van deze gateway; gebruik alleen de headerwaarde.",
      "email_allowlist": "E-mailtoelatingslijst",
      "gateway_ips": "Gateway-IP's",
      "google_admin_console": "Google Admin Console",
      "inbound_gateway": "Inkomende gateway",
      "inbound_gateway_warning_not_checked": "niet aangevinkt",
      "inbound_gateway_warning_text": "Zorg ervoor dat {reject_option} {not_checked} is. Als deze optie ingeschakeld blijft, kun je alleen e-mails van Moxso ontvangen en niet van externe afzenders.",
      "message_spam_eval_header": "Bericht wordt als spam beschouwd als de volgende header-regexp overeenkomt",
      "message_tagging": "Berichttagging",
      "navigate_spam_phishing_malware_heading": "Navigeer naar de instellingen voor spam, phishing en malware",
      "navigate_spam_phishing_malware_text": "Ga naar de Gmail-instellingen voor spam, phishing en malware: {spam_phishing_link}",
      "regexp": "Regexp",
      "require_tls": "Vereis TLS voor verbindingen vanaf de hierboven genoemde e-mailgateways.",
      "save": "Opslaan",
      "spam_phishing_malware_settings": "Instellingen voor spam, phishing en malware",
      "whitelisting_moxso_ip_addresses_in_gw": "Moxso IP-adressen toestaan in Google Workspace"
    },
    "import_employees": "Medewerkers importeren",
    "integration_error": "Er is een fout opgetreden bij het instellen van de integratie met {provider}.",
    "integration_error_title": "Er is een fout opgetreden",
    "invite": {
      "button": "Gebruiker uitnodigen",
      "text": "We sturen hen een e-mail om te beginnen.",
      "title": "Nodig teamleden uit op je dashboard"
    },
    "microsoft_bypass_junk_by_header": {
      "bypass_junk_by_header": "Omzeil Ongewenste E-mail Door Header",
      "finish": "Afronden",
      "step_1_heading": "Exchange-beheercentrum",
      "step_1_text": "Navigeer naar Mail Flow-regels in het Exchange-beheercentrum door de volgende URL te bezoeken: {url}",
      "step_2_heading": "Maak een nieuwe regel",
      "step_2_text": "Maak een nieuwe regel en geef deze een naam. Bijvoorbeeld: {copyField}",
      "step_2b_heading": "Regel configureren",
      "step_2b_list_1": "Kies \"The message headers...\"",
      "step_2b_list_2": "Komt overeen met deze tekstpatronen.",
      "step_2b_p1": "Klik op de eerste link \"Tekst invoeren\" en voer de header-sleutel in: {copyField}",
      "step_2b_p2": "Klik op de volgende link \"Voer tekst in\" en voer de volgende kopwaarde in: {copyField}",
      "step_2b_text": "In het uitklapmenu \"Pas deze regel toe als\":",
      "step_3_heading": "Berichtkop instellen",
      "step_3_list_1": "Kies \"De bericht eigenschappen wijzigen\"",
      "step_3_list_2": "Kies vervolgens \"Een berichtkop instellen\".",
      "step_3_list_3": "Klik op de eerste link \"Tekst invoeren\" en stel de header in op: {copyField}",
      "step_3_list_4": "Klik op de tweede link \"Tekst invoeren\" en stel de waarde in op: {copyField}",
      "step_3_text": "In het vervolgkeuzemenu \"Doe het volgende\":",
      "step_4_heading": "Regelinstellingen",
      "step_4_list_1": "Klik op \"volgende\" en ga door naar regelinstellingen.",
      "step_4_list_2": "Kies onder \"Regelmodus\" de optie \"Afdwingen\".",
      "step_4_list_3": "Klik op \"volgende\" en controleer de regelconfiguratie.",
      "step_5_heading": "De regel opslaan",
      "step_5_text": "Klik op {finish} om de regel op te slaan en toe te passen."
    },
    "microsoft_bypass_junk_by_ip": {
      "bypass_junk_by_ip": "Omzeil Ongewenst Door IP-adres",
      "configure_message_header_heading": "Berichtkop configureren",
      "configure_message_header_text_bullet_1": "Kies {modify_message_props}",
      "configure_message_header_text_bullet_2": "Kies vervolgens {set_msg_header}",
      "configure_message_header_text_bullet_3": "Klik op de eerste \"Tekst invoeren\" link en stel de kop in op: {header}",
      "configure_message_header_text_bullet_4": "Klik op de tweede link \"Tekst invoeren\" en stel de waarde in op: {value}",
      "configure_message_header_text_intro": "In het dropdownmenu \"Doe het volgende\":",
      "configure_rule_heading": "De regel configureren",
      "configure_rule_text_bullet_1": "Kies {the_sender}",
      "configure_rule_text_bullet_2": "Kies vervolgens {ip_range}",
      "configure_rule_text_bullet_3": "Voer de volgende IP-adressen één voor één in het pop-upvenster in en klik op \"Toevoegen\". Klik op \"Opslaan\" wanneer je klaar bent.",
      "configure_rule_text_intro": "In het \"Pas deze regel toe indien\" keuzemenu:",
      "create_new_rule_heading": "Maak een nieuwe regel aan",
      "create_new_rule_text": "Maak een nieuwe regel aan en geef deze een naam. Bijvoorbeeld: {example}",
      "exchange_admin_center_heading": "Beheercentrum voor Exchange",
      "exchange_admin_center_text": "Navigeer naar Mailstroomregels in het Exchange-beheercentrum door de volgende URL te bezoeken: {url}",
      "rule_settings_bullet_1": "Klik op \"volgende\" en ga verder naar regelinstellingen.",
      "rule_settings_bullet_2": "Onder \"Regelmodus\" selecteer \"Handhaven\".",
      "rule_settings_bullet_3": "Klik op \"volgende\" en bekijk de regelconfiguratie.",
      "rule_settings_heading": "Regelinstellingen",
      "save_the_rule_heading": "De regel opslaan",
      "save_the_rule_text": "Klik op {finish} om de regel op te slaan en toe te passen."
    },
    "microsoft_bypass_safe_links_by_header": {
      "bypass_safe_links_by_header": "Veilige koppelingen omzeilen via header",
      "configure_message_header_heading": "Koptekst van bericht configureren",
      "configure_message_header_text_bullet_1": "Kies {modify_message_properties}",
      "configure_message_header_text_bullet_2": "Kies vervolgens {set_a_message_header}",
      "configure_message_header_text_bullet_3": "Klik op de eerste link \"Tekst invoeren\" en stel de kop in op: {header}",
      "configure_message_header_text_bullet_4": "Klik op de tweede link \"Tekst invoeren\" en stel de waarde in op: {value}",
      "configure_message_header_text_intro": "In het vervolgkeuzemenu \"Voer het volgende uit\":",
      "configure_rule_heading": "Regel configureren",
      "configure_rule_text_bullet_1": "Kies {the_message_headers}",
      "configure_rule_text_bullet_2": "Kies vervolgens {matches_text_patterns}",
      "configure_rule_text_intro": "In het menu \"Pas deze regel toe als\" uitklaplijst:",
      "configure_rule_text_paragraph_1": "Klik op de eerste link \"Tekst invoeren\" en voer de header-sleutel in: {header_key}",
      "configure_rule_text_paragraph_2": "Klik op de volgende link \"Tekst invoeren\" en voer de volgende headerwaarde in: {header_value}",
      "create_new_rule_heading": "Een nieuwe regel maken",
      "create_new_rule_text": "Maak een nieuwe regel aan en geef deze een naam. Bijvoorbeeld: {example}",
      "exchange_admin_center_heading": "Beheercentrum voor Exchange",
      "exchange_admin_center_text": "Navigeer naar de mailstroomregels in het Exchange-beheercentrum door de volgende URL te bezoeken: {url}",
      "rule_settings_bullet_1": "Klik op \"volgende\" en ga verder naar regelinstellingen.",
      "rule_settings_bullet_2": "Onder \"Regelmodus\" selecteer \"Afdwingen\".",
      "rule_settings_bullet_3": "Klik op \"volgende\" en controleer de regelconfiguratie.",
      "rule_settings_heading": "Instellingen voor regels",
      "save_the_rule_heading": "De regel opslaan",
      "save_the_rule_text": "Klik op {finish} om de regel op te slaan en toe te passen."
    },
    "microsoft_bypass_safe_links_by_ip": {
      "bypass_safe_links_by_ip": "IP-adressen voor veilige links omzeilen",
      "configure_message_header_heading": "Configuratie van berichtkoptekst",
      "configure_message_header_text_bullet_1": "Kies {modify_message_props}",
      "configure_message_header_text_bullet_2": "Kies vervolgens {set_msg_header}",
      "configure_message_header_text_bullet_3": "Klik op de eerste link \"Tekst invoeren\" en stel de header in op: {header}",
      "configure_message_header_text_bullet_4": "Klik op de tweede \"Tekst invoeren\" link en stel de waarde in op: {value}",
      "configure_message_header_text_intro": "In het vervolgkeuzemenu \"Doe het volgende\":",
      "configure_rule_heading": "Regel configureren",
      "configure_rule_text_bullet_1": "Kies {the_sender}",
      "configure_rule_text_bullet_2": "Kies dan {ip_range}",
      "configure_rule_text_bullet_3": "Voer de volgende IP-adressen één voor één in het pop-upvenster in en klik op \"Toevoegen\". Klik op \"Opslaan\" wanneer je klaar bent.",
      "configure_rule_text_intro": "In het vervolgkeuzemenu \"Deze regel toepassen als\":",
      "create_new_rule_heading": "Een nieuwe regel maken",
      "create_new_rule_text": "Maak een nieuwe regel en geef deze een naam. Bijvoorbeeld: {example}",
      "exchange_admin_center_heading": "Exchange-beheercentrum",
      "exchange_admin_center_text": "Navigeer naar de Mailstroomregels in het Exchange-beheercentrum door de volgende URL te bezoeken: {url}",
      "rule_settings_bullet_1": "Klik op \"volgende\" en ga verder naar regelinstellingen.",
      "rule_settings_bullet_2": "Onder \"Regelmodus\" selecteer \"Handhaven\".",
      "rule_settings_bullet_3": "Klik op \"volgende\" en bekijk de regelconfiguratie.",
      "rule_settings_heading": "Regelinstellingen",
      "save_the_rule_heading": "Sla de regel op",
      "save_the_rule_text": "Klik op {finish} om de regel op te slaan en toe te passen."
    },
    "microsoft_integration": "Microsoft-witlijst",
    "microsoft_tenant_allow_block": {
      "add_moxso_ips_to_tabl": "Voeg Moxso IP's toe aan Tenant Toestaan/Blokkeren-lijsten",
      "add_new_entry_bullet_1": "Klik op de knop {add_button}.",
      "add_new_entry_bullet_2": "In het sectie domeinkoppels voert je het volgende in: {domain_pair_1} {domain_pair_2}",
      "add_new_entry_bullet_3": "Stel Spoof-type in op {spoof_internal}.",
      "add_new_entry_bullet_4": "Stel Actie in op {allow_action}.",
      "add_new_entry_heading": "Een nieuwe vermelding toevoegen",
      "microsoft_defender_heading": "Microsoft Defender",
      "microsoft_defender_text": "Navigeer naar de Tenant Allow/Block Lists in Microsoft Defender door de volgende URL te bezoeken: {url}",
      "save_the_domain_pair_heading": "Domeinpaar opslaan",
      "save_the_domain_pair_text": "Klik op {add} om het nieuwe domeinenpaar op te slaan."
    },
    "microsoft_third_party": {
      "add_moxso_ips_domains_title": "Voeg de IP's en domeinen van Moxso toe aan de Phishing-simulatie van derden in Microsoft Defender",
      "download_simulation_heading": "Domeinen/IP's voor simulatiedownloads",
      "download_simulation_text": "Download de simulatie-domeinen/IP's door op de onderstaande knop te klikken: {csv_export_button}",
      "edit_entries_bullet_1": "Klik op de knop {edit_button}.",
      "edit_entries_bullet_2": "Voer in de sectie {domain_section} elk domein in dat is vermeld als {domain_text} in het gedownloade CSV-bestand.",
      "edit_entries_bullet_3": "Voer in de sectie {sending_ip_section} het volgende in: {ip_1} {ip_2}",
      "edit_entries_heading": "Items bewerken",
      "microsoft_defender_heading": "Microsoft Defender",
      "microsoft_defender_text": "Navigeer naar de instellingen voor simulatie van phishing van derden in Microsoft Defender door de volgende URL te bezoeken: {url}",
      "save_the_domain_pair_heading": "Sla het domeinpaar op",
      "save_the_domain_pair_text": "Klik op {save_button} om de instellingen voor de phishing-simulatie van derden op te slaan."
    },
    "redirecting": "Doorverwijzen",
    "results": {
      "button": "Ga naar dashboard",
      "text": "Welkom aan boord! Op basis van je antwoorden hebben we trainingsniveaus toegewezen die het beste bij je passen. Je kunt deze op elk moment aanpassen in de instellingen.",
      "title": "Je samenvatting"
    },
    "risk": {
      "approx_training_time_per_month": "Geschatte trainingstijd per maand",
      "more_training_more_time": "Hogere veerkrachtdoelen verhogen exponentieel de trainingstijd.",
      "targeted_resilience_score": "Doelgerichte weerbaarheidsscore",
      "text": "Gebruik de schuifregelaar om het algemene risicoblootstelling en de tolerantie van je bedrijf aan te geven. Houd rekening met je branche, de aard van je activiteiten en de gevoeligheid van de informatie die je verwerkt bij het kiezen van een risiconiveau.",
      "title": "Stel risiconiveau van organisatie in"
    },
    "select_your_email_provider": "Kies je e-mailprovider voor stapsgewijze instructies voor allowlisting.",
    "setting_up_workspace": "Organisatie instellen",
    "skip_button": "Witlijst overslaan",
    "skip_this_step": "Sla deze stap over",
    "sync_started": "Synchronisatie gestart",
    "toggle_gmail_api_integration": "Gebruik Gmail API-integratie",
    "try_integration_again": "Probeer het opnieuw",
    "use_powershell": "Gebruik Powershell",
    "verifying_integration": "Integratie verifiëren",
    "we_are_now_importing_employees": "We synchroniseren medewerkers van {provider}.",
    "welcome": {
      "graphic": {
        "text": "Je kunt deze stap ook voorlopig overslaan.",
        "title": "Kies je identiteitsprovider om te beginnen"
      },
      "text": "Om het meeste uit Moxso te halen, raden we aan om deze onboarding te doorlopen.",
      "title": "Welkom bij Moxso"
    }
  },
  "pagination": "Pagina {page} van {lastPage}",
  "policies": {
    "approve_button": "Beleid goedkeuren",
    "approve_warning": "Het finaliseren van dit beleid zal verdere bewerkingen uitschakelen. Wilt je doorgaan?",
    "approve_warning_title": "Goedkeuren beleid",
    "audit": {
      "cancel": {
        "audit_canceled": "Audit geannuleerd",
        "button": "Audit annuleren",
        "title": "Audit annuleren",
        "warning": "Alle openstaande meldingen worden onmiddellijk gestopt en toegewezen gebruikers verliezen de toegang tot dit beleid. Wilt u doorgaan?"
      },
      "details": {
        "all_completed_tooltip": "Alle {count} medewerkers hebben de audit bevestigd",
        "completed_tooltip": "Geen medewerkers hebben de audit bevestigd | {count} van de {total} medewerkers hebben de audit bevestigd | {count} van de {total} medewerkers hebben de audit bevestigd",
        "created_at": "Aangemaakt op",
        "end_date": "Einddatum",
        "enrolling_participants_heading": "Deelnemers inschrijven",
        "enrolling_participants_text": "Deelnemers worden ingeschreven. Gelieve te wachten.",
        "group": "Groep",
        "groups_heading": "Doelgroep",
        "groups_text": "Gegevens over het publiek",
        "heading": "Controle",
        "included_members_count_new_members_tooltip": "Nieuwe leden die aan de groep zijn toegevoegd nadat deze audit is gestart, worden niet opgenomen.",
        "included_members_count_tooltip": "Medewerkers die dit beleid al hebben bevestigd en nieuwe leden die aan de groep zijn toegevoegd nadat deze audit is gestart, worden uitgesloten.",
        "members": "Leden",
        "no_participants_text": "Geen deelnemers voor deze audit",
        "no_participants_title": "Geen deelnemers",
        "not_active_yet_text": "Start audit om deelnemers in te schrijven.",
        "not_active_yet_title": "Audit niet actief",
        "start_date": "Startdatum",
        "status": "Status",
        "text": "Auditgegevens"
      },
      "filters": {
        "acknowledged": "Bevestigd",
        "acknowledged_at": "Bevestigd op",
        "acknowledged_default": "Alle",
        "acknowledged_label": "Bevestiging",
        "not_acknowledged": "In behandeling"
      },
      "launch": {
        "audit_started": "Audit gestart",
        "button": "Start audit",
        "input_label": "Aantal ontvangers",
        "title": "Start audit",
        "warning": "Je staat op het punt een audit te starten die het beleid zal verspreiden naar medewerkers van de volgende groepen. Wilt je doorgaan?"
      },
      "single": {
        "settings": "Instellingen",
        "title": "Controle"
      }
    },
    "audit_draft": "Inactief",
    "audit_running": "Controle",
    "audits": {
      "create": {
        "buttons": {
          "back": "Ga terug",
          "continue": "Doorgaan",
          "submit": "Audit maken"
        },
        "date_range": "Controleperiode",
        "date_range_placeholder": "Kies de begindatum en einddatum van de audit",
        "error": "Er is een fout opgetreden bij het maken van de audit.",
        "select_groups": "Groepen selecteren",
        "title": "Een audit aanmaken"
      },
      "create_new_button": "Audit toevoegen",
      "created": "Controle met succes aangemaakt",
      "edit_button": "Bewerken",
      "empty": "Geen audits beschikbaar voor dit beleid",
      "help": {
        "include_previously_signed": "Medewerkers die dit beleid al hebben bevestigd, worden opgenomen in de audit.",
        "notification_flow_enabled": "Automatische meldingen inschakelen voor medewerkers die het beleid nog niet hebben bevestigd.",
        "notification_prelude_enabled": "Stuur een melding naar medewerkers wanneer een nieuw beleid aan hen is toegewezen."
      },
      "labels": {
        "include_previously_signed": "Reeds bevestigde medewerkers opnemen",
        "notification_flow_enabled": "Stel meldingenstroom in staat",
        "notification_frequency": "Frequentie van meldingen",
        "notification_prelude_enabled": "Prelude-melding inschakelen"
      },
      "policy_not_approved_yet": "Keur het beleid goed om een audit te starten.",
      "save_settings": "Instellingen opslaan",
      "title": "Geschiedenis van audits",
      "updated": "De audit is bijgewerkt"
    },
    "create": {
      "create_button": "Beleidsregel maken",
      "duplicate": "Dupliceren",
      "duplicated": "Beleid gedupliceerd!",
      "from_template": {
        "text": "Kies uit een bibliotheek van veelvoorkomende beleidsregels.",
        "title": "Beleidsregel maken vanuit template"
      },
      "labels": {
        "locale": "Taal",
        "title": "Titel"
      },
      "manual": {
        "text": "Beleidsregel maken zonder iets in te vullen.",
        "title": "Beleidsregel vanaf nul maken"
      },
      "placeholders": {
        "locale": "Kies de primaire taal van het beleid",
        "title": "Voer een titel in"
      },
      "success": "Beleid aangemaakt!",
      "title": "Beleidsregel maken"
    },
    "delete": {
      "are_you_sure": "Weet je zeker dat je dit beleid wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      "button": "Verwijderen",
      "policy_deleted": "Beleid verwijderd."
    },
    "edit": {
      "subtitle": "Bewerk beleidsinhoud en details",
      "title": "Bewerk beleid",
      "title_updated": "Titel succesvol gewijzigd"
    },
    "editor": {
      "add_column_after": "Kolom erna toevoegen",
      "add_column_before": "Kolom ervoor toevoegen",
      "add_row_after": "Rij eronder toevoegen",
      "add_row_before": "Rij erboven toevoegen",
      "delete_column": "Kolom verwijderen",
      "delete_image": "Afbeelding verwijderen",
      "delete_row": "Rij verwijderen",
      "delete_table": "Tabel verwijderen",
      "insert_image": "Afbeelding invoegen",
      "insert_table": "Tabel invoegen",
      "merge_cells": "Cellen samenvoegen",
      "split_cell": "Cel splitsen",
      "table": "Tabel",
      "toggle_header_row": "Koprij in-/uitschakelen"
    },
    "list": {
      "create_new": "Beleidsregel maken",
      "subtitle": "Overzicht van alle beleidsregels",
      "title": "Beleidsregels"
    },
    "policy_approved": "Beleid goedgekeurd.",
    "quiz": {
      "create_button": "Quiz maken",
      "done_translate_button": "Klaar",
      "edit_button": "Quiz bewerken",
      "empty": "Geen quizzen",
      "other_translations_have_quizzes": "Andere vertalingen hebben quizzes",
      "other_translations_have_quizzes_want_to_translate": "Andere vertalingen hebben al quizzen. Wilt je deze quiz automatisch naar die talen vertalen?",
      "processing_n_languages": "Verwerking van één taal | Verwerking van {count} talen",
      "quiz": "Quiz",
      "quiz_now_available_in": "Je quiz is nu beschikbaar in één extra taal | Je quiz is nu beschikbaar in {count} extra talen",
      "quiz_translate_success": "Succes!",
      "quizzes_translated": "Quizresultaten vertaald.",
      "select_the_languages_you_want_to_translate_your_quiz_into": "Kies de talen waarin je je quiz wilt vertalen",
      "some_translations_have_no_quizzes": "Sommige vertalingen hebben momenteel geen quizzen. Nu vertalen?",
      "subtitle": "Beschikbare quizzen",
      "this_translation_has_quizzes_in_other_languages_translate_automatically": "Deze vertaling heeft quizzen in andere talen. Automatisch vertalen?",
      "title": "Quizresultaten",
      "translate_button": "Vertalen",
      "translate_from": "Vertaal van",
      "translate_multiple_choice_quiz": "Vertaal meerkeuzequiz",
      "translate_quiz": "Vertalen",
      "translating_your_quiz": "Je quiz vertalen",
      "update_this_quiz_and_translate_others": "Werk deze quiz bij en vertaal andere quizzen",
      "update_this_quiz_only": "Werk alleen deze quiz bij",
      "view_button": "Quiz bekijken"
    },
    "single": {
      "audits": "Controles",
      "audits_subtitle": "Geschiedenis van audits",
      "details": {
        "heading": "Details",
        "text": "Beleid details"
      },
      "labels": {
        "acknowledgement_rate": "Bevestigingspercentage",
        "approval": "Goedkeuringsstatus",
        "approved_at": "Goedgekeurd op {approved_at}",
        "approved_by": "Goedgekeurd door {user}",
        "created_at": "Aangemaakt op",
        "edit": "Bewerken",
        "id": "ID",
        "latest_audit_status": "Laatste auditstatus",
        "not_approved": "Niet goedgekeurd",
        "updated_at": "Bijgewerkt op"
      },
      "subtitle": "Beschikbare vertalingen",
      "title": "Beleidsregels"
    },
    "tables": {
      "approved_at": "Goedgekeurd op",
      "created_at": "Aangemaakt op",
      "has_active_audit": "Auditstatus",
      "status_approved": "Goedgekeurd",
      "status_draft": "Concept",
      "title": "Titel"
    },
    "translations": {
      "ai": {
        "done_translate_button": "Voltooid",
        "policy_now_available_in": "Je polis is nu beschikbaar in één extra taal | Je polis is nu beschikbaar in {count} extra talen",
        "policy_translate_success": "Succes!",
        "processing_n_languages": "Een taal verwerken | {count} talen verwerken",
        "text": "Gebruik DeepL om het beleid automatisch naar een geselecteerde taal te vertalen.",
        "title": "Beleid vertalen met AI",
        "translate_button": "Vertalen",
        "translate_from": "Vertalen van",
        "translating_your_policy": "Het vertalen van je beleid"
      },
      "create": "Vertalen",
      "create_deepl_new_button": "Vertalen met AI",
      "create_new_button": "Vertaling toevoegen",
      "create_success": "Vertaling succesvol aangemaakt",
      "create_title": "Vertaling toevoegen",
      "created_at": "Aangemaakt",
      "default_badge": "Standaard",
      "delete_are_you_sure": "Weet je zeker dat je deze vertaling wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      "delete_button": "Verwijderen",
      "edit_button": "Bewerken",
      "edit_views": {
        "edit": "Bewerken",
        "preview": "Voorbeeldweergave"
      },
      "empty": "Geen vertalingen voor dit beleid",
      "empty_sections_overview": {
        "subtitle": "Voeg een kop 1 toe om een nieuwe sectie te maken",
        "title": "Geen secties toegevoegd"
      },
      "language": "Taal",
      "last_updated": "Laatst bijgewerkt",
      "locked": "Bewerken geblokkeerd omdat beleid is goedgekeurd.",
      "make_default": "Instellen als standaard",
      "manual": {
        "first_translation_text": "Begin door een vertaling vanaf nul te maken.",
        "first_translation_title": "Beleidsvertaling maken",
        "text": "Herschrijf de vertaling vanaf nul in een nieuwe taal.",
        "title": "Beleid handmatig vertalen"
      },
      "save": "Wijzigingen opslaan",
      "save_success": "Vertaling succesvol opgeslagen.",
      "save_success_title": "Titel succesvol gewijzigd",
      "select_locale": "Doeltaal",
      "select_locale_placeholder": "Kies de taal voor je vertaling",
      "subtitle": "Beheer vertalingen voor dit beleid",
      "title": "Vertalingen",
      "title_label": "Vertalingstitel",
      "title_placeholder": "Voer vertalingstitel in",
      "translation_deleted": "Vertaling verwijderd.",
      "view_button": "Bekijken"
    }
  },
  "quiz_builder": {
    "buttons": {
      "add_ai_question": "AI-vraag toevoegen",
      "add_option": "Optie toevoegen",
      "add_question": "Vraag toevoegen",
      "close": "Sluiten",
      "edit": "Bewerken",
      "save_quiz": "Quiz opslaan"
    },
    "delete_question_confirmation": {
      "are_you_sure": "Weet je zeker dat je deze vraag wilt verwijderen?",
      "button": "Vraag verwijderen"
    },
    "empty": {
      "ai_create_button": "Moxso Intelligence gebruiken",
      "ai_description": "Begin door de eerste vraag toe te voegen of gebruik Moxso AI om een quiz te genereren.",
      "create_button": "Quiz maken",
      "description": "Begin met het toevoegen van de eerste vraag.",
      "manually_create_button": "Quiz handmatig maken",
      "title": "Nog geen vragen"
    },
    "labels": {
      "answer_options": "Antwoordopties",
      "question": "Vraag"
    },
    "placeholders": {
      "answer_option": "Optie invoeren",
      "question": "Voer vraag in"
    },
    "quiz_saved": "Quiz opgeslagen",
    "quizzes_translated": "Quizresultaten vertaald.",
    "titles": {
      "question": "Vraag {number}"
    }
  },
  "report": {
    "click_rate": "Klikpercentage",
    "from_value": "van {value}",
    "last_12_months": "Afgelopen 12 maanden",
    "last_six_months": "Afgelopen zes maanden",
    "no_data": "Geen gegevens",
    "polarity": "Polariteit",
    "report_rate": "Rapportagepercentage",
    "resilience": "Weerbaarheid",
    "simulations": "Simulaties",
    "training": "Training",
    "vs_previous_period": "t.o.v. vorige periode"
  },
  "reset_password": {
    "heading": "Wachtwoord opnieuw instellen",
    "success_message": "Wachtwoord succesvol opgeslagen",
    "text": "Kies alstublieft een nieuw wachtwoord"
  },
  "seo_titles": {
    "automation": {
      "action": "Deelnemers automatisering",
      "edit": "Automatisering bewerken",
      "index": "Automatiseringen",
      "single": "Automatisering"
    },
    "breach": {
      "index": "Datalekken",
      "single": "Inbreuk"
    },
    "campaign": {
      "index": "Simulaties",
      "single": "Simulatie",
      "templates": "Aangepaste templates"
    },
    "dashboard": {
      "breaches": "Dashboard – Datalekken",
      "human_risk_intelligence": "Dashboard - Menselijke risico-intelligentie",
      "overview": "Dashboard",
      "resilience": "Dashboard – Weerbaarheid",
      "simulations": "Dashboard – Simulaties",
      "threats": "Dashboard – Dreigingen",
      "training": "Dashboard – Training"
    },
    "employee": {
      "index": "Medewerkers",
      "single": "Medewerker"
    },
    "forgot_password": "Wachtwoord opnieuw instellen",
    "group": {
      "index": "Groepen",
      "single": "Groep"
    },
    "impersonate": "Imiteren",
    "integration": "Integratie",
    "invite": {
      "id": "Accepteer uitnodiging",
      "index": "Accepteer uitnodiging"
    },
    "login": "Aanmelden",
    "policies": {
      "audit": "Controle",
      "index": "Beleidsregels",
      "single": "Bewerkbeleid vertaling",
      "translations": "Beleid Vertalingen"
    },
    "reset_password": "Wachtwoord opnieuw instellen",
    "settings": {
      "breaches": "Instellingen – Datalekken",
      "domains": "Instellingen – Domeinen",
      "e_learning": "Instellingen – Training",
      "export": "Instellingen – Gegevens exporteren naar CSV",
      "import": "Instellingen – Importeren vanuit CSV",
      "index": "Instellingen – organisatie",
      "integrations": {
        "index": "Instellingen – Integraties",
        "single": "Instellingen – Integratie bewerken"
      },
      "risk": "Instellingen – Risico",
      "simulations": "Instellingen – Simulaties",
      "threats": "Instellingen – Dreigingen"
    },
    "threat": {
      "index": "Dreigingen",
      "single": "Dreiging"
    },
    "training": {
      "deadlines": "Deadlines",
      "index": "Training",
      "participation": "Deelname"
    },
    "two_factor": "Tweefactorauthenticatie",
    "user_settings": "Gebruikersinstellingen",
    "validate_domain": "Domein valideren"
  },
  "settings": {
    "breaches": {
      "enable_breaches": {
        "help": "Datalekken inschakelen voor deze organisatie.",
        "title": "Datalekken inschakelen"
      },
      "enable_notifications": {
        "help": "Informeer medewerkers direct wanneer zij betrokken zijn bij een nieuw datalek.",
        "title": "Meldingen inschakelen"
      },
      "subtitle": "Beheer de instellingen voor datalekken.",
      "title": "Datalekken"
    },
    "buttons": {
      "add_domain": "Domein toevoegen",
      "add_report": "Rapport toevoegen",
      "add_user": "Gebruiker toevoegen",
      "resend_invitation": "E-mail opnieuw verzenden",
      "revoke_access": "Toegang intrekken",
      "save_settings": "Instellingen opslaan",
      "verify_domain": "Verifiëren"
    },
    "data": {
      "subtitle": "Wanneer ingeschakeld, worden gegevens 90 dagen na hun laatste relevante actie geanonimiseerd.",
      "title": "Gegevensanonimisering"
    },
    "domains": {
      "domain_added": "Domein aangemaakt",
      "domain_required": "Voer alstublieft een domein in",
      "subtitle": "Beheer domeinnamen die eigendom zijn van je organisatie.",
      "title": "Geverifieerde domeinen",
      "verification_email_sent": "Verificatie-e-mail verzonden",
      "verification_required": "Verificatie in behandeling",
      "verified": "Geverifieerd",
      "verified_on": "Geverifieerd op:",
      "verify_new_domain": "Nieuw domein verifiëren"
    },
    "e_learning": {
      "alert": {
        "not_allowed": "Niet toegestaan",
        "optional_courses": "Optionele cursussen",
        "optional_courses_description": "Cursussen buiten verplichte training",
        "optional_quiz_questions": "Quizvragen",
        "optional_quiz_questions_description": "Optionele phishing-quizvragen",
        "optional_videos": "Optionele video's",
        "optional_videos_description": "Video's buiten verplichte training",
        "quiz_limit_value": "15 per week",
        "title": "Beperkingen toegepast wanneer ingeschakeld",
        "video_limit_value": "2 per week"
      },
      "modes": {
        "automatic": {
          "description": "Moxso verzorgt je volledige trainingsprogramma automatisch.",
          "recommended": "Aanbevolen",
          "title": "Automatische training"
        },
        "confirmation": {
          "automatic": {
            "description": "Moxso begint trainingen automatisch toe te wijzen.",
            "title": "Overschakelen naar automatische training?"
          },
          "manual": {
            "description": "Moxso stopt met het toewijzen van trainingen. Bestaande toewijzingen blijven behouden.",
            "title": "Overschakelen naar geplande training?"
          },
          "switch": "Overschakelen"
        },
        "help": "Kies hoe trainingen binnen je organisatie worden toegewezen.",
        "label": "Trainingsmodus",
        "manual": {
          "description": "Beheerders plannen trainingen en wijzen deze zelf toe.",
          "title": "Geplande training"
        },
        "will_be_hidden": "Wordt na het overschakelen verborgen"
      },
      "subtitle": "Configureer je trainingsinstellingen.",
      "title": "Training"
    },
    "exports": {
      "custom": "Aangepast",
      "default": "Standaard",
      "download_export": "Export downloaden",
      "export_type": {
        "automation": "Automatiseringsrapport",
        "employee": "Rapport van de medewerker",
        "text": "Kies het type export dat je wilt genereren.",
        "title": "Exporttype",
        "training": "Trainingsrapport"
      },
      "form": {
        "deselect_all": "Alles deselecteren van velden",
        "select_all": "Kies alle velden"
      },
      "reports": {
        "delete_button": "Verwijderen",
        "deleted_success": "Rapport verwijderd",
        "download_button": "Downloaden",
        "edit_button": "Bewerken",
        "search": "Zoeken",
        "subtitle": "Beheer geplande rapporten voor de organisatie.",
        "title": "Geplande rapporten"
      },
      "selected_columns": "Velden({count}): {columns}",
      "subtitle": "Kies de gegevens die je wilt exporteren.",
      "title": "Export downloaden"
    },
    "forms": {
      "company": {
        "label": "Bedrijf",
        "placeholder": "Bedrijf"
      },
      "custom_deeplink_url": {
        "description": "Gebruik ::content_id:: als verplichte plaatshouder voor het inhouds-ID.",
        "label": "Aangepaste content-URL",
        "placeholder": "https://example.com/launch/something-::content_id::"
      },
      "custom_lms_url": {
        "label": "Aangepaste LMS-URL",
        "placeholder": "https://example.com/launch/"
      },
      "data_enrichment": {
        "subtitle": "Wijs rollen toe aan medewerkers op basis van hun gegevens.",
        "title": "Verrijking van medewerkersgegevens",
        "tooltip": "Verrijking van medewerkersgegevens gebruikt AI om rollen toe te wijzen aan medewerkers op basis van hun afdeling en groepen."
      },
      "enhanced_scoring": {
        "subtitle": "Weeg weerbaarheidsscores op basis van werknemersrollen.",
        "title": "Verbeterde scorebepaling",
        "tooltip": "Verbeterde scoring past verschillende wegingen toe, afhankelijk van hoe cruciaal de beveiliging van een rol is, zodat individuen met meer toegang of verantwoordelijkheid meer moeten doen om dezelfde veerkrachtscore te bereiken."
      },
      "gdpr": {
        "employees": {
          "help": "Automatisch inactieve medewerkers anonimiseren.",
          "title": "Anonimiseer inactieve medewerkers"
        },
        "threats": {
          "help": "Anonimiseer dreigingsgegevens automatisch.",
          "title": "Geanonimiseerde behandelde dreigingen"
        }
      },
      "hotline": {
        "description": "Dit zal het primaire contactpunt zijn voor je team in geval van een potentiële dreiging of medewerkersverzoeken.",
        "label": "Contact e-mail",
        "placeholder": "It{'@'}company.com"
      },
      "industry": {
        "label": "Industrie"
      },
      "labels": {
        "active_status": "Status",
        "automation": "Automatisering",
        "custom_fields": "Velden",
        "date_range": "Kies datums",
        "domain": "Domein",
        "email": "E-mail",
        "first_name": "Voornaam",
        "group": "Groep",
        "last_name": "Achternaam",
        "report_frequency": "Frequentie",
        "report_period": "Periode",
        "report_recipient": "Ontvanger",
        "report_status": "Status",
        "report_type": "Rapporttype",
        "role": "Rol",
        "training_type": "Type"
      },
      "leaderboard": {
        "enabled": {
          "subtitle": "Toon een klassement in de hub en kies hoe medewerkers worden gerangschikt.",
          "title": "Klassement"
        },
        "options": {
          "point_leaderboard": "Puntenklassement",
          "score_leaderboard": "Klassement voor weerbaarheidsscore"
        },
        "setting": {
          "label": "Type klassement"
        }
      },
      "placeholders": {
        "date_range": "Kies datums",
        "domain": "Bedrijf.com",
        "email": "Name{'@'}company.com",
        "first_name": "Voornaam",
        "last_name": "Achternaam",
        "report_recipient": "Zoek naar medewerker",
        "search_employee": "Zoek medewerker"
      },
      "reports": {
        "add_scheduled_report": "Gepland rapport toevoegen",
        "choose_report_type": "Kies een ander rapporttype",
        "description": "Stel geplande rapporten in om automatisch te worden verzonden.",
        "edit_scheduled_report": "Gepland rapport bewerken",
        "hierarchy_level": {
          "description": "Wanneer ingeschakeld bevat het rapport ook medewerkers lager in de hiërarchie, niet alleen directe ondergeschikten.",
          "label": "Inclusief onderliggende teamleden"
        },
        "manager_report": {
          "text": "Een rapport voor managers over hun medewerkers.",
          "title": "Managerrapport"
        },
        "workspace_report": {
          "text": "Een rapport voor de hele organisatie.",
          "title": "Organisatierapport"
        }
      },
      "scim": {
        "add_title": "SCIM-token aanmaken",
        "connection_add_title": "SCIM-verbinding aanmaken",
        "connection_created": "SCIM-verbinding aangemaakt.",
        "connection_deleted": "SCIM-verbinding verwijderd.",
        "connection_name_label": "Verbindingsnaam",
        "connection_name_placeholder": "Microsoft Entra ID",
        "connection_saved": "SCIM-verbinding opgeslagen.",
        "connection_token_name_placeholder": "{name}-provisioning",
        "create_connection_button": "Verbinding aanmaken",
        "create_token_button": "Token aanmaken",
        "create_token_header": "Token aanmaken",
        "created_title": "SCIM-token aangemaakt",
        "default_mapping_marker": "Standaard",
        "delete_connection_body": "Hiermee wordt de verbinding verwijderd en worden alle gekoppelde SCIM-tokens ingetrokken. Provisioning vanuit deze provider stopt onmiddellijk.",
        "delete_connection_button": "Verbinding verwijderen",
        "delete_connection_title": "SCIM-verbinding verwijderen?",
        "done": "Gereed",
        "edit_connection_button": "Verbinding bewerken",
        "enabled_label": "Ingeschakeld",
        "name_help": "Geef je token een beschrijvende naam zodat je het later kunt herkennen.",
        "name_label": "Tokennaam",
        "name_placeholder": "Microsoft Entra-provisioning",
        "note_cannot_view": "Dit token wordt slechts één keer getoond. Sla het op in je identiteitsprovider voordat je dit venster sluit.",
        "provider_label": "Provider",
        "reset_mapping_button": "Terugzetten naar standaardwaarden",
        "revoke_body": "Provisioningverzoeken met dit token stoppen onmiddellijk. Bestaande medewerkers en groepen worden niet verwijderd.",
        "revoke_button": "Token intrekken",
        "revoke_title": "SCIM-token intrekken",
        "save_connection_button": "Verbinding opslaan",
        "save_mapping_button": "Mapping opslaan",
        "secret_token_label": "Geheim token",
        "show_mapping_details": "Mappingdetails",
        "success_token_added": "SCIM-token toegevoegd.",
        "success_token_revoked": "SCIM-token ingetrokken.",
        "sync_type_employee": "Medewerker",
        "sync_type_employee_description": "Provision medewerkers en medewerkersgroepen vanuit deze identiteitsprovider.",
        "sync_type_label": "Provisioningtype",
        "sync_type_user": "Admingebruiker",
        "sync_type_user_description": "Provision admingebruikers die toegang hebben tot het beheerdashboard."
      },
      "select_automation": "Kies automatisering",
      "select_group": "Kies groep",
      "settings_saved": "Instellingen opgeslagen",
      "success": {
        "invitation_resent": "E-mailbevestiging is opnieuw verzonden",
        "report_added": "Rapport succesvol toegevoegd",
        "report_edited": "Rapport opgeslagen",
        "user_added": "Gebruiker toegevoegd"
      },
      "timezone": {
        "label": "Tijdzone",
        "placeholder": "Kies tijdzone"
      },
      "tokens": {
        "add_title": "Token maken",
        "are_you_sure_you_want_to_delete": "Weet je zeker dat je deze token wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        "close": "Sluiten",
        "create_token_button": "Token maken",
        "documentation": "Documentatie",
        "name_help": "Geef je token een beschrijvende naam om het later te kunnen identificeren.",
        "name_label": "Naam",
        "name_placeholder": "Naam van token",
        "note_cannot_view": "Deze token wordt slechts één keer weergegeven. Sla hem ergens veilig op.",
        "success_token_added": "Token toegevoegd.",
        "success_token_deleted": "Token verwijderd.",
        "token_created": "Token aangemaakt"
      },
      "training_restrictions": {
        "enabled": {
          "subtitle": "Beperk hoeveel niet-toegewezen training medewerkers zelfstandig kunnen voltooien.",
          "title": "Trainingsbeperkingen",
          "tooltip": "Schakel de standaardbeperkingen voor optionele training in de hub in."
        },
        "unassigned_quiz_limit": {
          "help": "Maximum aantal niet-toegewezen quizzen dat een medewerker kan voltooien.",
          "label": "Quizlimiet"
        },
        "unassigned_video_limit": {
          "help": "Maximum aantal niet-toegewezen video's dat een medewerker kan voltooien.",
          "label": "Videolimiet"
        }
      },
      "training_type": {
        "course": "Cursus",
        "video": "Video"
      },
      "users": {
        "add_employee": "Gebruiker toevoegen"
      }
    },
    "imports": {
      "back": "Terug",
      "button": "{klik} of slepen en neerzetten",
      "click_to_upload": "Klik om te uploaden",
      "completed": "Voltooid",
      "done": "Voltooid",
      "failed": "Mislukt",
      "file_requirements": "Het bestand moet de volgende kolommen bevatten: <b>first_name</b>, <b>last_name</b>, <b>email</b>, en <b>locale</b> (bijv. da_DK, en_US, de_DE).<br/>Optioneel kan het bestand <b>timezone</b> (bijv. Europe/Copenhagen), <b>phone_number</b> en <b>phone_country_code</b> bevatten.<br/><b>CSV-bestanden moeten komma's als scheidingsteken gebruiken.</b><br/>Geaccepteerde formaten: .csv of .txt (Het bestand moet worden opgeslagen in UTF-8-formaat om een correcte tekenencoding te garanderen)",
      "formats": "CSV of TXT tot 10MB",
      "import_type": {
        "employees": "{count} medewerker | {count} medewerkers",
        "groups": "{count} groep | {count} groepen"
      },
      "pending": "Synchroniseren",
      "upload_another": "Nog een bestand uploaden"
    },
    "integrations": {
      "account": {
        "subtitle": "Synchroniseer gebruikersaccounts met Moxso.",
        "title": "Gebruikers en communicatie"
      },
      "add_our_domains_and_setup_guides": "Voeg onze domeinen toe en volg de Gmail- en Outlook-allowlistinggidsen.",
      "addin_setup_guide": "Installatiehandleiding",
      "coming_soon": "Binnenkort beschikbaar",
      "compliance": {
        "subtitle": "Synchroniseer met compliance-tools.",
        "title": "Nalevingshulpmiddelen"
      },
      "connected": {
        "subtitle": "Momenteel verbonden integraties.",
        "title": "Actieve integraties"
      },
      "delete": {
        "button": "Integratie verwijderen",
        "confirmation": "Weet je zeker dat je deze integratie wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        "description": "Als je deze integratie verwijdert, stopt toekomstige synchronisatie. Deze actie kan niet ongedaan worden gemaakt.",
        "subtitle": "Verwijder deze integratie uit je workspace.",
        "success": "Integratie verwijderd",
        "title": "Integratie verwijderen"
      },
      "edit": {
        "auth_settings": {
          "subtitle": "De verificatie-instellingen bijwerken",
          "title": "Authenticatie-instellingen"
        },
        "filtering": {
          "text": "E-mailfiltering verwijdert automatisch gedeelde e-mailadressen uit je integratie. Dit kunnen e-mailaccounts zijn zoals: admin{'@'}domain.com, contact{'@'}domain.com enz.",
          "title": "Algemeen en rolgebaseerd e-mailfilteren"
        },
        "groups": {
          "text": "Kies of je groepen wilt synchroniseren telkens wanneer je integratie wordt bijgewerkt.",
          "title": "Groepen"
        },
        "managers": {
          "text": "Kies of managers gesynchroniseerd moeten worden telkens wanneer je integratie wordt bijgewerkt.",
          "title": "Beheerders"
        },
        "offboarding": {
          "text": "Kies of je medewerkers die uit je integratie worden verwijderd automatisch wilt uitschakelen.",
          "title": "Offboarding"
        },
        "settings": {
          "enable_notifications": {
            "title": "Schakel trainingsmeldingen in"
          },
          "enable_sync": "Synchronisatie inschakelen",
          "select_sync_frequency": "Kies hoe vaak je wilt dat je integratie wordt gesynchroniseerd.",
          "subtitle": "Integratieconfiguratie bijwerken",
          "sync_frequency": "Synchronisatiefrequentie",
          "title": "Integratie bewerken"
        },
        "sync_phone_numbers": {
          "text": "Kies of telefoonnummers geïmporteerd moeten worden bij het synchroniseren met deze integratie.",
          "title": "Telefoonnummers importeren"
        },
        "title": "Laatste synchronisaties"
      },
      "enabled": "Ingeschakeld",
      "first_sync": "Eerste synchronisatie",
      "form": {
        "access_token": {
          "help": "De API-sleutel wordt gebruikt om de integratie te verifiëren.",
          "label": "API-sleutel"
        },
        "api_route": {
          "label": "Api-route",
          "placeholder": "Voer API-route in"
        },
        "password": {
          "help": "Het wachtwoord wordt gebruikt om de integratie te verifiëren.",
          "label": "Wachtwoord",
          "placeholder": "Voer wachtwoord in"
        },
        "region": {
          "help": "Kies welke gegevensregio je gebruikt voor deze provider.",
          "label": "Gegevenregio",
          "options": {
            "eu": "EU",
            "global": "Wereldwijd"
          }
        },
        "username": {
          "help": "De gebruikersnaam wordt gebruikt om de integratie te verifiëren.",
          "label": "Gebruikersnaam",
          "placeholder": "Voer gebruikersnaam in"
        }
      },
      "frequency": {
        "daily": {
          "description": "Je gegevens worden elke dag gesynchroniseerd.",
          "title": "Dagelijks"
        },
        "monthly": {
          "description": "Je gegevens worden elke maand op de eerste dag gesynchroniseerd.",
          "title": "Maandelijks"
        },
        "realtime": {
          "description": "Je gegevens worden elke minuut gesynchroniseerd.",
          "title": "In real-time"
        },
        "weekly": {
          "description": "Je gegevens worden elke week op maandag gesynchroniseerd.",
          "title": "Wekelijks"
        }
      },
      "gmail_addin": {
        "apps_marketplace_apps": "Apps → Google Workspace Marketplace-apps",
        "click_install_review_deploy": "Klik op {install}, controleer de gevraagde machtigingen en kies {deploy_to_organisation} (of een testgroep) om de invoegtoepassing beschikbaar te maken voor gebruikers.",
        "deploy_to_organisation": "Implementeren naar je organisatie",
        "find_moxso_add_in": "Zoek de add-in \"Moxso Report\"",
        "in_admin_console_navigate_to": "Navigeer in de Google Workspace-beheerdersconsole naar {marketplace_apps}.",
        "install": "Installeren",
        "install_and_deploy": "De invoegtoepassing installeren en implementeren",
        "moxso_report": "Moxso-rapport",
        "open_workspace_marketplace": "Google Workspace Marketplace openen",
        "report_threats_directly_from_gmail": "Meld verdachte e-mails rechtstreeks vanuit Gmail bij Moxso.",
        "search_to_locate": "Gebruik de zoekbalk om {moxso_report} te vinden en open de detailpagina.",
        "title": "Gmail-invoegtoepassing instellen"
      },
      "gmail_whitelisting_guide": "Gmail-allowlistinggids",
      "hri": {
        "connected": "Verbonden",
        "directory_description": "Verbind Microsoft Entra of Google Workspace om medewerker-ID's te koppelen en andere HRI-integraties te ontgrendelen. Deze HRI-verbinding staat los van je reguliere integratie.",
        "directory_title": "Verbind eerst je medewerkersdirectory",
        "enable": "Inschakelen",
        "explore_description": "Je kunt de onderstaande integraties verkennen. Voor de configuratie is een actieve HRI-verbinding met Microsoft Entra of Google Workspace vereist.",
        "explore_title": "Verken integraties",
        "recommended": "Aanbevolen",
        "recommended_tooltip": "Je gebruikt deze directory al",
        "setup_locked": "Configuratie vergrendeld",
        "setup_prerequisite": "Stel eerst de HRI-koppeling met Microsoft Entra of Google Workspace in."
      },
      "integration_stored": "Integratie opgeslagen",
      "last_sync": "Laatste synchronisatie",
      "last_update": "Laatste update: {time}",
      "lms": {
        "subtitle": "Synchroniseren met leerbeheersystemen.",
        "title": "Leerbeheer systemen"
      },
      "never": "Nooit",
      "not_connected": "Niet verbonden",
      "notifications": {
        "subtitle": "Stuur meldingen via samenwerkingstools.",
        "title": "Meldingen"
      },
      "open_guide": "Gids openen",
      "outlook_addin": {
        "accept_permissions": "Machtigingen accepteren",
        "add_ins": "Invoegtoepassingen",
        "app_type": "App-type",
        "assign_access": "Toegang toewijzen",
        "assign_users": "Gebruikers toewijzen",
        "choose_who_get_add_in": "Onder {assign_users}, kies wie de add-in moet ontvangen. We raden aan om {specific_users} te selecteren en de relevante groepen te kiezen.",
        "chose_manifest_url": "Kies {provide_link} en plak de manifest-URL:",
        "click": "Klik op {next}.",
        "click_next_then_finish": "Klik op {next}, en vervolgens op {finish}.",
        "click_you_should_see_message": "Klik op {validate}. Je zou het bericht \"{file_validated}\" moeten zien.",
        "complete": "Voltooid",
        "confirm_slot_is_selected": "In de {app_type} lijst, bevestig dat {add_in} is geselecteerd.",
        "done": "Gedaan",
        "examine_permissions": "Controleer de gevraagde machtigingen. Als alles correct lijkt, kies dan {accept_permissions} en bevestig de prompts.",
        "finalize_deployment": "Voltooi implementatie",
        "finish_deployment": "Voltooi implementatie",
        "integrated_apps": "Geïntegreerde apps",
        "manifest_file_validated": "Manifestbestand gevalideerd",
        "navigate_to_admin_center": "Ga naar Microsoft 365-beheercentrum > Instellingen > {link}",
        "next": "Volgende",
        "office_add-in": "Office-invoegtoepassing",
        "open_integrated_apps": "Geïntegreerde apps openen",
        "proceed_to_assignment": "Ga verder naar Toewijzing",
        "process_indicator_then_complete": "Je ziet een voortgangsindicator; deze stap duurt zelden langer dan een minuut. Druk daarna op {done} om de installatie te voltooien.",
        "provide_link_to_manifest_file": "Link naar manifestbestand verstrekken",
        "provide_manifest": "Geef het Manifest",
        "report_threats_directly_from_outlook": "Meld verdachte e-mails rechtstreeks vanuit Outlook bij Moxso.",
        "restart_outlook": "Start Outlook opnieuw om ervoor te zorgen dat de invoegtoepassing initialiseert, en dien vervolgens een test-e-mailrapport in. Let op dat het tot 24 uur kan duren voordat de invoegtoepassing verschijnt na implementatie.",
        "review_permissions": "Permissies beoordelen",
        "select_upload_custom_apps": "Kies {bold}.",
        "specific_users_groups": "Specifieke gebruikers/groepen",
        "specify_app_type": "Geef het type app op",
        "start_the_upload": "Begin het uploadproces",
        "title": "De Outlook-add-in instellen",
        "upload_custom_apps": "Aangepaste apps uploaden",
        "use_powershell": "Gebruik powershell",
        "validate": "Valideren",
        "validate_manifest": "De manifest valideren",
        "verify_add_in": "Verifieer de invoegtoepassing in Outlook"
      },
      "outlook_whitelisting_guide": "Outlook-allowlistinggids",
      "overview": {
        "active": "Actief",
        "active_subtitle": "Momenteel verbonden integraties.",
        "active_title": "Actieve integraties",
        "all": "Alle",
        "all_subtitle": "Verbind diensten om de beveiligingsactiviteiten van medewerkers in Human Risk Intelligence te verzamelen.",
        "all_title": "Alle integraties",
        "attention": "Aandacht nodig",
        "attention_subtitle": "Integraties die aandacht nodig hebben voordat ze kunnen synchroniseren.",
        "attention_title": "Aandacht nodig",
        "empty": "Geen integraties gevonden.",
        "hri": "Human risk intelligence",
        "search": "Integraties zoeken..."
      },
      "refresh": "Gegevens vernieuwen",
      "refresh_data": "Gegevens vernieuwen",
      "report_threats_directly_from_inbox": "Dreigingen rechtstreeks vanuit de inbox melden.",
      "settings_saved": "Instellingen opgeslagen",
      "setup": "Verbinden",
      "setup_integration": "Integratie instellen",
      "setup_text": "We gebruiken single sign-on (SSO) om veilig verbinding te maken met {provider}. Je wordt doorgestuurd naar de inlogpagina van je provider voor authenticatie. Houd er rekening mee dat een beheerdersaccount vereist is om de integratie te configureren.",
      "simulation_deliverability": "Leverbaarheid van simulaties",
      "single": {
        "provider_title": "{provider} bewerken",
        "subtitle": "Integratieconfiguratie bijwerken",
        "title": "Integratie bewerken"
      },
      "status": "Integratiestatus",
      "step_by_step": "Stapsgewijze handleiding om e-mails toe te staan.",
      "sync_already_enabled_tooltip": "De synchronisatie van medewerkers is al ingeschakeld bij een andere integratie. Schakel deze uit om deze optie te gebruiken.",
      "sync_started": "Synchronisatie aan wachtrij toegevoegd",
      "teams_guide": {
        "description": "Volg de installatiehandleiding in ons {help_center} voor instructies om Moxso toe te voegen aan Microsoft Teams.",
        "download_zip": "ZIP-bestand downloaden",
        "help_center": "helpcentrum"
      },
      "title": "Integraties",
      "token_error": "We konden geen verbinding met {provider} voor je tot stand brengen. Onze meest recente poging was op: {date}. Bevestig je accountgegevens alstublieft opnieuw.",
      "whitelisting_guide": "Gids voor het toestaan"
    },
    "magic_links": {
      "description": "Laat medewerkers automatisch inloggen via Hub-links in meldingen. Wanneer dit is uitgeschakeld, openen links de inlogpagina van de Hub en behouden ze de oorspronkelijke bestemming.",
      "label": "Magische links inschakelen",
      "title": "Magische Hub-links"
    },
    "risk": {
      "organisation_risk_subtitle": "Algemeen risiconiveau voor {organisation}",
      "organisation_risk_text": "Hoe hoger het risiconiveau, hoe meer training medewerkers zullen ontvangen. Overweeg om de trainingsbehoeften in evenwicht te brengen met de werklast van medewerkers.",
      "organisation_risk_title": "Organisatierisico",
      "subtitle": "Pas het opleidingsniveau voor elke categorie aan.",
      "title": "Trainingsniveaus"
    },
    "saml": {
      "acs_url": "ACS-URL",
      "add_provider": "Provider toevoegen",
      "attribute_mapping": {
        "description": "Koppel SAML assertion-attributen aan de adminprofielvelden die Moxso verwacht.",
        "title": "Assertion-attribuutmapping"
      },
      "cancel_edit": "Bewerken annuleren",
      "create": {
        "manual": {
          "description": "Configureer de provider handmatig",
          "title": "Handmatig maken"
        },
        "metadata": {
          "description": "Importeer IdP-instellingen van provider",
          "title": "Maken vanuit metadata-URL"
        }
      },
      "delete": {
        "cancel": "Annuleren",
        "confirm": "Verbinding verwijderen",
        "description": "Gebruikers kunnen niet langer inloggen via deze identity provider. Bestaande gekoppelde SAML-identiteiten voor deze provider worden ook verwijderd.",
        "title": "SAML-verbinding verwijderen"
      },
      "deleted": "SAML-verbinding verwijderd",
      "disabled": "Uitgeschakeld",
      "edit_provider": "Provider bewerken",
      "empty": {
        "description": "Voeg een SAML-provider toe zodat uitgenodigde beheerders SSO vanaf de loginpagina kunnen starten.",
        "title": "Geen SAML-providers"
      },
      "enabled": "Ingeschakeld",
      "entity_id": "Entity ID",
      "entity_id_instruction": "Gebruik de entityID-waarde uit de metadata-URL.",
      "existing_users_only": "SAML-login werkt alleen voor bestaande uitgenodigde beheerders in deze workspace.",
      "form": {
        "app_federation_metadata_url": "App federation metadata-URL",
        "app_federation_metadata_url_placeholder": "https://example.com/federationmetadata.xml",
        "email_attribute": "E-mailattribuut",
        "email_attribute_placeholder": "email",
        "enabled": "Provider inschakelen",
        "enabled_help": "Ingeschakelde providers kunnen worden gebruikt vanaf de loginpagina.",
        "first_name_attribute": "Voornaamattribuut",
        "first_name_attribute_placeholder": "firstName",
        "idp_entity_id": "IdP entity ID",
        "idp_entity_id_placeholder": "https://idp.example.com/entity",
        "idp_login_url": "IdP-login-URL",
        "idp_logout_url": "IdP-logout-URL",
        "idp_x509_certificate": "IdP X.509-certificaat",
        "idp_x509_certificate_help": "Het huidige certificaat kan niet opnieuw worden bekeken. Laat dit veld leeg om het te behouden, of plak een nieuw certificaat om het bij te werken.",
        "idp_x509_certificate_placeholder": "Plak het certificaat van je identity provider",
        "idp_x509_certificate_update": "Certificaat bijwerken",
        "last_name_attribute": "Achternaamattribuut",
        "last_name_attribute_placeholder": "lastName",
        "login_type": "SAML vereisen voor",
        "login_type_employee": "Hubgebruikers",
        "login_type_employee_description": "Gebruik SAML voor medewerkersaanmelding bij de learning hub.",
        "login_type_user": "Admingebruikers",
        "login_type_user_description": "Gebruik SAML voor adminaanmelding bij de adminomgeving.",
        "name": "Naam",
        "name_id_format": "Name ID-formaat",
        "name_placeholder": "Microsoft Entra ID",
        "provider": "Provider",
        "url_placeholder": "https://idp.example.com/sso"
      },
      "idp_entity_id": "IdP entity ID",
      "login_url": "Login-URL",
      "metadata_url": "Metadata-URL",
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      },
      "read": {
        "description": "Kopieer deze waarden naar je identity provider-configuratie.",
        "title": "SAML-configuratie"
      },
      "save_provider": "Provider opslaan",
      "saved": "SAML-provider opgeslagen",
      "subtitle": "Configureer identity providers voor SSO.",
      "table": {
        "delete": "Verwijderen",
        "edit": "Bewerken",
        "name": "Naam",
        "provider": "Provider",
        "provider_id": "Provider-ID",
        "status": "Status"
      },
      "title": "SAML single sign-on"
    },
    "simulation": {
      "ceo_fraud": {
        "ceo": {
          "text": "Voer de contactgegevens van je CEO (of equivalent) in",
          "title": "Chief executive officer (CEO)"
        },
        "cfo": {
          "text": "Voer de contactgegevens van je CFO (of equivalent) in.",
          "title": "Financieel directeur (CFO)"
        },
        "cto": {
          "text": "Voer de contactgegevens van je CTO (of equivalent) in",
          "title": "Chief technology officer (CTO)"
        },
        "info": "We gebruiken de onderstaande informatie om onze CEO-fraude simulaties aan te passen voor je organisatie. Als je de informatie niet beschikbaar heeft, zullen we standaardwaarden gebruiken.",
        "subtitle": "Instellingen voor CEO-fraude-simulaties.",
        "title": "CEO-fraude"
      },
      "dmi": {
        "google": {
          "alert_text": "Zorg ervoor dat je DMI in Google Workspace configureert voordat je het hier inschakelt.",
          "subtitle": "Stel DMI in Google Workspace in om simulatie-e-mails direct in Gmail-inboxen te injecteren.",
          "title": "DMI for Google Workspace",
          "toggle": {
            "help": "Configureer DMI in Google Workspace en schakel het dan hier in zodra de setup voltooid is.",
            "label": "DMI activeren"
          }
        }
      },
      "search": {
        "placeholder": "Zoek naar diensten",
        "results": "Zoekresultaten voor: {query}"
      },
      "services": {
        "credential_harvest": "Referentiepagina",
        "selector": {
          "dialog_title": "Diensten bewerken",
          "edit_button": "Beschikbare services bewerken",
          "title": "Geen services geactiveerd | Eén dienst geactiveerd | {count} diensten geactiveerd",
          "update_services": "Diensten bijwerken"
        },
        "subtitle": "Instellingen voor targeting op basis van gebruikte software.",
        "title": "Softwaretargeting"
      },
      "training": {
        "download": {
          "subtitle": "Download de domeinen die worden gebruikt in onze phishing-simulaties.",
          "title": "Simulatiedomeinen downloaden"
        },
        "local_ratio": {
          "help": "Bij 70% krijgt een Duitstalige medewerker 70% Duitse sjablonen en 30% Engelse.",
          "subtitle": "Bepaal hoe sjablonen worden verdeeld tussen de taal van elke medewerker en het Engels. Wanneer dit is uitgeschakeld, is er geen vaste verhouding.",
          "title": "Sjablonen in de talen van medewerkers"
        },
        "subtitle": "Pas de gevoeligheids- en trackinginstellingen voor simulaties aan.",
        "title": "Algemeen",
        "toggle": {
          "subtitle": "Start automatisch aanvullende training wanneer een medewerker kwetsbaar blijkt te zijn.",
          "title": "Training"
        }
      }
    },
    "simulations": {
      "ceo_fraud": {
        "ceo_email": {
          "label": "E-mail"
        },
        "ceo_name": {
          "label": "Naam"
        },
        "cfo_email": {
          "label": "E-mail"
        },
        "cfo_name": {
          "label": "Naam"
        },
        "cto_email": {
          "label": "E-mail"
        },
        "cto_name": {
          "label": "Naam"
        }
      },
      "enable_ceo_fraud": "CEO-fraude inschakelen",
      "enable_module_help": "Schakel deze module in voor de organisatie.",
      "enable_software_targeting": "Softwaretargeting inschakelen"
    },
    "tables": {
      "reports": {
        "frequency": "Frequentie",
        "period": "Periode",
        "recipient": "Ontvanger",
        "status": "Status",
        "type": "Type"
      },
      "scim": {
        "actions": "Acties",
        "created": "Aangemaakt",
        "default_mapping": "Standaardmapping",
        "effective_mapping": "Effectieve mapping",
        "last_used": "Laatst gebruikt",
        "name": "Naam",
        "provider": "Provider",
        "status": "Status",
        "sync_type": "Type"
      },
      "tokens": {
        "created": "Aangemaakt",
        "last_used": "Laatst gebruikt",
        "name": "Naam"
      },
      "users": {
        "created": "Aangemaakt",
        "role": "Rol",
        "status": "Status",
        "two_factor": "2FA",
        "user": "Gebruiker"
      }
    },
    "threats": {
      "advanced_settings": {
        "hide": "Geavanceerde instellingen verbergen",
        "show": "Geavanceerde instellingen tonen"
      },
      "alias_email": {
        "help": "We raden aan om een gebruiksvriendelijkere aliasversie van het inkomende e-mailadres te maken. Bijvoorbeeld security{'@'}example.com",
        "label": "Alias-e-mail",
        "placeholder": "Veiligheid{'@'}example.com"
      },
      "clustering": {
        "title": "Dreigingen groeperen"
      },
      "enable_defender_integration": {
        "help": "Stuur gerapporteerde phishing-e-mails door naar Microsoft Defender.",
        "label": "Integratie met Microsoft Defender inschakelen",
        "title": "Microsoft Defender"
      },
      "enable_forwarding": {
        "help": "Schakel het doorsturen van dreigingen naar een specifiek e-mailadres in.",
        "title": "Doorsturen van dreigingen inschakelen"
      },
      "enable_grouped_threat_status_transitions": {
        "help": "Wanneer dit is ingeschakeld, krijgen nieuw aangemaakte dreigingen dezelfde status als hun gerelateerde dreiging",
        "title": "Automatische statusovergang voor dreigingen in clusters inschakelen"
      },
      "enable_notifications": {
        "help": "Ontvang een melding wanneer een potentiële dreiging wordt gemeld.",
        "title": "Meldingen inschakelen"
      },
      "enable_third_party_submission": {
        "help": "Schakel het automatisch indienen van phishingaanvallen bij Microsoft en Google in.",
        "title": "Indiening bij Microsoft en Google inschakelen"
      },
      "enable_threat_management": {
        "help": "Schakel dreigingsbeheer in voor deze organisatie.",
        "title": "Dreigingsbeheer inschakelen"
      },
      "forward_reported_emails_to": {
        "label": "Doorstuuradres:",
        "placeholder": "Gerapporteerd{'@'}company.com"
      },
      "forward_to": {
        "label": "Doorgestuurd naar:",
        "placeholder": "Phishing{'@'}company.com"
      },
      "forwarding": {
        "defender": {
          "description": "Stuur gemelde phishing-e-mails door naar Microsoft Defender.",
          "title": "Doorsturen naar Defender"
        },
        "disabled": {
          "description": "Stuur gemelde dreigingen niet door.",
          "title": "Doorsturen uitschakelen"
        },
        "email": {
          "description": "Stuur gemelde dreigingen naar een specifiek e-mailadres.",
          "title": "Doorsturen naar e-mail"
        },
        "title": "Dreigingen doorsturen"
      },
      "forwarding_warning": "Wanneer dreigingsdoorschakeling is ingeschakeld, zullen gerapporteerde dreigingen alleen-lezen zijn in het beheerderspaneel. Er zal geen analyse worden uitgevoerd door Moxso.",
      "inbound_email": {
        "help": "Dit e-mailadres is je persoonlijke rapporteer-e-mailadres. Alle e-mails die naar dit adres worden gestuurd, zullen worden geanalyseerd door Moxso.",
        "label": "Inkomende e-mail"
      },
      "save_forwarded_emails": {
        "help": "Wanneer dit is ingeschakeld, worden doorgestuurde e-mails opgeslagen.",
        "label": "Doorgestuurde dreigingen opslaan"
      },
      "subtitle": "Configureer de instellingen voor dreigingsbeheer.",
      "threat_grouping_confidence": {
        "help": "Bepaalt hoe sterk dreigingen moeten overeenkomen voordat ze in een cluster worden samengevoegd.",
        "label": "Betrouwbaarheidsniveau voor dreigingsclusters",
        "options": {
          "high": "Hoog",
          "low": "Laag",
          "medium": "Gemiddeld"
        }
      },
      "title": "Dreigingsbeheer"
    },
    "two_factor": {
      "actions": {
        "disable": "Tweefactorauthenticatie uitschakelen",
        "enable": "Tweefactorauthenticatie inschakelen",
        "regenerate_recovery_codes": "Herstelcodes opnieuw genereren",
        "view_recovery_codes": "Herstelcodes bekijken"
      },
      "disabled": {
        "badge": "Uit",
        "text": "Bescherm dit adminaccount met een code uit een authenticator-app of wachtwoordmanager.",
        "title": "Tweefactorauthenticatie is uitgeschakeld"
      },
      "enabled": {
        "badge": "Aan",
        "text": "Dit adminaccount vereist een tweede factor bij het inloggen.",
        "title": "Tweefactorauthenticatie is ingeschakeld"
      },
      "password_dialog": {
        "cancel": "Annuleren",
        "cancel-setup": {
          "button": "Instellen annuleren",
          "description": "Bevestig je huidige wachtwoord om het lopende instellen van tweefactorauthenticatie te annuleren.",
          "title": "Tweefactor instellen annuleren"
        },
        "current_password": "Huidig wachtwoord",
        "disable": {
          "button": "Uitschakelen",
          "description": "Bevestig je huidige wachtwoord om tweefactorauthenticatie voor dit account uit te schakelen.",
          "title": "Tweefactorauthenticatie uitschakelen"
        },
        "enable": {
          "button": "Doorgaan",
          "description": "Bevestig je huidige wachtwoord voordat je tweefactorauthenticatie instelt.",
          "title": "Tweefactorauthenticatie inschakelen"
        },
        "regenerate-recovery-codes": {
          "button": "Codes opnieuw genereren",
          "description": "Bevestig je huidige wachtwoord om je bestaande herstelcodes te vervangen.",
          "title": "Herstelcodes opnieuw genereren"
        },
        "show-recovery-codes": {
          "button": "Codes bekijken",
          "description": "Bevestig je huidige wachtwoord om je herstelcodes te bekijken.",
          "title": "Herstelcodes bekijken"
        }
      },
      "recovery_codes": {
        "copied": "Gekopieerd",
        "copy": "Codes kopieren",
        "text": "Bewaar deze eenmalige codes in je wachtwoordmanager. Ze worden hier niet opnieuw getoond nadat je ze sluit.",
        "title": "Herstelcodes"
      },
      "setup": {
        "cancel": "Instellen annuleren",
        "code_label": "Authenticatiecode",
        "code_placeholder": "123456",
        "confirm": "Bevestigen",
        "manual_key": "Handmatige instelsleutel",
        "qr_alt": "QR-code voor tweefactor instellen",
        "text": "Scan de QR-code met je authenticator-app of wachtwoordmanager en voer daarna de 6-cijferige code in die wordt gegenereerd.",
        "title": "Stel je authenticator in"
      },
      "subtitle": "Vereis een tweede factor bij het inloggen op je adminaccount.",
      "title": "Tweefactorauthenticatie"
    },
    "workspace": {
      "lms": {
        "subtitle": "Configureer een aangepaste content-URL om gebruikers door te sturen naar een extern leerplatform.",
        "title": "Extern LMS"
      },
      "logging": {
        "activity": "Activiteit",
        "columns": {
          "action_time": "Actietijd",
          "action_type": "Actietype",
          "actor": "Actor",
          "zone": "Zone"
        },
        "moxso_support": "Moxso support",
        "partner": "Partner",
        "slideover": {
          "actor": "Actor",
          "app": "App",
          "audit_log": "Auditlog",
          "created": "Aangemaakt",
          "email": "E-mail",
          "event": "Gebeurtenis",
          "impersonated_by_support": "Geïmiteerd door support",
          "ip_address": "IP-adres",
          "name": "Naam",
          "no": "Nee",
          "path": "Pad",
          "request": "Verzoek",
          "summary": "Overzicht",
          "tabs": {
            "request": "Verzoek",
            "summary": "Overzicht en actor"
          },
          "title": "Gebeurtenis",
          "type": "Type",
          "user_agent": "User agent",
          "yes": "Ja"
        },
        "subtitle": "Bekijk de geschiedenis van wijzigingen binnen dit account.",
        "title": "Auditlogs"
      },
      "scim": {
        "attribute_mapping": {
          "subtitle": "Overschrijf ondersteunde SCIM-attribuutdoelen voor deze verbinding. Lege rijen gebruiken de standaardmapping van de backend.",
          "title": "Attribuutmapping"
        },
        "connection_settings": {
          "subtitle": "Beheer de provider, naam en ingeschakelde status voor de geselecteerde SCIM-verbinding.",
          "title": "Verbindingsinstellingen"
        },
        "connections": {
          "disabled": "Uitgeschakeld",
          "enabled": "Ingeschakeld",
          "subtitle": "Configureer identiteitsproviderverbindingen voor geautomatiseerde SCIM-provisioning van gebruikers en groepen.",
          "title": "SCIM-verbindingen"
        },
        "endpoint": {
          "label": "Tenant-URL",
          "subtitle": "Gebruik deze basis-URL in je identiteitsprovider. Voeg geen Users, Groups of ServiceProviderConfig toe aan de URL.",
          "title": "Provisioning-endpoint"
        },
        "tokens": {
          "subtitle": "Maak bearer-tokens aan voor Microsoft Entra ID, Okta of een andere SCIM v2-identiteitsprovider.",
          "title": "SCIM-provisioningtokens"
        }
      },
      "subtitle": "Configureer je organisatie-instellingen.",
      "title": "Organisatie-instellingen",
      "tokens": {
        "subtitle": "Beveiligde toegang tot het Moxso datawarehouse vanuit je apps en services.",
        "title": "Datawarehouse"
      },
      "user": {
        "two_factor_disabled": "Uitgeschakeld",
        "two_factor_enabled": "Ingeschakeld",
        "verification_required": "Verificatie in afwachting",
        "verified": "Geverifieerd"
      },
      "users": {
        "subtitle": "Beheer gebruikers in je organisatie",
        "title": "Gebruikers"
      }
    }
  },
  "simulations": {
    "audience_missing_phone_numbers_all": "Geen van de medewerkers in de geselecteerde doelgroep heeft telefoonnummers. Verander de doelgroep of voeg telefoonnummers toe en probeer het opnieuw.",
    "audience_missing_phone_numbers_some": "Eén medewerker van de {total} in het geselecteerde publiek mist een telefoonnummer. | {count} medewerkers van de {total} in het geselecteerde publiek missen telefoonnummers.",
    "click_rate": {
      "title": "Klikpercentage"
    },
    "clicked": "Geklikt",
    "count": {
      "title": "Verwerkte simulaties",
      "unit": "Simulaties"
    },
    "create": {
      "button": "Simulatie maken",
      "configuration": {
        "choose_type": "Terug",
        "text": "Definieer de doelgroep en instellingen voor deze simulatie.",
        "title": "Configureer je simulatie",
        "token": "Stel een aangepaste e-mailkop in voor witlijstdoeleinden. Je token wordt als een {token} header meegegeven bij elke e-mail die vanuit deze simulatie wordt verzonden."
      },
      "credential_harvest": {
        "description": "Wanneer ingeschakeld, zullen medewerkers uitsluitend simulaties ontvangen die inlogpagina's bevatten. Moxso bewaakt formulierinzendingen, maar slaat nooit ingevoerde inloggegevens op.",
        "enable_label": "Inschakelen credential harvesting",
        "title": "Credential harvesting"
      },
      "delivery_rate": {
        "high": {
          "email_description": "1-2 weken tussen e-mails",
          "sms_description": "1-2 weken tussen sms-berichten",
          "title": "Hoog"
        },
        "low": {
          "email_description": "1-6 weken tussen e-mails",
          "sms_description": "1-6 weken tussen tekstberichten",
          "title": "Laag"
        },
        "medium": {
          "email_description": "1-4 weken tussen e-mails",
          "sms_description": "1-4 weken tussen tekstberichten",
          "title": "Gemiddeld"
        }
      },
      "help": {
        "audience": "Bepaal welke doelgroep deze simulatie moet ontvangen.",
        "email_delivery_rate": "Bepaalt de tijd tussen simulatiemails. De frequentie past zich aan binnen het leveringspercentagebereik op basis van de prestaties van de medewerker.",
        "sms_delivery_rate": "Definieert de tijd tussen simulatie-sms'jes. De frequentie past zich aan binnen het afleverpercentage, gebaseerd op de prestaties van medewerkers.",
        "staggered_delivery": "Simulaties worden willekeurig op werkdagen geleverd binnen het geselecteerde aantal dagen.",
        "test": "Testsimulaties hebben geen invloed op gebruikersopleidingsgegevens of rapportagemetingen."
      },
      "labels": {
        "audience": "Doelgroep",
        "delivery_rate": "Bezorgingspercentage",
        "name": "Naam",
        "preview": "Voorbeeldweergave",
        "schedule_type": "Type planning",
        "staggered_delivery": "Gespreide levering",
        "template": "Sjabloon",
        "test": "Markeer als test simulatie",
        "token": "Token",
        "token_header": "Stel een aangepast simulatie-tokenheader in",
        "use_template": "Gebruik aangepaste template"
      },
      "placeholders": {
        "audience": "Kies publiek",
        "name": "Simulatienaam",
        "token": "ABC-123"
      },
      "random_template": "Willekeurig template",
      "remove_template": "Sjabloon verwijderen",
      "step_current_of_last": "Stap {current_step} van {last_step}",
      "type": {
        "button": "Volgende",
        "email": {
          "text_plural": "Simulaties als e-mail verzenden",
          "text_singular": "Simulatie als e-mail verzenden",
          "title": "E-mail"
        },
        "help": {
          "delivery_method": "Kies hoe de simulatie wordt geleverd",
          "schedule_type": "Kies hoe vaak deze simulatie moet worden uitgevoerd"
        },
        "labels": {
          "delivery_method": "Bezorgmethode",
          "schedule_type": "Simulatietype"
        },
        "one_off": {
          "text": "De aanvallen worden eenmalig verzonden volgens de ingestelde planning.",
          "title": "Eenmalige simulatie"
        },
        "recurring": {
          "text": "De aanvallen worden automatisch herhaald volgens de ingestelde planning, totdat de simulatie wordt gedeactiveerd.",
          "title": "Geautomatiseerde simulatie"
        },
        "sms": {
          "text_plural": "Simulaties als sms-berichten verzenden",
          "text_singular": "Simulatie als sms versturen",
          "title": "Tekstbericht"
        },
        "text": "Kies het schema en de aflevermethode voor deze simulatie.",
        "title": "Instellen levering van simulatie"
      }
    },
    "delete": {
      "are_you_sure": "Weet je zeker dat je deze simulatie wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      "button": "Simulatie verwijderen",
      "simulation_deleted": "Simulatie verwijderd"
    },
    "details": {
      "heading": "Overzicht",
      "text": "Simulatiesamenvatting"
    },
    "edit": {
      "button": "Instellingen bewerken",
      "button_save": "Instellingen opslaan",
      "campaign_updated": "Simulatie bijgewerkt",
      "title": "Simulatie bewerken"
    },
    "filter": {
      "status": {
        "all": "Status: Alles",
        "click": "Status: Geklikt",
        "report": "Status: Gerapporteerd",
        "submission": "Status: Inloggen"
      }
    },
    "launch": {
      "button": "Simulatie starten",
      "input_label": "Typ het totale aantal ontvangers",
      "launched": "Simulatie gestart",
      "no_recipients": "De geselecteerde doelgroep heeft geen medewerkers. Pas de doelgroep aan en probeer het opnieuw.",
      "no_recipients_title": "Geen medewerkers",
      "title": "Simulatie starten",
      "warning": "Je staat op het punt een simulatie te starten die naar {count} ontvangers zal worden verzonden. Weet je zeker dat je wilt doorgaan?"
    },
    "opened": "Openen",
    "pause": "Simulatie pauzeren",
    "pause_confirmation": {
      "results": "Resultaten van al verzonden simulaties blijven behouden.",
      "title": "Simulatie pauzeren?",
      "warning": "Pauzeren annuleert {count} geplande verzending. Wanneer je de simulatie hervat, vervangt een nieuw schema de oorspronkelijke verzenddatums. Medewerkers moeten daardoor mogelijk langer wachten op hun volgende simulatie. | Pauzeren annuleert {count} geplande verzendingen. Wanneer je de simulatie hervat, vervangt een nieuw schema de oorspronkelijke verzenddatums. Medewerkers moeten daardoor mogelijk langer wachten op hun volgende simulatie."
    },
    "play": "Simulatie hervatten",
    "received": "Ontvangen",
    "report_rate": {
      "title": "Rapporteercijfer"
    },
    "reported": "Gerapporteerd",
    "scheduled": "Gepland",
    "send_test": "Stuur test",
    "send_test_tooltip": "Hiermee wordt een test-e-mail verzonden naar {userEmail}",
    "staggered_delivery": {
      "days": "{count} dag | {count} dagen",
      "off": "Uit"
    },
    "stop": {
      "button": "Simulatie stoppen",
      "simulation_stopped": "Simulatie gestopt",
      "title": "Simulatie stoppen?",
      "warning": "Als je de simulatie stopt, worden alle resterende geplande leveringen geannuleerd. Resultaten van simulaties die al zijn verzonden, blijven behouden. Weet je zeker dat je wilt doorgaan?"
    },
    "submission_disabled": "Uitgeschakeld",
    "submission_enabled": "Ingeschakeld",
    "submission_rate": {
      "title": "Inlogpercentage"
    },
    "submitted": "Inloggen",
    "summary": {
      "credential_harvest": "Inloggegevens oogsten",
      "delivery_method": "Bezorgmethode",
      "delivery_rate": "Bezorgingssnelheid",
      "group": "Doelgroep",
      "schedule_type": "Simulatietype",
      "staggered_delivery": "Gespreide levering",
      "test": "Testsimulatie",
      "type": "Type"
    },
    "templates": {
      "create": {
        "button": "Template maken",
        "success_text": "Sjabloon aangemaakt",
        "title": "Template maken"
      },
      "duplicate": {
        "button": "Dupliceren",
        "subject": "Kopie",
        "success_text": "Template gedupliceerd",
        "title": "Simulatietemplate dupliceren"
      },
      "edit": {
        "button": "Sjabloon opslaan",
        "success_text": "Sjabloon opgeslagen",
        "title": "Bewerk template voor simulatie"
      },
      "editor": {
        "ai_modal": {
          "button": "Genereer",
          "placeholder": "Beschrijf de simulatiesjabloon die je wilt maken...",
          "title": "Sjabloon genereren met AI"
        },
        "attack_link": "Aanvalslink",
        "attack_link_already_applied": "Aanvalslinks worden automatisch toegepast op knoppen.",
        "buttons": {
          "generate": "Genereren",
          "send_preview": "Voorbeeld verzenden"
        },
        "change_image": "Afbeelding wijzigen",
        "default_block_content": {
          "button": "Nu bekijken",
          "container_text": "Voeg hier je inhoud toe.",
          "footer_text": "Je ontvangt deze e-mail omdat je een werknemer bent van ::workspace.name::.",
          "heading_1": "Kop 1",
          "heading_2": "Kop 2",
          "heading_3": "Kop 3",
          "image_alt": "Afbeelding",
          "text": "Schrijf hier je bericht.",
          "unsubscribe": "Uitschrijven"
        },
        "generating_template": "Sjabloon genereren",
        "insert_image": "Afbeelding invoegen",
        "labels": {
          "custom_domain": "Aangepast domein",
          "email": "E-mail",
          "sender": "Afzender",
          "string_templates": {
            "date_last_month": "Zelfde dag vorige maand",
            "date_last_week": "Zelfde dag vorige week",
            "date_last_year": "Zelfde dag vorig jaar",
            "date_next_month": "Zelfde dag volgende maand",
            "date_next_week": "Zelfde dag volgende week",
            "date_next_year": "Zelfde dag volgend jaar",
            "date_today": "Vandaag",
            "date_tomorrow": "Morgen",
            "date_yesterday": "Gisteren",
            "department": "Afdeling",
            "email": "E-mail",
            "first_name": "Voornaam",
            "last_name": "Achternaam",
            "manager_email": "Manager e-mail",
            "manager_first_name": "Manager voornaam",
            "manager_last_name": "Manager achternaam",
            "workspace_address": "Bedrijfsadres",
            "workspace_city": "Bedrijfsstad",
            "workspace_name": "Bedrijfsnaam",
            "workspace_postal_code": "Postcode van het bedrijf"
          },
          "subject": "Onderwerp"
        },
        "no_image_selected": "Geen afbeelding geselecteerd",
        "placeholders": {
          "custom_domain": "example.com",
          "email": "Naam afzender",
          "sender_name": "Alice Smith",
          "subject": "Onderwerp invoeren"
        },
        "preview_sent_success": "Voorbeeld-e-mail succesvol verzonden.",
        "qr_code": "QR-code",
        "sidebar": {
          "blocks": "Blokken",
          "no_tags_found": "Geen tags gevonden",
          "settings": "Instellingen",
          "settings_title": "Instellingen voor geselecteerd blok",
          "style": "Ontwerp",
          "style_title": "Sjabloonontwerp",
          "tags": "Labels",
          "variables_title": "Merge tags"
        },
        "sidebar_field_options": {
          "center": "Gecentreerd",
          "fixed": "Vaste breedte",
          "full_width": "Volledige breedte",
          "left": "Links",
          "right": "Rechts"
        },
        "sidebar_fields": {
          "alt_text": "Alt-tekst",
          "auto": "Automatisch",
          "background_color": "Achtergrondkleur",
          "border_radius": "Hoekradius",
          "button_dimensions_hint": "Afmetingen zijn in pixels. Stel breedte of hoogte in op 0 om aan de tekst aan te passen.",
          "button_min_height": "Minimale hoogte",
          "color": "Kleur",
          "column_width": "Breedte van kolom {column} (%)",
          "columns": "Kolommen",
          "content_alignment": "Uitlijning",
          "content_width_mode": "Breedte",
          "font_size": "Lettergrootte",
          "gap": "Tussenruimte",
          "height": "Hoogte",
          "image_url": "Afbeelding",
          "padding": "Opvulling",
          "text_color": "Tekstkleur",
          "thickness": "Dikte",
          "width": "Breedte"
        },
        "sidebar_placeholders": {
          "alt_text": "Describe the image",
          "button_label": "Review now",
          "legal_copy": "You are receiving this email because you are an employee of ::workspace.name::."
        },
        "tooltip_fill_out_all_fields": "Vul alle velden in om een voorbeeld te verzenden",
        "tooltip_this_will_save_the_template": "Dit zal de template opslaan",
        "unsaved_changes": {
          "confirm_exit": "Je hebt niet-opgeslagen wijzigingen. Weet je zeker dat je wilt afsluiten?",
          "description": "Je hebt niet-opgeslagen wijzigingen. Als je de pagina verlaat zonder op te slaan, gaan je wijzigingen verloren.",
          "discard": "Wijzigingen verwerpen",
          "save_and_exit": "Opslaan en verlaten",
          "subtile": "Opslaan voordat je de pagina verlaat?",
          "title": "Niet-opgeslagen wijzigingen"
        },
        "unsaved_changes_badge": "Niet-opgeslagen wijzigingen"
      }
    },
    "test_sent": "Test-e-mail verzonden naar {userEmail}",
    "tooltip": {
      "click": "Er is op een link geklikt",
      "open": "Deze simulatie werd geopend",
      "report": "De simulatie werd gerapporteerd",
      "submit": "Er is een inlogpoging gedaan"
    },
    "updated": "Simulatie bijgewerkt"
  },
  "statistics": {
    "activities_by_type": {
      "completed_courses": "Voltooide cursussen",
      "phishing_quiz_correct_answers": "Correcte antwoorden op phishingquiz",
      "phishing_quiz_incorrect_answers": "Onjuiste antwoorden op phishingquiz",
      "quiz_answers": "Quizantwoorden",
      "quiz_correct_answers": "Correcte quizantwoorden",
      "quiz_incorrect_answers": "Onjuiste quizantwoorden",
      "simulations_delivered": "Geleverde simulaties",
      "simulations_failed": "Mislukte simulaties",
      "simulations_passed": "Geslaagde simulaties",
      "simulations_reported": "Gerapporteerde simulaties",
      "text": "Hoe je medewerkers aan het trainen zijn",
      "threats_reported": "Gemelde dreigingen",
      "title": "Voltooide activiteiten",
      "videos_watched": "Video's bekeken"
    },
    "benchmarks": {
      "above_benchmark_tooltip": "Waarde is boven de benchmark.",
      "average": "Netwerkgemiddelde",
      "below_benchmark_tooltip": "Waarde ligt onder de benchmark.",
      "benchmark_tooltip": "Benchmark",
      "peer_avg": "Gemiddelde van de groep.",
      "score": "Huidige score",
      "text_higher": "% beter dan vergelijkbare bedrijven",
      "text_lower": "% lager dan vergelijkbare bedrijven",
      "title": "Benchmarks"
    },
    "breaches": {
      "title": "Datalekken"
    },
    "competence": {
      "text": "Hoe goed je medewerkers presteren in hun training",
      "title": "Bekwaamheid"
    },
    "culture": {
      "text": "Hoe betrokken je medewerkers zijn bij hun beveiligingstraining",
      "title": "Cultuur"
    },
    "employee_activity": {
      "title": "Medewerkersactiviteit"
    },
    "employees": {
      "title": "Actieve medewerkers"
    },
    "onboarding": {
      "title": "Activatie"
    },
    "overdue": {
      "change": "{points} procentpunt t.o.v. {date}",
      "security_program_text": "Percentage medewerkers dat hun beveiligingsprogramma niet volgt (training, beleid)",
      "security_program_title": "Medewerkers die achterlopen op het beveiligingsprogramma",
      "text": "Percentage actieve medewerkers met gemiste trainingsdeadlines",
      "title": "Gemiste deadlines",
      "unit": "gemiste deadlines"
    },
    "recent_activity": "Recente activiteit",
    "resilience_score": {
      "change_last_90_days": "{value}% in de afgelopen 90 dagen",
      "text": "Berekende score gebaseerd op hoe alle actieve medewerkers trainen en presteren in simulaties.",
      "title": "Huidige weerbaarheidsscore"
    },
    "resilience_score_progression": {
      "title": "Ontwikkeling van de weerbaarheidsscore"
    },
    "risk_level": {
      "country": "Land",
      "text": "Het risiconiveau wordt bepaald door land, organisatie en een gesynthetiseerd risiconiveau, wat inzicht geeft in het huidige dreigingslandschap.",
      "title": "Risiconiveau",
      "workspace": "Organisatie"
    },
    "show_more": "Meer weergeven",
    "simulation_coverage": {
      "title": "Simulatiedeelname"
    },
    "simulations": {
      "campaign_overview": "Campagneoverzicht",
      "click_count": {
        "text": "Aantal keren dat een simulatie is aangeklikt.",
        "title": "Totaal aantal klikken",
        "unit": "Klikken"
      },
      "click_rate": {
        "text": "Berekende score op basis van het percentage medewerkers dat heeft geklikt op een link in een simulatie.",
        "title": "Klikpercentage",
        "unit": "%"
      },
      "count": {
        "text": "Totaal aantal verzonden simulaties.",
        "title": "Verzonden simulaties",
        "unit": "Simulaties"
      },
      "performance_metrics": "Prestaties metrics",
      "reporting_count": {
        "text": "Totaal aantal gerapporteerde simulaties",
        "title": "Totaal aantal rapporten",
        "unit": "Meldingen"
      },
      "reporting_rate": {
        "text": "Berekende score op basis van het percentage medewerkers dat een simulatie heeft gerapporteerd.",
        "title": "Meldpercentage",
        "unit": "%"
      },
      "submission_count": {
        "text": "Totaal aantal ingediende simulaties.",
        "title": "Totaal aantal ingevoerde gegevens",
        "unit": "Inzendingen"
      },
      "submission_rate": {
        "text": "Berekende score op basis van het percentage medewerkers dat heeft ingelogd op een simulatie.",
        "title": "Inlogpercentage",
        "unit": "Gemiddeld aantal ingevoerde gegevens per dag"
      },
      "submission_sent_count": "Totaal aantal verzonden simulaties"
    },
    "simulations_sent": {
      "title": "Verzonden simulaties"
    },
    "threats": {
      "count": {
        "text": "Aantal dreigingen gemeld door medewerkers.",
        "title": "Gerapporteerde dreigingen"
      },
      "fraud_count": {
        "text": "Aantal frauduleuze dreigingen gemeld door medewerkers.",
        "title": "Fraudemeldingen"
      },
      "handle_rate": {
        "text": "Berekende score op basis van het percentage dreigingen dat door een beheerder is afgehandeld.",
        "title": "Afhandelingspercentage"
      },
      "reporting_rate": {
        "title": "Gemelde dreigingen"
      },
      "status_partition": {
        "title": "Dreigingsstatus"
      },
      "text": "Hoe goed je medewerkers actie ondernemen tegen dreigingen",
      "time_to_handle": {
        "text": "De gemiddelde tijd die je medewerkers nodig hebben om een dreiging af te handelen.",
        "title": "Afhandelingstijd"
      },
      "title": "Detectie van dreigingen"
    },
    "timeframe_nienty_days": "In de afgelopen 90 dagen",
    "training": {
      "courses": {
        "title": "Cursussen",
        "unit": "Voltooide cursussen"
      },
      "phishing_quizzes": {
        "title": "Phishingquizzen"
      },
      "quizzes": {
        "title": "Quizresultaten"
      },
      "video_quizzes": {
        "title": "Videoquizzen"
      },
      "videos": {
        "title": "Video's",
        "unit": "Voltooide video's"
      }
    },
    "training_coverage": {
      "text": "Berekende score gebaseerd op het percentage medewerkers dat de beveiligingstraining heeft voltooid.",
      "title": "Trainingdeelname"
    }
  },
  "tables": {
    "anonymized_at": "Geanonimiseerd op",
    "audience": "Doelgroep",
    "audit_completed_status": "Bevestigd op",
    "available_at": "Beschikbaar om",
    "breached_at": "Aangemaakt op",
    "completed_at": "Voltooid op",
    "created": "Aangemaakt",
    "created_at": "Aangemaakt op",
    "deadlines": {
      "deadline": "Deadline",
      "employee": "Medewerker",
      "last_learning_interaction": "Laatste interactie",
      "lesson": "Les",
      "reminder_sent": "Laatste herinnering"
    },
    "delivery_method": "Bezorgmethode",
    "deselect_all": "Alles deselecteren",
    "domain": "Domein",
    "employee": "Medewerker",
    "employees": "Medewerkers",
    "enrolled_at": "Ingeschreven op",
    "error_count": "Overgeslagen",
    "filters": {
      "back": "Terug",
      "boolean": "{column} is {toggle}",
      "data": "Data filteren",
      "false": "Onwaar",
      "filter_by": "Filteren op",
      "group": "Filter op groep",
      "numberRange": "{column} van {minValue} tot {maxValue}",
      "search": "Zoeken",
      "select_date": "Selecteer datum",
      "status": "Status",
      "training_type": "Type",
      "true": "Waar"
    },
    "group": "Groep",
    "groups": "Groepen",
    "invited": "Uitgenodigd",
    "languages": "Talen",
    "last_sent_at": "Laatst verzonden",
    "lesson_status": "Lesstatus",
    "locale": "Taal",
    "name": "Naam",
    "overdue": "Achterstallig",
    "published_at": "Gepubliceerd op",
    "report_count": "Rapporttelling",
    "reports": "Meldingen",
    "scheduled_at": "Gepland voor",
    "score": "Score",
    "sensitivity": "Risiconiveau",
    "sent_to_count": "Verzonden",
    "status": "Status",
    "synced_count": "Gesynchroniseerd",
    "title": "Titel",
    "unique_click_count": "Kliks",
    "unique_submission_count": "Ingevoerde gegevens",
    "updated_at": "Bijgewerkt op"
  },
  "threats": {
    "analysis": {
      "attachments": {
        "files": "Bestanden",
        "subtitle": "E-mailbijlagen",
        "title": "Bijlagen"
      },
      "indicators": {
        "common": {
          "heading": "Veelvoorkomende dreigingen",
          "help": "De inhoud van de e-mail vermeldt bedrijfsnamen die vaak worden gebruikt bij phishing."
        },
        "credentials": {
          "heading": "Referenties",
          "help": "De inhoud van de e-mail vermeldt inloggegevens of wachtwoorden."
        },
        "detected": "Gedetecteerd",
        "homoglyphs": {
          "heading": "Homoglyfen",
          "help": "De naam van de afzender of e-mail bevat homogliefen."
        },
        "inconsistency": {
          "heading": "Inconsistentie",
          "help": "Inconsistenties in links en/of afzenderinformatie."
        },
        "no_data": "Geen gegevens",
        "not_detected": "Niet gedetecteerd",
        "subtitle": "Dreigingsindicatoren",
        "title": "Indicatoren",
        "urgency": {
          "heading": "Urgentie",
          "help": "Urgentie wordt gebruikt om de ontvanger onder druk te zetten om actie te ondernemen."
        }
      },
      "links": {
        "button": "Browserisolatie",
        "empty": "Geen links gevonden",
        "showing_links": "{shown} van {total} links weergegeven",
        "subtitle": "Links gevonden in e-mail",
        "title": "Koppelingen"
      },
      "preview": {
        "not_available": {
          "description": "We konden geen voorbeeld voor deze e-mail genereren.",
          "title": "Geen voorbeeld van afbeelding beschikbaar"
        },
        "subtitle": "E-mailvoorbeeld",
        "title": "Voorbeeld"
      },
      "sender": {
        "domain": "Domein",
        "email": "E-mail",
        "empty": "Geen verzenderanalyse gevonden",
        "ip": "IP-adres",
        "mx": "DNS MX-gegevens",
        "subtitle": "Afzenderanalyse",
        "title": "Afzender",
        "type": "Type",
        "type_text": {
          "free": "Gratis service",
          "paid": "Betaalde dienst"
        }
      }
    },
    "anonymized": {
      "title": "Geanonimiseerde dreiging"
    },
    "browser_isolation": {
      "button": "Link openen in browserisolatie",
      "copied": "Gekopieerd naar klembord",
      "heading": "Browserisolatie",
      "host": "Host",
      "notice": "BrowserLing is een service van derden die een veilige omgeving biedt voor het openen van links. Door op de knop hieronder te klikken, wordt je doorgestuurd naar de BrowserLing-website. Moxso is niet verbonden met BrowserLing en kan niet verantwoordelijk worden gehouden voor enige inhoud of activiteit die plaatsvindt op de BrowserLing-website.",
      "path": "Pad",
      "scheme": "Schema",
      "secured_by": "Beveiligd door BrowserLing"
    },
    "buttons": {
      "delete": "Dreiging verwijderen",
      "download_html": "HTML downloaden",
      "fraudulent": "Frauduleus",
      "legitimate": "Legitiem",
      "mark_as_fraudulent": "Als frauduleus markeren",
      "mark_as_legitimate": "Als legitiem markeren",
      "mark_as_spam": "Als spam markeren",
      "notify_reporters": "Informeer verslaggevers",
      "notify_reporters_description": "Meld verslaggevers over de statuswijziging van hun rapporten.",
      "show_headers": "E-mailkoppen weergeven",
      "show_less": "Minder weergeven",
      "show_more": "Meer weergeven",
      "spam": "Spam"
    },
    "comment_added": "Reactie toegevoegd",
    "created_at": "Gemaakt op",
    "current": "Huidig",
    "disabled": {
      "button": "Ga naar instellingen",
      "heading": "Dreigingsbeheer is uitgeschakeld",
      "text": "Bied je medewerkers een veilige manier om je op de hoogte te brengen en actie te ondernemen tegen potentiële dreigingen die in hun e-mailinboxen schuilen, waardoor de integriteit van je organisatie dagelijks wordt gewaarborgd. Blijf een stap voor op mogelijk kwaad."
    },
    "export_csv": {
      "description": "Download bevat alleen dreigingen met de geselecteerde status in de CSV-export.",
      "subtitle": "Kies dreigingsstatus",
      "title": "CSV downloaden"
    },
    "filter": {
      "status": {
        "all": "Status: Alles",
        "forwarded": "Status: Doorsturen",
        "fraudulent": "Status: Frauduleus",
        "legitimate": "Status: Legitiem",
        "spam": "Status: Spam",
        "unhandled": "Status: Onbehandeld"
      }
    },
    "forwarding_enabled": "Doorsturen ingeschakeld",
    "forwarding_warning": "Gerapporteerde dreigingen zijn alleen-lezen en moeten in een extern systeem worden afgehandeld.",
    "from": "Van",
    "headers": "Koppen",
    "mark_as": "Markeren als:",
    "no_more_unhandled_threats_button": "Sluiten",
    "no_more_unhandled_threats_text": "Je heeft alle gemelde dreigingen beoordeeld. Je inbox is nu beveiligd.",
    "no_more_unhandled_threats_title": "Alles helder!",
    "note_placeholder": "Voeg een notitie toe aan de reporters...",
    "related_threats": "Gerelateerde bedreigingen",
    "relative_time": {
      "days_ago": "{count} dag geleden | {count} dagen geleden",
      "hours_ago": "{count} uur geleden | {count} uur geleden",
      "minutes_ago": "{count} minuut geleden | {count} minuten geleden"
    },
    "report_information": "Rapportinformatie",
    "reported_by": "Gemeld door: {name}",
    "reports": {
      "clicked_link_warning": "Op een link geklikt",
      "phishing": "Phishing",
      "reported_as_phishing": "Gemeld als phishing",
      "reported_as_spam": "Gemeld als spam",
      "reporter_note": "Notitie van de melder",
      "spam": "Spam"
    },
    "review_next_threat_button": "Volgende dreiging beoordelen",
    "review_next_threat_text": "Wilt je de volgende niet afgehandelde dreiging beoordelen?",
    "status_updated": "Status bijgewerkt",
    "subject": "Onderwerp",
    "this_threat_has_been_forwarded": "Deze dreiging is doorgestuurd naar een extern systeem. Er is geen analyse uitgevoerd.",
    "timeline": {
      "analysis_completed": "Analyse voltooid",
      "button": "Opslaan",
      "status_transition": "Status overgegaan van {from} naar {to}",
      "textarea_placeholder": "Voeg een opmerking toe...",
      "title": "Activiteit"
    },
    "transition_description": "Bevestig welke rapporten deze status krijgen.",
    "x_of_n_selected": "{x} van {n} geselecteerd"
  },
  "titles": {
    "automations": {
      "subtitle": "Geautomatiseerde trainingsreeksen",
      "title": "Automatisering"
    },
    "breaches": {
      "subtitle": "Ontdek de datalekken in je organisatie.",
      "title": "Datalekken"
    },
    "dashboard": {
      "subtitle": "Overzicht van je organisatie.",
      "title": "Overzicht"
    },
    "group": {
      "subtitle": "Eén actief groepslid. | {count} actieve groepsleden."
    },
    "groups": {
      "subtitle": "Schik je medewerkers samen in groepen.",
      "title": "Groepen"
    },
    "integrations": {
      "subtitle": "Overzicht van integraties",
      "title": "Integraties"
    },
    "resilience": {
      "subtitle": "Overzicht van de weerbaarheid van je organisatie.",
      "title": "Weerbaarheid"
    },
    "simulations": {
      "custom_templates": {
        "subtitle": "Overzicht van al je aangepaste templates",
        "title": "Aangepaste templates"
      },
      "subtitle": "Simuleer phishingaanvallen op je medewerkers.",
      "title": "Simulaties"
    },
    "team": {
      "subtitle": "Alle medewerkers in je organisatie.",
      "title": "Medewerkers"
    },
    "threat": {
      "title": "Dreigingsrapport"
    },
    "threats": {
      "subtitle": "Overzicht van alle dreigingen en hun status",
      "title": "Dreigingen"
    },
    "training": {
      "course": {
        "subtitle": "Overzicht van alle cursussen",
        "title": "Cursussen"
      },
      "course_overview": {
        "title": "Cursusoverzicht"
      },
      "deadlines": {
        "subtitle": "Overzicht van deadlines",
        "title": "Deadlines"
      },
      "participation": {
        "subtitle": "Overzicht van trainingdeelname",
        "title": "Overzicht van deelname"
      },
      "subtitle": "Overzicht van de training van je organisatie",
      "title": "Training",
      "video": {
        "subtitle": "Overzicht van alle video's",
        "title": "Video's"
      },
      "video_overview": {
        "title": "Video-overzicht"
      }
    }
  },
  "training": {
    "actions": {
      "edit": "Bewerken",
      "edit_categories": "Categorieën bewerken",
      "save": "Opslaan"
    },
    "completed_status": {
      "completed": "Voltooid",
      "not_completed": "Niet voltooid"
    },
    "courses": {
      "actions": {
        "collapse_all": "Alles samenvouwen",
        "delete_course": "Cursus verwijderen",
        "edit": "Bewerken",
        "edit_categories": "Categorieën bewerken",
        "edit_course": "Cursus bewerken",
        "expand_all": "Alles uitklappen",
        "preview_course": "Cursusvoorbeeld bekijken",
        "save": "Opslaan"
      },
      "add_step": {
        "quiz": "Quiz inhoud",
        "text": "Tekstinhoud",
        "video": "Videoinhoud"
      },
      "create": {
        "button": "Cursus creëren"
      },
      "create_button": "Cursus aanmaken",
      "create_success": "Cursus succesvol aangemaakt",
      "create_title": "Nieuwe cursus aanmaken",
      "default_language_badge": "Standaard",
      "default_language_label": "Standaardtaal",
      "default_language_placeholder": "Kies een standaardtaal",
      "delete": {
        "are_you_sure": "Weet je zeker dat je deze stap wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        "course_are_you_sure": "Weet je zeker dat je deze cursus wilt verwijderen? Alle verplichte training en punten die aan deze cursus zijn gekoppeld, worden ook verwijderd. Deze actie kan niet ongedaan worden gemaakt.",
        "translation_are_you_sure": "Weet je zeker dat je deze vertaling wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt."
      },
      "details": {
        "heading": "Details"
      },
      "edit_name_dialog": {
        "save": "Titel opslaan",
        "title": "Cursustitel bewerken"
      },
      "errors": {
        "select_category": "Selecteer ten minste één categorie",
        "select_locale": "Kies ten minste één taal"
      },
      "form": {
        "labels": {
          "categories": "Categorieen",
          "risk_categories": "Categorieën",
          "title": "Titel"
        },
        "placeholders": {
          "categories": "Selecteer categorieën",
          "title": "Voer een titel in"
        }
      },
      "labels": {
        "categories": "Categorie | Categorieen",
        "no_categories": "Geen categorieen"
      },
      "language_card": {
        "add_language": "Voeg een taal toe",
        "editing": "Bewerken",
        "select_language": "Selecteer een taal",
        "switch": "Wisselen",
        "translate_with_ai": "Vertalen met AI"
      },
      "navigation": {
        "course": "Cursus",
        "participants": "Deelnemers"
      },
      "notifications": {
        "course_deleted": "Cursus verwijderd",
        "name_updated": "Cursusnaam bijgewerkt",
        "saved": "Opgeslagen",
        "settings_saved": "Wijzigingen opgeslagen",
        "step_deleted": "Stap verwijderd"
      },
      "preview": "Voorbeeld",
      "publish": "Cursus publiceren",
      "publish_confirm": "Ja, cursus publiceren",
      "publish_confirm_description": "Weet je zeker dat je deze cursus wilt publiceren? Het kan niet worden gedepubliceerd en zal onmiddellijk in de hub verschijnen.",
      "publish_success": "Cursus gepubliceerd",
      "quiz_editor": {
        "actions": {
          "cancel": "Annuleren",
          "save": "Opslaan"
        },
        "ai_prompt": {
          "button": "AI-prompt",
          "generate": "Genereren",
          "no_previous_steps": "Voeg eerder in de cursus een video- of tekststap toe om deze als context te gebruiken.",
          "placeholder": "Aangepaste instructies",
          "select_helper": "Kies stappen",
          "select_label": "Gebruik bestaande inhoud, een geschreven prompt of beide om nieuwe vragen te genereren.",
          "step_number": "Stap {order}",
          "step_type": {
            "quiz": "Quiz",
            "text": "Oefentype: AI-tekst.\nIn tegenstelling tot andere momenten bij het trainen met AI, gaat het bij deze oefentype niet om het verkrijgen van een correct antwoord. In plaats daarvan ligt de nadruk bij het zorgvuldig opstellen van een prompt die de AI aanmoedigt om een compleet en relevant antwoord of idee te genereren.\n\n**AI-tekstoefening in te voeren:** {'@'}.\n\n**{stepTypeDetailsPrompt}**\n\nNet als bij andere AI-gebaseerde vraagtypes kan je verwachten dat gebruikers dit met variërende moeilijkheidsgraad doorlopen. Daarom is het verstandig om de probleemstelling toegankelijk maar toch uitdagend te maken.\n\n**{stepTypeDetailsSolution}**\n\nBij deze oefentype is het belangrijk dat gebruikers begrijpen wat de bedoeling is van een opdracht voor het beantwoorden van een vraag door de AI. Dit is een uitgesproken kans om input te ontvangen en te intrainen, zodat de AI consistent betere resultaten oplevert.\n\n{stepTypeDetailsPublicLink}",
            "video": "Video"
          },
          "title": "Vragen toevoegen met behulp van AI",
          "untitled": "Naamloos"
        },
        "heading": {
          "description": "Quiz",
          "title": "Stap {step}"
        },
        "select_action": {
          "ai": {
            "description": "Laat AI automatisch quizvragen genereren uit je bestaande inhoud in deze cursus.",
            "title": "AI genereren uit inhoud"
          },
          "manual": {
            "description": "Bouw je eigen quiz vanaf nul door handmatig vragen en antwoorden toe te voegen.",
            "title": "Quiz handmatig maken"
          }
        }
      },
      "select_languages_description": "Kies de talen die je wilt opnemen in je cursusinhoud.",
      "set_current_language_as_default": "Instellen als standaard",
      "settings": {
        "edit_description": "Bewerk cursusbeschrijving",
        "save": "Opslaan"
      },
      "status": {
        "draft": "Concept",
        "missing_content_warning": "De cursus mist inhoud in een of meer talen",
        "published": "Gepubliceerd"
      },
      "steps": {
        "empty": {
          "description": "Klik op de knop bewerken hierboven om inhoud toe te voegen",
          "title": "Lege stap"
        },
        "intro": "Introductie",
        "knowledge_check": "Kenniscontrole",
        "missing_translation": "Vertaling ontbreekt voor deze taalinstelling",
        "quiz": "Quiz",
        "text": "Tekst",
        "video": "Video"
      },
      "tabs": {
        "course": "Cursus",
        "participants": "Deelnemers"
      },
      "text_editor": {
        "actions": {
          "cancel": "Annuleren",
          "edit": "Bewerken",
          "save": "Opslaan"
        },
        "ai_prompt": {
          "button": "Teksteditor AI-knop",
          "generate": "Genereren",
          "label": "Beschrijf wat je graag zou willen dat de AI doet",
          "placeholder": "\"Help me de tekst formeler te maken\"",
          "title": "Genereer tekstkaart met AI"
        },
        "ai_viewer": {
          "accept": "Accepteren",
          "back": "Annuleren",
          "caption": "Beoordeel de door AI gegenereerde inhoud en beslis of je deze wilt accepteren of opnieuw wilt genereren.",
          "generating": "Cursusinhoud genereren",
          "heading": "Bekijk gegenereerde inhoud"
        },
        "apply_image": {
          "button": "Toepassen op andere talen",
          "has_image": "Heeft afbeelding",
          "subtitle": "Kies talen om deze afbeelding toe te passen op",
          "title": "Afbeelding toepassen op andere talen"
        },
        "course_title_badge": "Cursustitel",
        "heading": {
          "description": "Teksteditor",
          "title": "Stap {step}"
        },
        "labels": {
          "after": "Na",
          "before": "Voor",
          "excerpt": "Uittreksel",
          "image_upload": "Afbeelding",
          "remove_image": "Afbeelding verwijderen",
          "title": "Titel",
          "uploaded_image_alt": "Geüploade afbeelding"
        },
        "placeholders": {
          "content": "Voer je inhoud in",
          "excerpt": "Voer een uittreksel in",
          "title": "Voer een titel in"
        },
        "title_linked_tooltip": "Wordt gebruikt als titel in de {language}-versie van de cursus."
      },
      "title_summary": {
        "course_title": "Cursustitel",
        "description": "Wordt gebruikt als titel in de {language}-versie van de cursus."
      },
      "translate": {
        "open": "Vertaal cursus",
        "submit": "Vertalen",
        "title": "Cursus vertalen"
      },
      "translate_success": "Cursus vertaald.",
      "translation_list_label": "Vertaling | Vertalingen",
      "unpublish": "Publicatie van cursus intrekken",
      "unpublish_confirm": "Ja, publicatie van cursus intrekken",
      "unpublish_confirm_description": "Weet je zeker dat je de publicatie van deze cursus wilt intrekken? De cursus verdwijnt meteen uit de hub.",
      "unpublish_success": "Publicatie van cursus ingetrokken",
      "untitled": "Ongetiteld",
      "validation": {
        "content_missing_in_languages": "Inhoud ontbreekt in één taal | Inhoud ontbreekt in {count} talen",
        "missing_content": "Ontbrekende inhoud",
        "missing_excerpt": "Ontbrekend fragment",
        "missing_image": "Ontbrekende afbeelding",
        "missing_questions": "Ontbrekende vragen",
        "missing_title": "Ontbrekende titel",
        "options_missing_text": "Sommige opties missen tekst",
        "questions_missing_correct_options": "Sommige vragen missen correcte opties",
        "questions_missing_text": "Sommige vragen missen tekst",
        "step_issues": "Stap problemen"
      },
      "video_editor": {
        "empty_search": {
          "description": "Probeer je trefwoorden te verfijnen of maak de zoekopdracht leeg om alle video's te bekijken.",
          "title": "Geen video's voldoen aan je zoekopdracht"
        },
        "empty_state": {
          "description": "Deze stap is leeg. Klik op de bewerkknop hierboven om inhoud toe te voegen."
        },
        "fallback_translation_tooltip": "Deze video maakt gebruik van een fallbackvertaling",
        "search_placeholder": "Video's zoeken",
        "selected": {
          "button": "Video wijzigen",
          "title": "VIDEO"
        },
        "subtitle": "Kies een video om aan deze stap toe te voegen.",
        "title": "Video selecteren"
      }
    },
    "custom_uploads": {
      "subtitle": "Video's van je organisatie",
      "title": "Eigen video's",
      "video": {
        "badges": {
          "quiz": "Quiz",
          "video": "Video"
        },
        "create": {
          "create_video": "Video maken",
          "next_steps_text": "Vul de onderstaande informatie in om je video in te stellen. Nadat je de video hebt gemaakt, word je naar de videopagina geleid, waar je deze vertaling kunt selecteren en een videobestand kunt uploaden.",
          "video_created": "Video gemaakt"
        },
        "delete": {
          "are_you_sure": "Weet je zeker dat je deze video wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
          "button": "Verwijderen",
          "video_deleted": "Video verwijderd"
        },
        "form": {
          "labels": {
            "categories": "Categorieen",
            "description": "Beschrijving",
            "language": "Taal",
            "title": "Titel"
          },
          "placeholders": {
            "categories": "Selecteer categorieën",
            "description": "Voer een beschrijving in",
            "language": "Kies taal",
            "title": "Voer een titel in"
          }
        },
        "publish": "Publiceren",
        "publish_confirm": "Publiceren",
        "publish_confirm_description": "Het publiceren maakt deze video beschikbaar in de hub en bruikbaar over het hele platform.",
        "publish_success": "Video gepubliceerd",
        "publish_unavailable": "Upload video's voor alle vertalingen voordat je publiceert.",
        "quiz": {
          "available_quizzes": "Beschikbare quizzes",
          "create": "Aanmaken",
          "edit": "Bewerken",
          "quiz_deleted": "Quiz verwijderd",
          "quiz_saved": "Quiz opgeslagen",
          "quizzes": "Quizresultaten",
          "quizzes_translated": "Quizresultaten vertaald."
        },
        "single": {
          "details": {
            "heading": "Details",
            "text": "Videodetails"
          },
          "labels": {
            "categories": "Categorie | Categorieen",
            "created_at": "Aangemaakt op",
            "published_at": "Gepubliceerd op",
            "updated_at": "Bijgewerkt op"
          },
          "title": "Aangepaste video"
        },
        "status": {
          "draft": "Concept",
          "published": "Gepubliceerd"
        },
        "translations": {
          "add_translation": "Vertaling toevoegen",
          "ai": {
            "done_translate_button": "Voltooid",
            "processing_n_languages": "Een taal verwerken | {count} talen verwerken",
            "text": "Gebruik DeepL om de titel en beschrijving van de video automatisch te vertalen naar een geselecteerde taal.",
            "title": "Vertaal videodetails met AI",
            "translate_button": "Vertalen",
            "translating_your_video": "Video-details vertalen",
            "video_now_available_in": "Vertalingen zijn gemaakt in één extra taal | Vertalingen zijn gemaakt in {count} extra talen",
            "video_translate_success": "Succes!"
          },
          "available_translations": "Beschikbare vertalingen",
          "create_title": "Vertaling toevoegen",
          "default_badge": "Standaard",
          "delete": "Verwijderen",
          "delete_are_you_sure": "Weet je zeker dat je deze vertaling wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
          "edit": "Bewerken",
          "edit_translation": "Vertaling bewerken",
          "empty": "Geen vertalingen voor deze video",
          "make_default": "Instellen als standaard",
          "manual": {
            "text": "Herschrijf de vertaling vanaf nul in een nieuwe taal.",
            "title": "Video handmatig vertalen"
          },
          "quiz": {
            "create": "Quiz maken",
            "edit": "Bewerk quiz",
            "other_translations_have_quizzes": "Andere vertalingen hebben quizzen",
            "other_translations_have_quizzes_want_to_translate": "Andere vertalingen hebben al quizzen. Wilt je deze quiz automatisch vertalen naar die talen?",
            "some_translations_have_no_quizzes": "Sommige vertalingen hebben momenteel geen quizzen. Nu vertalen?",
            "this_translation_has_quizzes_in_other_languages_translate_automatically": "Deze vertaling heeft quizzen in andere talen. Automatisch vertalen?",
            "translate_quiz": "Vertalen",
            "update_this_quiz_and_translate_others": "Werk deze quiz bij en vertaal andere quizzen",
            "update_this_quiz_only": "Werk alleen deze quiz bij"
          },
          "save_changes": "Wijzigingen opslaan",
          "single": {
            "edit": {
              "subtitle": "Werk de videogegevens bij",
              "title": "Videogegevens"
            },
            "upload": {
              "subtitle": "Upload videobestand voor deze vertaling.",
              "title": "Video uploaden",
              "video_deleted": "Video verwijderd",
              "video_uploaded": "Video geüpload"
            }
          },
          "translation_added": "Vertaling toegevoegd",
          "translation_deleted": "Vertaling verwijderd",
          "translation_updated": "Vertaling bijgewerkt",
          "translations": "Vertalingen",
          "video": "Video"
        },
        "unpublish": "Publicatie ongedaan maken",
        "unpublish_confirm": "De-publiceren",
        "unpublish_confirm_description": "De-publiceren zorgt ervoor dat deze video niet meer zichtbaar is in de hub. Het blijft nog steeds beschikbaar in elke automatisering waar het al wordt gebruikt.",
        "unpublish_success": "Video gedepubliceerd"
      }
    },
    "deadlines": {
      "bulk_reminder_dialog_confirm": "Verstuur {count} herinnering | Verstuur {count} herinneringen",
      "bulk_reminder_dialog_text": "Dit stuurt een melding naar {count} medewerkers. Elke medewerker ontvangt één melding, ook als die meerdere opdrachten heeft.",
      "bulk_reminder_dialog_title": "Stuur herinneringen naar iedereen die overeenkomt met je geselecteerde filters",
      "bulk_reminders_sent": "Herinneringen verzonden",
      "delete_reminder": "Herinnering verwijderen",
      "participation_title": "Deelname",
      "reminder_deleted": "Herinnering verwijderd",
      "reminder_sent": "Herinnering verzonden",
      "send_bulk_reminder": "Herinneringen versturen",
      "send_reminder": "Verstuur herinnering"
    },
    "default_language_updated": "Standaardtaal bijgewerkt",
    "default_translation_tooltip": "Dit is momenteel de standaardtaal. Kies een andere taal voordat je deze verwijdert.",
    "errors": {
      "select_category": "Selecteer ten minste één categorie"
    },
    "filter": {
      "course": "Alleen cursussen tonen",
      "video": "Alleen video's tonen"
    },
    "form": {
      "labels": {
        "categories": "Categorieën",
        "no_categories": "Geen categorieen"
      },
      "placeholders": {
        "categories": "Selecteer categorieën"
      }
    },
    "invited_status": {
      "invited": "Uitgenodigd",
      "not_invited": "Niet uitgenodigd"
    },
    "moxso_courses": {
      "description": "Cursussen van je organisatie",
      "title": "Eigen cursussen"
    },
    "moxso_uploads": {
      "subtitle": "Video’s van Moxso",
      "title": "Moxso-video’s"
    },
    "quiz": "Quiz",
    "search_courses": {
      "description": "Zoekresultaten die overeenkomen met je zoekopdracht",
      "title": "Zoekresultaten"
    },
    "type": {
      "course": "Cursus",
      "user_course": "Cursus voor gebruiker",
      "video": "Video"
    },
    "user_defined_courses": {
      "description": "Door je organisatie gemaakte cursussen",
      "title": "Gebruikersgedefinieerde cursussen"
    }
  },
  "translations": {
    "ai": {
      "overwrite_existing_translations_text": "Hiermee worden de bestaande vertalingen verwijderd en opnieuw vertaald vanaf nul.",
      "overwrite_existing_translations_title": "Bestaande vertalingen overschrijven",
      "select_languages_to_translate_item_into": "Kies de talen waarvoor je vertalingen wilt genereren",
      "translate_from": "Vertalen van"
    },
    "deepl_privacy": "Het privacybeleid van DeepL",
    "deepl_text": "Dit stuurt een kopie van je vertaling naar DeepL, een externe AI-gestuurde vertaaldienst. Je inhoud zal extern worden verwerkt, en {link} zal van toepassing zijn.",
    "quizzes": {
      "done_translate_button": "Voltooid",
      "processing_n_languages": "Een taal verwerken | {count} talen verwerken",
      "quiz_now_available_in": "Je quiz is nu beschikbaar in één extra taal | Je quiz is nu beschikbaar in {count} extra talen",
      "quiz_translate_success": "Succes!",
      "select_the_languages_you_want_to_translate_your_quiz_into": "Kies de talen waarin je je quiz wilt vertalen",
      "translate_button": "Vertalen",
      "translate_from": "Vertaal van",
      "translate_multiple_choice_quiz": "Vertaal meerkeuzetoets",
      "translating_your_quiz": "Je quiz vertalen"
    }
  },
  "two_factor_challenge": {
    "back_to_login": "Terug naar inloggen",
    "code": {
      "label": "Authenticatiecode",
      "placeholder": "123456"
    },
    "heading": "Tweefactorauthenticatie",
    "recovery_code": {
      "label": "Herstelcode",
      "placeholder": "aaaaaaaaaa-bbbbbbbbbb"
    },
    "submit": "Verifieer",
    "text": "Voer een code uit je authenticator-app in of gebruik een herstelcode om door te gaan.",
    "use_authenticator_code": "Gebruik een authenticator-code",
    "use_recovery_code": "Gebruik een herstelcode"
  },
  "uploads": {
    "file_upload": {
      "click_to_upload": "Klik om te uploaden",
      "delete": {
        "are_you_sure": "Weet je zeker dat je dit bestand wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        "button": "Verwijderen"
      },
      "file_upload_limit": "{fileType} · Tot {fileSize} · {imageRatio} aanbevolen",
      "or_drag_and_drop": "{klik} of slepen en neerzetten",
      "placeholder": "Bestand",
      "title": "Bestand uploaden",
      "up_to": "Tot en met",
      "upload_failed": {
        "button": "Nieuwe upload",
        "subtitle": "Het uploaden van het opgegeven bestand is mislukt.",
        "title": "Upload mislukt"
      },
      "upload_in_progress": {
        "processing_subtitle": "Upload voltooid. Je kunt deze pagina veilig verlaten terwijl we het verwerken.",
        "processing_title": "Bezig met het verwerken van je bestand...",
        "uploading_subtitle": "Je bestand wordt geüpload.",
        "uploading_title": "Bestand uploaden..."
      }
    },
    "image_upload": {
      "click_to_upload": "Klik om te uploaden",
      "delete": {
        "are_you_sure": "Weet je zeker dat je deze afbeelding wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        "button": "Verwijderen"
      },
      "or_drag_and_drop": "Of sleep en zet neer",
      "upload_failed": {
        "button": "Nieuwe upload",
        "subtitle": "Het uploaden van het bestand is mislukt.",
        "title": "Upload mislukt"
      },
      "upload_in_progress": {
        "processing_subtitle": "Upload voltooid. Je kunt deze pagina veilig verlaten terwijl we het verwerken.",
        "processing_title": "Je bestand wordt verwerkt...",
        "uploading_subtitle": "Je bestand wordt geüpload.",
        "uploading_title": "Bestand wordt geüpload..."
      }
    },
    "video_upload": {
      "click_to_upload": "Klik om te uploaden",
      "delete": {
        "are_you_sure": "Weet je zeker dat je deze video wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        "button": "Verwijderen"
      },
      "format": "MP4",
      "max": "Maximale",
      "or_drag_and_drop": "Of sleep en neerzet",
      "up_to": "Tot en met",
      "upload_failed": {
        "button": "Nieuwe upload",
        "subtitle": "Het uploaden van het bestand is mislukt.",
        "title": "Upload mislukt"
      },
      "upload_in_progress": {
        "processing_subtitle": "Upload voltooid. Je kunt deze pagina veilig verlaten terwijl wij het verwerken.",
        "processing_title": "Je bestand wordt verwerkt...",
        "uploading_title": "Bestand uploaden..."
      }
    }
  },
  "upsell": {
    "click_to_open": "Klik om meer te lezen",
    "contact": "Breng Customer Success op de hoogte",
    "knowledge_base": "Kennisbank",
    "learn_more": "Meer informatie",
    "locked_feature": "Vergrendelde functie",
    "notify_success": "Melding verzonden naar Customer Success",
    "upgrade_required": "Voor deze functie is een upgrade vereist"
  },
  "user_settings": {
    "subtitle": "Beheer de beveiligingsinstellingen voor je adminaccount.",
    "title": "Beveiliging en toegang"
  },
  "validate_domain": {
    "login": "Aanmelden",
    "success": "Het domein is met succes geverifieerd."
  },
  "videos": {
    "error": "Streaming is momenteel niet beschikbaar"
  },
  "workspace_onboarding": {
    "invite_admins": {
      "form": {
        "button": "Beheerder uitnodigen",
        "description": "Voeg extra beheerders toe als anderen ook moeten helpen met de inrichting of het beheer van Moxso. Alle beheerders hebben dezelfde toegang en zien dezelfde wijzigingen.",
        "title": "Nog een beheerder uitnodigen"
      },
      "header": {
        "description": "Bepaal vanaf het begin wie beheerderstoegang moet hebben. Als meer dan één persoon cybersecurity of Moxso gaat beheren, nodig hen dan nu uit zodat inrichting en eigenaarschap vanaf dag één worden gedeeld. Alle beheerders hebben dezelfde toegang en zien dezelfde wijzigingen.",
        "title": "Beheerders uitnodigen"
      },
      "intro": {
        "admin_added": "Je hebt al meer dan één beheerder in deze werkruimte.",
        "description": "Eén beheerder kan goed werken voor kleinere teams, terwijl meerdere beheerders overdracht en samenwerking makkelijker kunnen maken.",
        "eyebrow": "Aanbevolen vóór de lancering",
        "recommendation": "Kies de inrichting die bij je team past en nodig extra beheerders uit als het eigenaarschap wordt gedeeld.",
        "title": "Beheerderstoegang delen"
      },
      "list": {
        "added_on": "Toegevoegd op",
        "description": "Bekijk de beheerders die momenteel toegang hebben tot deze werkruimte.",
        "title": "Werkruimtebeheerders",
        "you": "Jij"
      }
    },
    "kick_off": {
      "complete": "Kick-off plannen",
      "dates": {
        "description": "Plan de kickoffdatums",
        "locked": "Vergrendeld",
        "locked_description": "Voltooi de bovenstaande vereisten om de planning te ontgrendelen.",
        "simulation": {
          "custom_date": "Aangepaste datum",
          "custom_date_description": "Kies een specifieke dag",
          "label": "Kickoffdatum simulatie",
          "one_week_before": "1 week voor de training",
          "recommended": "Aanbevolen"
        },
        "title": "Kickoffdatums",
        "training": {
          "description": "Medewerkers ontvangen op deze dag hun eerste trainingsmodule.",
          "label": "Kickoffdatum training",
          "placeholder": "Kies een datum"
        }
      },
      "header": {
        "description": "Kies de dag waarop medewerkers met hun bewustwordingstraining beginnen. Vooraf wordt een nulmeting met een phishing-simulatie uitgevoerd.",
        "title": "Kickoff plannen"
      },
      "validation": {
        "description": "Voltooi deze stappen voordat je de training kunt plannen.",
        "requirements_count": "{count} van {total} voltooid",
        "set_up": "Instellen",
        "title": "Kickoffvalidatie"
      }
    },
    "microsoft_manual_setup": {
      "junk": {
        "button": "Zo omzeil je ongewenste-e-mailfilters",
        "heading": "Ongewenste-e-mailfilter omzeilen",
        "text": "Deze gids geeft stapsgewijze instructies om Moxso-e-mails ongewenste-e-mailfilters te laten omzeilen."
      },
      "safe_links": {
        "button": "Zo omzeil je Safe Links",
        "heading": "Safe Links omzeilen",
        "text": "Deze gids geeft stapsgewijze instructies om Moxso-e-mails Safe Links te laten omzeilen."
      },
      "spam": {
        "button": "Zo omzeil je spamfilters",
        "heading": "Spamfilter omzeilen",
        "text": "Deze gids geeft stapsgewijze instructies om Moxso-e-mails spamfilters te laten omzeilen."
      },
      "tenant_allow_block": {
        "button": "Zo zet je Moxso via IP op de toelatingslijst in Outlook",
        "heading": "Voeg Moxso-IP's toe aan Tenant Allow/Block Lists",
        "text": "Deze gids geeft stapsgewijze instructies om Moxso-IP-adressen toe te voegen aan de Tenant Allow/Block Lists in Microsoft Defender om correcte e-mailbezorging te garanderen."
      },
      "third_party": {
        "button": "Zo voeg je Moxso-IP's en domeinen toe aan Microsoft Defender",
        "heading": "Voeg Moxso's IP's en domeinen toe aan Microsoft Defender",
        "text": "Deze gids geeft stapsgewijze instructies om Moxso's IP's en domeinen toe te voegen aan de Third-Party Phishing Simulation-instellingen in Microsoft Defender om correcte e-mailtests en bezorging te garanderen."
      }
    },
    "onboarding_actions": {
      "back": "Terug",
      "continue": "Doorgaan",
      "knowledge_base": "Kennisbank",
      "mark_as_completed": "Markeren als voltooid",
      "skip": "Later instellen"
    },
    "progress_badge": {
      "kick_off_planned": "Kickoff gepland",
      "simulation_date": "Startdatum simulatie",
      "training_start": "Startdatum training",
      "workspace_setup": "Instelling:"
    },
    "reporting_add_in": {
      "confirm_setup": {
        "description": "Als de Moxso-plugin zichtbaar is in je mailbox, kunnen medewerkers deze gaan gebruiken om verdachte e-mails direct vanuit hun inbox te melden.",
        "manage_later": "Bekijk hoe rapporteren werkt in {link}.",
        "subtitle": "Volg de handleiding voor je e-mailprovider en ga verder zodra de add-in is uitgerold.",
        "this_guide": "deze handleiding",
        "title": "Is de Moxso-plugin zichtbaar in je mailbox?"
      },
      "continue_disabled_tooltip_text": "Selecteer een e-mailprovider om verder te gaan.",
      "follow_guide": {
        "gmail": "Gmail",
        "outlook": "Outlook",
        "title": "Volg de handleiding hieronder"
      },
      "guide_picker": {
        "gmail": {
          "description": "Stapsgewijze handleiding om de reporting add-in in Gmail in te stellen.",
          "title": "Gmail"
        },
        "outlook": {
          "description": "Stapsgewijze handleiding om de reporting add-in in Outlook in te stellen.",
          "title": "Outlook"
        },
        "title": "Selecteer je e-mailprovider"
      },
      "header": {
        "description": "Stel de Moxso reporting add-in in zodat medewerkers verdachte e-mails snel rechtstreeks vanuit hun inbox kunnen melden als onderdeel van hun normale e-mailworkflow.",
        "title": "Reporting add-in instellen"
      }
    },
    "setup_provider": {
      "add_simulation": {
        "button": "Simulatieconcept aanmaken",
        "continue_disabled_tooltip_text": "Stel een phishing-simulatiecampagne in om door te gaan",
        "description": "We hebben een phishing-simulatiecampagne opgezet op basis van je bedrijfsprofiel. Deze campagne dient als nulmeting om verbeterpunten te identificeren.",
        "description_cta": "Klik op de knop hieronder om de simulatie aan te maken",
        "header": {
          "description": "Stel een phishing-simulatiecampagne in die doorlopend realistische e-mails verstuurt, zodat medewerkers kunnen oefenen met het herkennen van bedreigingen. Je kunt de instellingen en doelgroep van de campagne aanpassen nadat de campagne is gestart.",
          "title": "Stel je eerste phishing-simulatie in"
        },
        "settings_card": {
          "Audience": "Doelgroep",
          "Credential harvest": "Verzameling van inloggegevens",
          "Delivery rate": "Verzendfrequentie",
          "Name": "Naam",
          "all_employees": "Alle medewerkers",
          "baseline_campaign": "Nulmetingscampagne",
          "credential_harvest": "Ingeschakeld",
          "delivery_rate": "Gemiddeld"
        },
        "simulation_created": "Simulatieconcept aangemaakt",
        "subtitle": "Klaar om te starten",
        "title": "Aanbevolen instellingen"
      },
      "buttons": {
        "back": "Terug",
        "continue": "Doorgaan"
      },
      "header": {
        "description": "Stel een integratie in om de gegevens van je medewerkers automatisch met het systeem te synchroniseren. Zo blijven medewerkergegevens up-to-date en zijn handmatige updates niet nodig.",
        "title": "Integraties configureren"
      },
      "integration": {
        "header": {
          "description": "Selecteer of je wilt integreren met je HR-database (identity provider) of in plaats daarvan je werknemers handmatig wilt importeren via een CSV-bestand. We raden de handmatige optie niet aan omdat het systeem dan niet automatisch kan synchroniseren en updaten in de tijd (bijhouden van nieuwe of inactieve gebruikers).",
          "title": "Synchroniseer werknemers"
        },
        "warning": "Een beheerdersaccount met globale rechten is vereist om synchronisatie met Microsoft Entra ID of Google Workspace in te stellen."
      },
      "provider": {
        "csv_import": "CSV-import",
        "description": "Selecteer het platform waarmee je identiteiten en medewerkers beheert.",
        "employees": "Medewerkers",
        "google": "Google Workspace",
        "google_sync": "Google Sync",
        "microsoft": "Microsoft",
        "microsoft_sync": "Microsoft Entra ID",
        "okta": "Okta",
        "title": "Kies je provider"
      },
      "recommendations": {
        "create_target_group": {
          "description": "Maak een groep met de medewerkers die je wilt targeten, zodat je simulaties en trainingen eenvoudig kunt toewijzen door de groep direct te selecteren.",
          "title": "Doelgroep aanmaken"
        },
        "heading": {
          "description": "Volg deze stappen voordat je werknemers importeert om ervoor te zorgen dat de juiste gegevens worden gesynchroniseerd. Hoewel niet verplicht, bespaart dit je later tijd.",
          "title": "Bereid je voor op integratie"
        },
        "verify_language_settings": {
          "description": "Zorg dat de taalinstellingen van medewerkers correct zijn, zodat de juiste taal naar Moxso wordt gesynchroniseerd.",
          "title": "Taalinstellingen controleren"
        },
        "warning": "Zorg ervoor dat nieuwe medewerkers altijd worden toegevoegd aan de groepen die met Moxso zijn gesynchroniseerd."
      },
      "saml_scim": {
        "header": {
          "description": "Configureer single sign-on en automatische gebruikersprovisioning. Voltooi beide onderdelen hieronder en ga verder zodra je identity provider is gekoppeld.",
          "title": "SAML en SCIM instellen"
        }
      },
      "setup_method": {
        "header": {
          "description": "Gebruik SAML en SCIM voor veilig aanmelden en automatische provisioning, of koppel een provider via de standaardintegratie.",
          "title": "Kies je configuratie"
        },
        "provider_integration": {
          "description": "Synchroniseer medewerkers rechtstreeks vanuit Microsoft Entra ID, Google Workspace, Slack of een CSV-bestand.",
          "title": "Standaardintegratie"
        },
        "recommended": "Aanbevolen",
        "saml_scim": {
          "description": "Schakel single sign-on en automatische gebruikersprovisioning in.",
          "title": "SAML en SCIM"
        }
      },
      "whitelisting": {
        "buttons": {
          "change_guides": "Handleiding wijzigen",
          "confirm_whitelist": "Allowlisting bevestigen",
          "manual": "Handmatig",
          "test_whitelist": "Allowlisting testen"
        },
        "continue_disabled_tooltip_text": "Bevestig dat de allowlisting werkt voordat je verdergaat.",
        "follow_guide": {
          "gmail": "Gmail",
          "outlook": "Outlook",
          "title": "Volg de onderstaande handleiding"
        },
        "guide_picker": {
          "gmail": {
            "description": "Stapsgewijze handleiding om e-mails in Gmail door te laten.",
            "title": "Gmail"
          },
          "outlook": {
            "description": "Stapsgewijze handleiding om e-mails in Outlook door te laten.",
            "title": "Outlook"
          },
          "title": "Kies je e-mailprovider"
        },
        "header": {
          "description": "Stel allowlisting in voor onze IP-adressen en domeinen zodat phishing-simulaties in de inbox van medewerkers worden afgeleverd en niet door spamfilters worden geblokkeerd.",
          "title": "Zorg dat berichten niet als spam worden gemarkeerd"
        },
        "send_test": {
          "buttons": {
            "no": "Nee, help mij",
            "send_test": "Testmail verzenden",
            "yes": "Ja, ik heb hem ontvangen"
          },
          "confirm": {
            "text": "Controleer je inbox (en spammap).",
            "title": "Heb je de e-mail ontvangen | Heb je de e-mails ontvangen"
          },
          "description": "Stuur een testmail om te bevestigen dat deze in je inbox op {email} wordt afgeleverd (en niet in de spammap). {try_a_few_times}, elke e-mail gebruikt andere inhoud en domeinen.",
          "subtitle": "Testmail verzenden",
          "success": {
            "text": "Je configuratie is correct. Je kunt nu doorgaan naar de volgende stap.",
            "title": "Allowlisting werkt"
          },
          "title": "Bevestig dat de allowlisting werkt",
          "try_a_few_times": "Probeer het een paar keer"
        }
      }
    },
    "simulation": {
      "targeting": {
        "add_services": "Diensten toevoegen",
        "ceo": "Contactgegevens CEO",
        "cfo": "Contactgegevens CFO",
        "content_description": "Voeg contactgegevens van directieleden en je diensten toe voor realistischere simulaties.",
        "content_title": "Personaliseer je simulaties",
        "cto": "Contactgegevens CTO",
        "description": "Configureer realistische targeting voor je organisatie.",
        "edit_services": "Diensten bewerken",
        "no_services": "Geen diensten geselecteerd",
        "services": "Diensten",
        "services_title": "Selecteer diensten",
        "title": "Simulaties instellen"
      }
    },
    "steps": {
      "add_simulation": "Simulaties",
      "invite_admins": "Beheerders",
      "kick_off": "Kickoff",
      "reporting_add_in": "Rapportage-add-in",
      "setup_provider": "Integraties",
      "training": "Training",
      "verify_domains": "Domeinen",
      "welcome": "Welkom",
      "whitelisting": "Allowlisting"
    },
    "training": {
      "header": {
        "description": "Kies of Moxso training automatisch toewijst of dat je deze zelf plant, en stem daarna de instellingen af op je organisatie.",
        "title": "Training instellen"
      },
      "mode": {
        "continue_disabled": "Kies een trainingsaanpak om door te gaan.",
        "description": "Kies een aanpak om deze stap af te ronden.",
        "title": "Kies hoe training verloopt"
      }
    },
    "verify_domains": {
      "buttons": {
        "add": "Toevoegen",
        "resend": "Opnieuw verzenden",
        "verify": "Verifiëren"
      },
      "continue_disabled_tooltip_text": "Verifieer minimaal één domein voordat je verdergaat",
      "domain_placeholder": "bedrijf.com",
      "empty": {
        "subtitle": "Voeg hierboven je bedrijfsdomeinen toe om verder te gaan",
        "title": "Nog geen domeinen toegevoegd"
      },
      "heading": {
        "description": "Voeg alle bedrijfsdomeinen toe die worden gebruikt in e-mailadressen van medewerkers om je medewerkers te importeren. Er wordt een verificatiemail naar {email} gestuurd om elk domein te bevestigen.",
        "title": "Bevestig je domeinen"
      },
      "labels": {
        "add_domain": "Domein toevoegen",
        "not_verified": "Niet geverifieerd",
        "verification_pending": "Verificatie in behandeling",
        "verified": "Geverifieerd",
        "verified_on": "Geverifieerd op: {date}"
      },
      "verification_email_sent": "Verificatiemail verzonden",
      "your_domains": "Je domeinen"
    },
    "welcome": {
      "connect_provider": {
        "description": "Bereid je voor op integratie en synchronisatie van werknemers",
        "title": "Configureer integraties"
      },
      "description": "Je bent misschien al bekend met de onderstaande stappen, maar we zorgen er nu voor dat ze allemaal zijn voltooid zodat je live kunt gaan. Alle testgegevens die je mogelijk eerder hebt aangemaakt, zijn nu verwijderd.",
      "get_started": "Aan de slag",
      "invite_admins": {
        "description": "Bepaal of anderen ook moeten helpen met de inrichting en het doorlopende beheerwerk.",
        "title": "Beheerders uitnodigen"
      },
      "launch_phishing_simulation": {
        "description": "Maak een baselinesimulatie en stel CEO-fraude en softwaretargeting in.",
        "title": "Simulaties"
      },
      "reporting_add_in": {
        "description": "Voeg de Moxso-meldknop toe aan de inboxen van medewerkers.",
        "title": "Reporting add-in instellen"
      },
      "review_and_start": {
        "description": "Controleer de instellingen en begin Moxso te gebruiken.",
        "title": "Begin met Moxso"
      },
      "subtitle": "Welkom bij Moxso",
      "title": "Laten we je klaarmaken om te starten.",
      "training": {
        "description": "Kies een trainingsvorm en de kaders die voor je organisatie belangrijk zijn.",
        "title": "Training"
      },
      "verify_domains": {
        "description": "Verifieer de domeinen die je met Moxso wilt gebruiken.",
        "title": "Domeinen verifiëren"
      },
      "whitelist_email": {
        "description": "Zorg ervoor dat berichten niet als spam worden gemarkeerd.",
        "title": "Stel allowlisting in"
      }
    }
  },
  "workspace_report": {
    "assignments": "Toewijzingen",
    "avg_score": "Gem. score",
    "compared_against": "Vergeleken met {period}",
    "department": "Afdeling",
    "employee": "Medewerker",
    "employees_at_risk": "Medewerkers met risico",
    "generated": "Gegenereerd {date}",
    "group": "Groep",
    "group_breakdown": "Groepsoverzicht",
    "group_breakdown_description": "Samengevoegde signalen, toewijzingen en interventies per groep",
    "group_breakdown_description_without_hri": "Samengevoegde toewijzingen per groep",
    "group_breakdown_note": "De gemiddelde score is gewogen op basis van het aantal medewerkers in elke groep. De signaalbalk verdeelt de activiteit in negatief, neutraal en positief sentiment.",
    "group_breakdown_note_without_hri": "De gemiddelde score is gewogen op basis van het aantal medewerkers in elke groep.",
    "hri_summary": "HRI-overzicht van de werkruimte",
    "human_risk_intelligence": "Human Risk Intelligence",
    "interventions": "Interventies",
    "interventions_by_type": "Interventies per type",
    "last_six_months": "Afgelopen 6 maanden",
    "loading": "Werkruimterapport laden…",
    "missed": "Gemist",
    "no_employees_at_risk": "Geen medewerkers met risico",
    "no_groups": "Geen groepsgegevens beschikbaar",
    "no_risk_indicators": "Geen risico-indicatoren",
    "operational_metrics": "Operationele statistieken",
    "performance_by_team": "Prestaties per team",
    "resilience_score": "Veerkrachtscore",
    "risk_index": "Risico-index {value}/10 · lager is beter",
    "risk_indicator": "Risico-indicator",
    "risk_level": "Risiconiveau",
    "risk_levels": {
      "high": "Hoog",
      "low": "Laag",
      "moderate": "Gemiddeld"
    },
    "security_behaviour_overview": "Overzicht van beveiligingsgedrag",
    "signals": "Signalen",
    "signals_by_sentiment": "Signalen per sentiment",
    "signals_by_severity": "Signalen per ernst",
    "threshold": "Drempel {value}% · gesorteerd van laag naar hoog",
    "title": "Werkruimterapport",
    "top_five_period": "Top 5 deze periode",
    "total": "{count} totaal",
    "total_employees": "{count} medewerkers in totaal",
    "total_groups": "{count} groepen",
    "total_signals": "{count} signalen",
    "training": "Trainingsstatistieken",
    "training_simulations_risk": "Training, simulaties en risico",
    "trend": "Trend",
    "trend_title": "Veerkracht, klik- en rapportagepercentage",
    "trending_risk_indicators": "Actuele risico-indicatoren",
    "unavailable": "Rapport niet beschikbaar",
    "unavailable_description": "Het rapport kon niet worden geladen. Controleer of de rapport-URL geldig is en niet is verlopen.",
    "workspace_summary": "Overzicht van de werkruimte"
  }
}
